var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 631.47 256.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        mix-blend-mode: hard-light;\n        opacity: .59;\n      }\n\n      .cls-3 {\n        fill: #fe2215;\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.73,
    width: 600.74,
    height: 141.12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.94,
    cy: 111.87,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.27,
    cy: 111.38,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.64,
    cy: 110.84,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.06,
    cy: 110.26,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.52,
    cy: 109.63,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.03,
    cy: 108.96,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.59,
    cy: 108.25,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.21,
    cy: 107.52,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.88,
    cy: 106.75,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.62,
    cy: 105.97,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.42,
    cy: 105.16,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.27,
    cy: 104.35,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.19,
    cy: 103.52,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.18,
    cy: 102.69,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.22,
    cy: 101.86,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.34,
    cy: 101.04,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.51,
    cy: 100.23,
    r: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.58,99.25c.1-.09.26-.08.34.02s.08.26-.02.34-.26.08-.34-.02-.08-.26.02-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.88,98.48c.1-.09.25-.08.34.02s.08.25-.02.34-.25.08-.34-.02-.08-.25.02-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.24,97.74c.1-.09.25-.08.33.02s.08.25-.02.33-.25.08-.33-.02-.08-.25.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.65,97.02c.1-.09.24-.08.33.02s.08.24-.02.33-.24.08-.33-.02-.08-.24.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.12,96.33c.09-.08.24-.08.32.02s.08.24-.02.32-.24.08-.32-.02-.08-.24.02-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.63,95.69c.09-.08.24-.08.32.02s.08.24-.02.32-.24.08-.32-.02-.08-.24.02-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.2,95.08c.09-.08.23-.07.31.02s.07.23-.02.31-.23.07-.31-.02-.07-.23.02-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.81,94.52c.09-.08.23-.07.31.02s.07.23-.02.31-.23.07-.31-.02-.07-.23.02-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.46,94.01c.09-.08.22-.07.3.02s.07.22-.02.3-.22.07-.3-.02-.07-.22.02-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.15,93.55c.09-.08.22-.07.3.02s.07.22-.02.3-.22.07-.3-.02-.07-.22.02-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.87,93.14c.09-.08.22-.07.29.02s.07.22-.02.29-.22.07-.29-.02-.07-.22.02-.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.76,
    cy: 92.94,
    r: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.41,92.5c.08-.07.21-.07.28.02s.07.21-.02.28-.21.07-.28-.02-.07-.21.02-.28Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.33,
    cy: 92.41,
    r: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.02,92.1c.08-.07.2-.06.27.02s.06.2-.02.27-.2.06-.27-.02-.06-.2.02-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.84,91.99c.08-.07.2-.06.27.01s.06.2-.01.27-.2.06-.27-.01-.06-.2.01-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.67,91.94c.08-.07.19-.06.26.01s.06.19-.01.26-.19.06-.26-.01-.06-.19.01-.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.62,
    cy: 92.09,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.45,
    cy: 92.17,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.27,
    cy: 92.32,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.07,
    cy: 92.52,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.85,
    cy: 92.79,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.62,
    cy: 93.11,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.35,
    cy: 93.49,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.06,
    cy: 93.93,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.73,
    cy: 94.42,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.36,
    cy: 94.96,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.94,
    cy: 95.55,
    r: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.39,96.07c.06-.05.15-.05.2.01s.05.15-.01.2-.15.05-.2-.01-.05-.15.01-.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.97,
    cy: 96.84,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.41,
    cy: 97.55,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.79,
    cy: 98.29,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.11,
    cy: 99.05,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.38,
    cy: 99.84,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.58,
    cy: 100.64,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.73,
    cy: 101.46,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.81,
    cy: 102.28,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.82,
    cy: 103.11,
    r: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.71,103.86s.11-.03.14,0,.03.11,0,.14-.11.03-.14,0-.03-.11,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.6,104.69s.1-.03.14,0,.03.1,0,.14-.1.03-.14,0-.03-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.43,105.5s.1-.03.13,0,.03.1,0,.13-.1.03-.13,0-.03-.1,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.2,106.3s.09-.03.13,0,.03.09,0,.13-.09.03-.13,0-.03-.09,0-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.9,107.08s.09-.03.12,0,.03.09,0,.12-.09.03-.12,0-.03-.09,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.55,107.83s.09-.03.12,0,.03.09,0,.12-.09.03-.12,0-.03-.09,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.14,108.55s.08-.03.11,0,.03.08,0,.11-.08.03-.11,0-.03-.08,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.68,109.24s.08-.03.11,0,.03.08,0,.11-.08.03-.11,0-.03-.08,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.17,109.89s.07-.02.1,0,.02.07,0,.1-.07.02-.1,0-.02-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.61,110.51s.07-.02.1,0,.02.07,0,.1-.07.02-.1,0-.02-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180,111.07s.07-.02.09,0,.02.07,0,.09-.07.02-.09,0-.02-.07,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.35,111.59s.06-.02.08,0,.02.06,0,.08-.06.02-.08,0-.02-.06,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.67,112.06s.06-.02.08,0,.02.06,0,.08-.06.02-.08,0-.02-.06,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.95,112.47s.05-.02.07,0,.02.05,0,.07-.05.02-.07,0-.02-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.2,112.83s.05-.02.07,0,.02.05,0,.07-.05.02-.07,0-.02-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.43,113.12s.05-.02.06,0,.02.05,0,.06-.05.02-.06,0-.02-.05,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.64,113.36s.04-.01.06,0,.01.04,0,.06-.04.01-.06,0-.01-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.83,113.54s.04-.01.05,0,.01.04,0,.05-.04.01-.05,0-.01-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.01,113.65s.04-.01.05,0,.01.04,0,.05-.04.01-.05,0-.01-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.2,
    cy: 113.72,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.36,113.69s.03,0,.04,0,0,.03,0,.04-.03,0-.04,0,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.55,
    cy: 113.63,
    r: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.72,113.47s.02,0,.03,0,0,.02,0,.03-.02,0-.03,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.92,113.27s.02,0,.02,0,0,.02,0,.02-.02,0-.02,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.14,
    cy: 113.02,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.38,
    cy: 112.69,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.65,
    cy: 112.31,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.18,
    cy: 114.15,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.33,
    cy: 113.9,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.49,
    cy: 113.59,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.68,
    cy: 113.21,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.91,
    cy: 112.78,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.16,
    cy: 112.28,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.46,
    cy: 111.73,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.81,
    cy: 111.13,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.2,
    cy: 110.47,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.64,
    cy: 109.78,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.14,
    cy: 109.04,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.7,
    cy: 108.27,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.31,
    cy: 107.46,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.99,
    cy: 106.63,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.73,
    cy: 105.78,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.54,
    cy: 104.91,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.42,
    cy: 104.02,
    r: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.13,103.01c.07-.13.23-.18.36-.11s.18.23.11.36-.23.18-.36.11-.18-.23-.11-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.15,102.12c.07-.13.22-.17.35-.11s.17.22.11.35-.22.17-.35.11-.17-.22-.11-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.24,101.23c.07-.12.22-.17.34-.1s.17.22.1.34-.22.17-.34.1-.17-.22-.1-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.39,100.36c.07-.12.22-.17.34-.1s.17.22.1.34-.22.17-.34.1-.17-.22-.1-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.61,99.49c.06-.12.21-.17.33-.1s.17.21.1.33-.21.17-.33.1-.17-.21-.1-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.9,98.65c.06-.12.21-.16.33-.1s.16.21.1.33-.21.16-.33.1-.16-.21-.1-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.24,97.83c.06-.12.21-.16.32-.1s.16.21.1.32-.21.16-.32.1-.16-.21-.1-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.66,97.04c.06-.11.2-.16.32-.1s.16.2.1.32-.2.16-.32.1-.16-.2-.1-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.13,96.28c.06-.11.2-.15.31-.09s.15.2.09.31-.2.15-.31.09-.15-.2-.09-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.65,95.56c.06-.11.2-.15.31-.09s.15.2.09.31-.2.15-.31.09-.15-.2-.09-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.23,94.88c.06-.11.19-.15.3-.09s.15.19.09.3-.19.15-.3.09-.15-.19-.09-.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.06,
    cy: 94.35,
    r: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.55,93.67c.06-.1.19-.14.29-.09s.14.19.09.29-.19.14-.29.09-.14-.19-.09-.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.45,
    cy: 93.24,
    r: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.03,92.67c.05-.1.18-.14.28-.08s.14.18.08.28-.18.14-.28.08-.14-.18-.08-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.82,92.26c.05-.1.18-.14.27-.08s.14.18.08.27-.18.14-.27.08-.14-.18-.08-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.64,91.91c.05-.1.17-.13.27-.08s.13.17.08.27-.17.13-.27.08-.13-.17-.08-.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.66,
    cy: 91.71,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.52,
    cy: 91.49,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.4,
    cy: 91.33,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.29,
    cy: 91.24,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.18,
    cy: 91.22,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.07,
    cy: 91.27,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.95,
    cy: 91.39,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.82,
    cy: 91.57,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.68,
    cy: 91.82,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.52,
    cy: 92.13,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.32,
    cy: 92.51,
    r: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.97,92.88c.04-.07.13-.1.2-.06s.1.13.06.2-.13.1-.2.06-.1-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.84,
    cy: 93.44,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.54,
    cy: 93.99,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.2,
    cy: 94.6,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.81,
    cy: 95.25,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.36,
    cy: 95.95,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.87,
    cy: 96.68,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.31,
    cy: 97.46,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.69,
    cy: 98.26,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.01,
    cy: 99.09,
    r: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.18,99.89c.03-.05.09-.07.15-.04s.07.09.04.15-.09.07-.15.04-.07-.09-.04-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.37,100.77c.03-.05.09-.07.14-.04s.07.09.04.14-.09.07-.14.04-.07-.09-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.5,101.65s.09-.07.14-.04.07.09.04.14-.09.07-.14.04-.07-.09-.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.55,102.54s.08-.06.13-.04.06.08.04.13-.08.06-.13.04-.06-.08-.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.54,103.44s.08-.06.13-.04.06.08.04.13-.08.06-.13.04-.06-.08-.04-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.46,104.33s.08-.06.12-.04.06.08.04.12-.08.06-.12.04-.06-.08-.04-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.32,105.21s.07-.06.11-.03.06.07.03.11-.07.06-.11.03-.06-.07-.03-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.11,106.08s.07-.05.11-.03.05.07.03.11-.07.05-.11.03-.05-.07-.03-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.83,106.92s.07-.05.1-.03.05.07.03.1-.07.05-.1.03-.05-.07-.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.49,107.75s.06-.05.1-.03.05.06.03.1-.06.05-.1.03-.05-.06-.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.08,108.54s.06-.05.09-.03.05.06.03.09-.06.05-.09.03-.05-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.62,109.3s.06-.04.09-.03.04.06.03.09-.06.04-.09.03-.04-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.1,110.03s.05-.04.08-.02.04.05.02.08-.05.04-.08.02-.04-.05-.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.52,110.71s.05-.04.08-.02.04.05.02.08-.05.04-.08.02-.04-.05-.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.9,111.34s.05-.04.07-.02.04.05.02.07-.05.04-.07.02-.04-.05-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.23,111.93s.04-.03.07-.02.03.04.02.07-.04.03-.07.02-.03-.04-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.51,112.46s.04-.03.06-.02.03.04.02.06-.04.03-.06.02-.03-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.76,112.93s.04-.03.05-.02.03.04.02.05-.04.03-.05.02-.03-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.98,113.35s.03-.02.05-.01.02.03.01.05-.03.02-.05.01-.02-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.19,
    cy: 113.72,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.32,114s.02-.02.04-.01.02.02.01.04-.02.02-.04.01-.02-.02-.01-.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.48,
    cy: 114.23,
    r: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.59,114.38s.02-.01.03,0,.01.02,0,.03-.02.01-.03,0-.01-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.7,114.47s.01-.01.02,0,.01.01,0,.02-.01.01-.02,0-.01-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.83,
    cy: 114.5,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.94,
    cy: 114.45,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.05,
    cy: 114.33,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.29,
    cy: 115.26,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.34,
    cy: 115.33,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.38,
    cy: 115.32,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.42,
    cy: 115.24,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.48,
    cy: 115.08,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.55,
    cy: 114.85,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.64,
    cy: 114.55,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.75,
    cy: 114.18,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.9,
    cy: 113.75,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.08,
    cy: 113.25,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.3,
    cy: 112.69,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.57,
    cy: 112.07,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.88,
    cy: 111.4,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.25,
    cy: 110.68,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.68,
    cy: 109.91,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.17,
    cy: 109.1,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.72,
    cy: 108.25,
    r: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.05,107.33c.02-.15.17-.26.32-.24s.26.17.24.32-.17.26-.32.24-.26-.17-.24-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.74,106.43c.02-.15.16-.26.31-.24s.26.16.24.31-.16.26-.31.24-.26-.16-.24-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.51,105.5c.02-.15.16-.25.31-.23s.25.16.23.31-.16.25-.31.23-.25-.16-.23-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.34,104.56c.02-.15.16-.25.31-.23s.25.16.23.31-.16.25-.31.23-.25-.16-.23-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.24,103.61c.02-.14.16-.25.3-.22s.25.16.22.3-.16.25-.3.22-.25-.16-.22-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.22,102.65c.02-.14.15-.24.3-.22s.24.15.22.3-.15.24-.3.22-.24-.15-.22-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.27,101.69c.02-.14.15-.24.29-.22s.24.15.22.29-.15.24-.29.22-.24-.15-.22-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.39,100.74c.02-.14.15-.23.29-.21s.23.15.21.29-.15.23-.29.21-.23-.15-.21-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.59,99.8c.02-.14.15-.23.28-.21s.23.15.21.28-.15.23-.28.21-.23-.15-.21-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.86,98.88c.02-.13.14-.23.28-.21s.23.14.21.28-.14.23-.28.21-.23-.14-.21-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.2,97.98c.02-.13.14-.22.27-.2s.22.14.2.27-.14.22-.27.2-.22-.14-.2-.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.84,
    cy: 97.15,
    r: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.08,96.28c.02-.13.13-.21.26-.2s.21.13.2.26-.13.21-.26.2-.21-.13-.2-.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.83,
    cy: 95.51,
    r: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.21,94.72c.02-.12.13-.21.25-.19s.21.13.19.25-.13.21-.25.19-.21-.13-.19-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.85,94.01c.02-.12.13-.2.25-.18s.2.13.18.25-.13.2-.25.18-.2-.13-.18-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.56,93.36c.02-.12.12-.2.24-.18s.2.12.18.24-.12.2-.24.18-.2-.12-.18-.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.51,
    cy: 92.78,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.3,
    cy: 92.24,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.13,
    cy: 91.76,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168,
    cy: 91.34,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.89,
    cy: 91,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.81,
    cy: 90.72,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.74,
    cy: 90.51,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.69,
    cy: 90.37,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.65,
    cy: 90.31,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.61,
    cy: 90.32,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.56,
    cy: 90.4,
    r: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.35,90.54c.01-.09.09-.15.18-.14s.15.09.14.18-.09.15-.18.14-.15-.09-.14-.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.44,
    cy: 90.79,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.35,
    cy: 91.09,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.23,
    cy: 91.46,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.09,
    cy: 91.89,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.91,
    cy: 92.39,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.68,
    cy: 92.95,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.42,
    cy: 93.57,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.1,
    cy: 94.24,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.73,
    cy: 94.96,
    r: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.19,95.71c0-.06.07-.11.13-.1s.11.07.1.13-.07.11-.13.1-.11-.07-.1-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.71,96.52c0-.06.07-.1.13-.1s.1.07.1.13-.07.1-.13.1-.1-.07-.1-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.16,97.37c0-.06.06-.1.12-.09s.1.06.09.12-.06.1-.12.09-.1-.06-.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.55,98.25c0-.06.06-.1.12-.09s.1.06.09.12-.06.1-.12.09-.1-.06-.09-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.87,99.16c0-.05.06-.09.11-.08s.09.06.08.11-.06.09-.11.08-.09-.06-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.11,100.09c0-.05.06-.09.11-.08s.09.06.08.11-.06.09-.11.08-.09-.06-.08-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.29,101.03s.05-.08.1-.08.08.05.08.1-.05.08-.1.08-.08-.05-.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.39,101.98s.05-.08.1-.07.08.05.07.1-.05.08-.1.07-.08-.05-.07-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.42,102.94s.05-.08.09-.07.08.05.07.09-.05.08-.09.07-.08-.05-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.38,103.9s.05-.07.09-.07.07.05.07.09-.05.07-.09.07-.07-.05-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.27,104.85s.04-.07.08-.06.07.04.06.08-.04.07-.08.06-.07-.04-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.08,105.79s.04-.06.08-.06.06.04.06.08-.04.06-.08.06-.06-.04-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.82,106.72s.04-.06.07-.06.06.04.06.07-.04.06-.07.06-.06-.04-.06-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.49,107.61s.04-.06.07-.05.06.04.05.07-.04.06-.07.05-.06-.04-.05-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.09,108.49s.03-.05.06-.05.05.03.05.06-.03.05-.06.05-.05-.03-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.63,109.32s.03-.05.06-.04.05.03.04.06-.03.05-.06.04-.05-.03-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.1,110.12s.03-.04.05-.04.04.03.04.05-.03.04-.05.04-.04-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.52,110.88s.03-.04.05-.04.04.03.04.05-.03.04-.05.04-.04-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.87,111.59s.02-.04.04-.03.04.02.03.04-.02.04-.04.03-.04-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.22,
    cy: 112.25,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.44,112.85s.02-.03.03-.03.03.02.03.03-.02.03-.03.03-.03-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.68,
    cy: 113.4,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.83,113.88s.01-.02.02-.02.02.01.02.02-.01.02-.02.02-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.97,114.29s.01-.02.02-.01.02.01.01.02-.01.02-.02.01-.02-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.09,
    cy: 114.64,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.18,
    cy: 114.92,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.24,
    cy: 115.13,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.86,
    cy: 114.88,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.91,
    cy: 115.29,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.94,
    cy: 115.64,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.95,
    cy: 115.9,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.93,
    cy: 116.1,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.91,
    cy: 116.21,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.88,
    cy: 116.24,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.85,
    cy: 116.19,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.83,
    cy: 116.07,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.81,
    cy: 115.86,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.82,
    cy: 115.58,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.85,
    cy: 115.23,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.92,
    cy: 114.8,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.01,
    cy: 114.3,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.15,
    cy: 113.74,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.34,
    cy: 113.11,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.57,
    cy: 112.42,
    r: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.56,111.73c-.03-.16.07-.33.24-.36s.33.07.36.24-.07.33-.24.36-.33-.07-.36-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.92,110.93c-.03-.16.07-.32.23-.35s.32.07.35.23-.07.32-.23.35-.32-.07-.35-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.34,110.08c-.03-.16.07-.32.23-.35s.32.07.35.23-.07.32-.23.35-.32-.07-.35-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.82,109.19c-.03-.16.07-.31.22-.34s.31.07.34.22-.07.31-.22.34-.31-.07-.34-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.37,108.26c-.03-.15.07-.31.22-.34s.31.07.34.22-.07.31-.22.34-.31-.07-.34-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160,107.3c-.03-.15.07-.3.22-.33s.3.07.33.22-.07.3-.22.33-.3-.07-.33-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.7,106.32c-.03-.15.06-.3.21-.33s.3.06.33.21-.06.3-.21.33-.3-.06-.33-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.47,105.31c-.03-.15.06-.29.21-.32s.29.06.32.21-.06.29-.21.32-.29-.06-.32-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.32,104.29c-.03-.14.06-.29.21-.32s.29.06.32.21-.06.29-.21.32-.29-.06-.32-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.26,103.26c-.03-.14.06-.28.2-.31s.28.06.31.2-.06.28-.2.31-.28-.06-.31-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.27,102.23c-.03-.14.06-.28.2-.3s.28.06.3.2-.06.28-.2.3-.28-.06-.3-.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.61,
    cy: 101.15,
    r: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.53,100.18c-.03-.13.06-.27.19-.29s.27.06.29.19-.06.27-.19.29-.27-.06-.29-.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.01,
    cy: 99.13,
    r: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.1,98.2c-.03-.13.06-.26.18-.28s.26.06.28.18-.06.26-.18.28-.26-.06-.28-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.49,97.24c-.03-.13.05-.25.18-.28s.25.05.28.18-.05.25-.18.28-.25-.05-.28-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.96,96.32c-.03-.12.05-.25.18-.27s.25.05.27.18-.05.25-.18.27-.25-.05-.27-.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.72,
    cy: 95.39,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.32,
    cy: 94.55,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.98,
    cy: 93.76,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.7,
    cy: 93.02,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.47,
    cy: 92.34,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.3,
    cy: 91.72,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.16,
    cy: 91.17,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.07,
    cy: 90.68,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.02,
    cy: 90.27,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.99,
    cy: 89.93,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.98,
    cy: 89.66,
    r: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.83,89.5c-.02-.09.04-.19.13-.2s.19.04.2.13-.04.19-.13.2-.19-.04-.2-.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.02,
    cy: 89.36,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.05,
    cy: 89.32,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.08,
    cy: 89.37,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.11,
    cy: 89.5,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.12,
    cy: 89.7,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.11,
    cy: 89.98,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.08,
    cy: 90.34,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.02,
    cy: 90.76,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.92,
    cy: 91.26,
    r: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.66,91.85c-.01-.07.03-.14.1-.15s.14.03.15.1-.03.14-.1.15-.14-.03-.15-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.48,92.48c-.01-.07.03-.13.09-.14s.13.03.14.09-.03.13-.09.14-.13-.03-.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.25,93.17c-.01-.06.03-.13.09-.14s.13.03.14.09-.03.13-.09.14-.13-.03-.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.96,93.92c-.01-.06.03-.12.09-.13s.12.03.13.09-.03.12-.09.13-.12-.03-.13-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.62,94.72c-.01-.06.03-.12.08-.13s.12.03.13.08-.03.12-.08.13-.12-.03-.13-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.21,95.56c-.01-.06.02-.11.08-.12s.11.02.12.08-.02.11-.08.12-.11-.02-.12-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.73,96.45c-.01-.05.02-.11.08-.12s.11.02.12.08-.02.11-.08.12-.11-.02-.12-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.19,97.38c-.01-.05.02-.1.07-.11s.1.02.11.07-.02.1-.07.11-.1-.02-.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.57,98.33s.02-.1.07-.11.1.02.11.07-.02.1-.07.11-.1-.02-.11-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.88,99.32s.02-.09.07-.1.09.02.1.07-.02.09-.07.1-.09-.02-.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.12,100.32s.02-.09.06-.09.09.02.09.06-.02.09-.06.09-.09-.02-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.27,101.34s.02-.08.06-.09.08.02.09.06-.02.08-.06.09-.08-.02-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.35,102.37s.02-.08.05-.08.08.02.08.05-.02.08-.05.08-.08-.02-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.35,103.4s.02-.07.05-.08.07.02.08.05-.02.07-.05.08-.07-.02-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.26,104.43s.01-.07.05-.07.07.01.07.05-.01.07-.05.07-.07-.01-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.1,105.44s.01-.06.04-.07.06.01.07.04-.01.06-.04.07-.06-.01-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.87,106.44s.01-.06.04-.06.06.01.06.04-.01.06-.04.06-.06-.01-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.55,107.42s.01-.05.04-.06.05.01.06.04-.01.05-.04.06-.05-.01-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.17,108.38s0-.05.03-.05.05,0,.05.03,0,.05-.03.05-.05,0-.05-.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.74,
    cy: 109.29,
    r: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.18,110.18s0-.04.03-.04.04,0,.04.03,0,.04-.03.04-.04,0-.04-.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.61,
    cy: 111.01,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.93,111.81s0-.03.02-.03.03,0,.03.02,0,.03-.02.03-.03,0-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.21,112.54s0-.02.01-.02.02,0,.02.01,0,.02-.01.02-.02,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.46,
    cy: 113.22,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.63,
    cy: 113.84,
    r: 0
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.76,
    cy: 114.39,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.33,
    cy: 112.81,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.53,
    cy: 113.58,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.67,
    cy: 114.28,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.76,
    cy: 114.92,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.81,
    cy: 115.48,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.81,
    cy: 115.97,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.79,
    cy: 116.38,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.73,
    cy: 116.71,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.65,
    cy: 116.96,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.55,
    cy: 117.13,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.45,
    cy: 117.21,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.34,
    cy: 117.21,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.23,
    cy: 117.12,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.14,
    cy: 116.95,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.06,
    cy: 116.7,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168,
    cy: 116.36,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.97,
    cy: 115.95,
    r: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.71,115.62c-.1-.15-.05-.35.11-.45s.35-.05.45.11.05.35-.11.45-.35.05-.45-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.76,115.05c-.09-.15-.05-.35.1-.44s.35-.05.44.1.05.35-.1.44-.35.05-.44-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.86,114.41c-.09-.15-.05-.34.1-.44s.34-.05.44.1.05.34-.1.44-.34.05-.44-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.01,113.7c-.09-.15-.05-.34.1-.43s.34-.05.43.1.05.34-.1.43-.34.05-.43-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.22,112.92c-.09-.14-.04-.33.1-.42s.33-.04.42.1.04.33-.1.42-.33.04-.42-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.48,112.09c-.09-.14-.04-.33.1-.42s.33-.04.42.1.04.33-.1.42-.33.04-.42-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.82,111.21c-.09-.14-.04-.32.1-.41s.32-.04.41.1.04.32-.1.41-.32.04-.41-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.22,110.27c-.08-.14-.04-.32.09-.4s.32-.04.4.09.04.32-.09.4-.32.04-.4-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.7,109.3c-.08-.13-.04-.31.09-.39s.31-.04.39.09.04.31-.09.39-.31.04-.39-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.25,108.28c-.08-.13-.04-.31.09-.39s.31-.04.39.09.04.31-.09.39-.31.04-.39-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.88,107.23c-.08-.13-.04-.3.09-.38s.3-.04.38.09.04.3-.09.38-.3.04-.38-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.83,
    cy: 106.02,
    r: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.39,105.07c-.08-.12-.04-.29.09-.37s.29-.04.37.09.04.29-.09.37-.29.04-.37-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.5,
    cy: 103.83,
    r: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.24,102.86c-.07-.12-.04-.28.08-.35s.28-.04.35.08.04.28-.08.35-.28.04-.35-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.29,101.74c-.07-.12-.04-.27.08-.35s.27-.04.35.08.04.27-.08.35-.27.04-.35-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.42,100.64c-.07-.12-.04-.27.08-.34s.27-.04.34.08.04.27-.08.34-.27.04-.34-.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.84,
    cy: 99.42,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.14,
    cy: 98.36,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.51,
    cy: 97.31,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.97,
    cy: 96.3,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.5,
    cy: 95.33,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.11,
    cy: 94.4,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.78,
    cy: 93.52,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.52,
    cy: 92.7,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.32,
    cy: 91.93,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.18,
    cy: 91.22,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.09,
    cy: 90.59,
    r: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.88,90.12c-.05-.09-.03-.2.06-.26s.2-.03.26.06.03.2-.06.26-.2.03-.26-.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.03,
    cy: 89.53,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.06,
    cy: 89.12,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.12,
    cy: 88.79,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.2,
    cy: 88.54,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.3,
    cy: 88.38,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.4,
    cy: 88.29,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.51,
    cy: 88.3,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.62,
    cy: 88.38,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.71,
    cy: 88.55,
    r: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.68,88.88c-.04-.06-.02-.15.04-.19s.15-.02.19.04.02.15-.04.19-.15.02-.19-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.74,89.21c-.04-.06-.02-.14.04-.18s.14-.02.18.04.02.14-.04.18-.14.02-.18-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.77,89.63c-.04-.06-.02-.14.04-.17s.14-.02.17.04.02.14-.04.17-.14.02-.17-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.76,90.12c-.04-.06-.02-.13.04-.17s.13-.02.17.04.02.13-.04.17-.13.02-.17-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.72,90.69c-.03-.05-.02-.13.04-.16s.13-.02.16.04.02.13-.04.16-.13.02-.16-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.63,91.32c-.03-.05-.02-.12.04-.15s.12-.02.15.04.02.12-.04.15-.12.02-.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.49,92.03s-.02-.11.03-.15.11-.02.15.03.02.11-.03.15-.11.02-.15-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.29,92.8s-.01-.11.03-.14.11-.01.14.03.01.11-.03.14-.11.01-.14-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.03,93.62s-.01-.1.03-.13.1-.01.13.03.01.1-.03.13-.1.01-.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.7,94.5s-.01-.1.03-.12.1-.01.12.03.01.1-.03.12-.1.01-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.31,95.43s-.01-.09.03-.12.09-.01.12.03.01.09-.03.12-.09.01-.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.84,96.4s-.01-.09.03-.11.09-.01.11.03.01.09-.03.11-.09.01-.11-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.29,97.41s-.01-.08.02-.1.08-.01.1.02.01.08-.02.1-.08.01-.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.67,98.46s-.01-.08.02-.1.08-.01.1.02.01.08-.02.1-.08.01-.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.97,99.52s0-.07.02-.09.07,0,.09.02,0,.07-.02.09-.07,0-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.18,100.61s0-.07.02-.08.07,0,.08.02,0,.07-.02.08-.07,0-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.31,101.71s0-.06.02-.08.06,0,.08.02,0,.06-.02.08-.06,0-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.35,102.81s0-.05.02-.07.05,0,.07.02,0,.05-.02.07-.05,0-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.31,103.92s0-.05.01-.06.05,0,.06.01,0,.05-.01.06-.05,0-.06-.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.22,
    cy: 105,
    r: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.98,106.1s0-.04.01-.05.04,0,.05.01,0,.04-.01.05-.04,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.71,
    cy: 107.15,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.31,108.21s0-.03,0-.03.03,0,.03,0,0,.03,0,.03-.03,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.86,109.22s0-.02,0-.03.02,0,.03,0,0,.02,0,.03-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.35,
    cy: 110.18,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.74,
    cy: 111.11,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.06,
    cy: 111.98,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.08,
    cy: 109.07,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.55,
    cy: 110.14,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.95,
    cy: 111.17,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.27,
    cy: 112.15,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.51,
    cy: 113.07,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.69,
    cy: 113.93,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.8,
    cy: 114.72,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.85,
    cy: 115.45,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.85,
    cy: 116.1,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.8,
    cy: 116.67,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.72,
    cy: 117.16,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.6,
    cy: 117.56,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.45,
    cy: 117.88,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.28,
    cy: 118.11,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.09,
    cy: 118.25,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.9,
    cy: 118.3,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.71,
    cy: 118.26,
    r: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.31,118.4c-.15-.12-.18-.34-.06-.49s.34-.18.49-.06c.15.12.18.34.06.49s-.34.18-.49.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.14,118.17c-.15-.12-.18-.34-.06-.49s.34-.18.49-.06.18.34.06.49-.34.18-.49.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168,117.85c-.15-.12-.17-.33-.06-.48s.33-.17.48-.06.17.33.06.48-.33.17-.48.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.88,117.44c-.15-.11-.17-.32-.06-.47s.32-.17.47-.06.17.32.06.47-.32.17-.47.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.79,116.95c-.14-.11-.17-.32-.06-.46s.32-.17.46-.06.17.32.06.46-.32.17-.46.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.75,116.38c-.14-.11-.16-.31-.05-.46s.31-.16.46-.05.16.31.05.46-.31.16-.46.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.75,115.73c-.14-.11-.16-.31-.05-.45s.31-.16.45-.05.16.31.05.45-.31.16-.45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.8,115.01c-.14-.11-.16-.3-.05-.44s.3-.16.44-.05.16.3.05.44-.3.16-.44.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.91,114.21c-.13-.11-.16-.3-.05-.43s.3-.16.43-.05.16.3.05.43-.3.16-.43.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.09,113.35c-.13-.1-.15-.29-.05-.42s.29-.15.42-.05.15.29.05.42-.29.15-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.33,112.43c-.13-.1-.15-.29-.05-.42s.29-.15.42-.05.15.29.05.42-.29.15-.42.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.83,
    cy: 111.22,
    r: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.04,110.42c-.12-.1-.15-.28-.05-.4s.28-.15.4-.05.15.28.05.4-.28.15-.4.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.69,
    cy: 109.13,
    r: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.07,108.24c-.12-.09-.14-.27-.05-.39s.27-.14.39-.05.14.27.05.39-.27.14-.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.71,107.1c-.12-.09-.14-.26-.05-.38s.26-.14.38-.05.14.26.05.38-.26.14-.38.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.44,105.94c-.11-.09-.13-.26-.04-.37s.26-.13.37-.04.13.26.04.37-.26.13-.37.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.42,
    cy: 104.55,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.32,
    cy: 103.37,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.32,
    cy: 102.17,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.41,
    cy: 100.99,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.59,
    cy: 99.81,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.86,
    cy: 98.65,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.22,
    cy: 97.51,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.66,
    cy: 96.4,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.19,
    cy: 95.33,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.8,
    cy: 94.31,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.48,
    cy: 93.33,
    r: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.11,92.57c-.09-.07-.1-.19-.03-.28s.19-.1.28-.03.1.19.03.28-.19.1-.28.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.06,
    cy: 91.55,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.95,
    cy: 90.75,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.9,
    cy: 90.03,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.9,
    cy: 89.38,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.94,
    cy: 88.81,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.03,
    cy: 88.32,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.15,
    cy: 87.92,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.3,
    cy: 87.6,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.47,
    cy: 87.37,
    r: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.56,87.34c-.06-.05-.07-.14-.02-.2s.14-.07.2-.02.07.14.02.2-.14.07-.2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.76,87.29c-.06-.05-.07-.14-.02-.2s.14-.07.2-.02.07.14.02.2-.14.07-.2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.95,87.33c-.06-.05-.07-.13-.02-.19s.13-.07.19-.02.07.13.02.19-.13.07-.19.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.14,87.46c-.06-.04-.07-.13-.02-.18s.13-.07.18-.02.07.13.02.18-.13.07-.18.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.31,87.68c-.05-.04-.06-.12-.02-.17s.12-.06.17-.02.06.12.02.17-.12.06-.17.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.46,87.99c-.05-.04-.06-.12-.02-.17s.12-.06.17-.02.06.12.02.17-.12.06-.17.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.59,88.39s-.06-.11-.02-.16.11-.06.16-.02.06.11.02.16-.11.06-.16.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.68,88.87s-.05-.1-.02-.15.1-.05.15-.02.05.1.02.15-.1.05-.15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.73,89.43s-.05-.1-.02-.14.1-.05.14-.02.05.1.02.14-.1.05-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.74,90.07s-.05-.09-.02-.14.09-.05.14-.02.05.09.02.14-.09.05-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.69,90.79s-.05-.09-.02-.13.09-.05.13-.02.05.09.02.13-.09.05-.13.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.59,91.57s-.04-.08-.01-.12.08-.04.12-.01.04.08.01.12-.08.04-.12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.42,92.43s-.04-.08-.01-.11.08-.04.11-.01.04.08.01.11-.08.04-.11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.18,93.34s-.04-.07-.01-.11.07-.04.11-.01.04.07.01.11-.07.04-.11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.87,94.31s-.04-.07-.01-.1.07-.04.1-.01.04.07.01.1-.07.04-.1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.49,95.33s-.03-.06-.01-.09.06-.03.09-.01.03.06.01.09-.06.03-.09.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.02,96.39s-.03-.06,0-.08.06-.03.08,0,.03.06,0,.08-.06.03-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.47,97.5s-.03-.05,0-.08.05-.03.08,0,.03.05,0,.08-.05.03-.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.84,98.63s-.02-.05,0-.07.05-.02.07,0,.02.05,0,.07-.05.02-.07,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.14,
    cy: 99.75,
    r: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.3,100.96s-.02-.04,0-.05.04-.02.05,0,.02.04,0,.05-.04.02-.05,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.42,
    cy: 102.11,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.41,103.33s-.01-.03,0-.04.03-.01.04,0,.01.03,0,.04-.03.01-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.32,104.51s-.01-.02,0-.03.02-.01.03,0,.01.02,0,.03-.02.01-.03,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.15,
    cy: 105.67,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.88,
    cy: 106.83,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.52,
    cy: 107.97,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.5,
    cy: 103.92,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.36,
    cy: 105.19,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.13,
    cy: 106.45,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.8,
    cy: 107.69,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.37,
    cy: 108.9,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.86,
    cy: 110.07,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.25,
    cy: 111.2,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.56,
    cy: 112.28,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.79,
    cy: 113.31,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.94,
    cy: 114.27,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.02,
    cy: 115.16,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.04,
    cy: 115.98,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182,
    cy: 116.73,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.9,
    cy: 117.39,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.75,
    cy: 117.97,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.57,
    cy: 118.46,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.35,
    cy: 118.85,
    r: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.99,119.51c-.2-.07-.31-.28-.24-.48s.28-.31.48-.24.31.28.24.48-.28.31-.48.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.72,119.71c-.2-.06-.3-.27-.24-.47s.27-.3.47-.24.3.27.24.47-.27.3-.47.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.45,119.8c-.19-.06-.3-.27-.23-.46s.27-.3.46-.23.3.27.23.46-.27.3-.46.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.17,119.81c-.19-.06-.29-.27-.23-.45s.27-.29.45-.23.29.27.23.45-.27.29-.45.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.89,119.71c-.19-.06-.29-.26-.23-.45s.26-.29.45-.23.29.26.23.45-.26.29-.45.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.62,119.52c-.18-.06-.28-.26-.22-.44s.26-.28.44-.22.28.26.22.44-.26.28-.44.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.38,119.23c-.18-.06-.28-.25-.22-.43s.25-.28.43-.22.28.25.22.43-.25.28-.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.15,118.85c-.18-.06-.27-.25-.21-.43s.25-.27.43-.21.27.25.21.43-.25.27-.43.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.96,118.37c-.17-.06-.27-.24-.21-.42s.24-.27.42-.21.27.24.21.42-.24.27-.42.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.81,117.8c-.17-.06-.26-.24-.21-.41s.24-.26.41-.21.26.24.21.41-.24.26-.41.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.71,117.15c-.17-.06-.26-.24-.2-.4s.24-.26.4-.2.26.24.2.4-.24.26-.4.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.76,
    cy: 116.11,
    r: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.67,115.6c-.16-.05-.25-.23-.2-.39s.23-.25.39-.2.25.23.2.39-.23.25-.39.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.84,
    cy: 114.42,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.88,113.75c-.16-.05-.24-.22-.19-.37s.22-.24.37-.19.24.22.19.37-.22.24-.37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.1,112.73c-.15-.05-.24-.21-.19-.37s.21-.24.37-.19.24.21.19.37-.21.24-.37.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.4,111.65c-.15-.05-.23-.21-.18-.36s.21-.23.36-.18.23.21.18.36-.21.23-.36.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.87,
    cy: 110.26,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.34,
    cy: 109.1,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.89,
    cy: 107.89,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.55,
    cy: 106.66,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.3,
    cy: 105.4,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.14,
    cy: 104.13,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.09,
    cy: 102.85,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.13,
    cy: 101.57,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.27,
    cy: 100.29,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.5,
    cy: 99.03,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.83,
    cy: 97.8,
    r: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.19,96.79c-.11-.04-.17-.16-.14-.27s.16-.17.27-.14.17.16.14.27-.16.17-.27.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.77,
    cy: 95.41,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.38,
    cy: 94.28,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.07,
    cy: 93.2,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.84,
    cy: 92.18,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.69,
    cy: 91.22,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.61,
    cy: 90.33,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.59,
    cy: 89.5,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.64,
    cy: 88.76,
    r: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.73,
    cy: 88.1,
    r: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.83,87.67c-.08-.03-.13-.12-.1-.2s.12-.13.2-.1.13.12.1.2-.12.13-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.02,87.18c-.08-.03-.12-.11-.1-.19s.11-.12.19-.1.12.11.1.19-.11.12-.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.24,86.78c-.08-.03-.12-.11-.09-.18s.11-.12.18-.09.12.11.09.18-.11.12-.18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.48,86.47c-.07-.02-.11-.1-.09-.18s.1-.11.18-.09.11.1.09.18-.1.11-.18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.75,86.26c-.07-.02-.11-.1-.09-.17s.1-.11.17-.09.11.1.09.17-.1.11-.17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.03,86.15c-.07-.02-.1-.09-.08-.16s.09-.1.16-.08.1.09.08.16-.09.1-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.31,86.14c-.06-.02-.1-.09-.08-.15s.09-.1.15-.08.1.09.08.15-.09.1-.15.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.59,86.23c-.06-.02-.09-.09-.07-.15s.09-.09.15-.07.09.09.07.15-.09.09-.15.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.86,86.41c-.06-.02-.09-.08-.07-.14s.08-.09.14-.07.09.08.07.14-.08.09-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.12,86.68c-.05-.02-.08-.08-.07-.13s.08-.08.13-.07.08.08.07.13-.08.08-.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.34,87.06c-.05-.02-.08-.07-.06-.12s.07-.08.12-.06.08.07.06.12-.07.08-.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.54,87.52s-.08-.07-.06-.12.07-.08.12-.06.08.07.06.12-.07.08-.12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.69,88.08s-.07-.06-.06-.11.06-.07.11-.06.07.06.06.11-.06.07-.11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.8,88.72s-.07-.06-.05-.1.06-.07.1-.05.07.06.05.1-.06.07-.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.85,89.45s-.06-.06-.05-.1.06-.06.1-.05.06.06.05.1-.06.06-.1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.85,90.25s-.06-.05-.04-.09.05-.06.09-.04.06.05.04.09-.05.06-.09.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.78,91.13s-.05-.05-.04-.08.05-.05.08-.04.05.05.04.08-.05.05-.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.64,92.08s-.05-.04-.04-.07.04-.05.07-.04.05.04.04.07-.04.05-.07.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.42,93.09s-.04-.04-.03-.07.04-.04.07-.03.04.04.03.07-.04.04-.07.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.14,
    cy: 94.11,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.75,95.27s-.03-.03-.03-.05.03-.03.05-.03.03.03.03.05-.03.03-.05.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.29,
    cy: 96.39,
    r: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.73,97.63s-.02-.02-.02-.04.02-.02.04-.02.02.02.02.04-.02.02-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.08,98.85s-.02-.02-.01-.03.02-.02.03-.01.02.02.01.03-.02.02-.03.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.33,
    cy: 100.09,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.49,
    cy: 101.36,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.54,
    cy: 102.64,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.05,
    cy: 97.82,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.38,
    cy: 99.16,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.61,
    cy: 100.52,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.73,
    cy: 101.89,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.74,
    cy: 103.27,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.65,
    cy: 104.64,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.46,
    cy: 106.01,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.15,
    cy: 107.35,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.75,
    cy: 108.67,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.25,
    cy: 109.95,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.65,
    cy: 111.2,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.96,
    cy: 112.39,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.18,
    cy: 113.52,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.31,
    cy: 114.6,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.37,
    cy: 115.6,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.35,
    cy: 116.53,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.26,
    cy: 117.38,
    r: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.13,118.54c-.22,0-.41-.17-.42-.39s.17-.41.39-.42.41.17.42.39-.17.41-.39.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.92,119.21c-.22,0-.41-.17-.41-.39s.17-.41.39-.41.41.17.41.39-.17.41-.39.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.67,119.78c-.22,0-.4-.16-.41-.38s.16-.4.38-.41.4.16.41.38-.16.4-.38.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.38,120.25c-.21,0-.39-.16-.4-.37s.16-.39.37-.4.39.16.4.37-.16.39-.37.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.05,120.62c-.21,0-.39-.16-.39-.37s.16-.39.37-.39.39.16.39.37-.16.39-.37.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.7,120.89c-.21,0-.38-.16-.39-.36s.16-.38.36-.39.38.16.39.36-.16.38-.36.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.34,121.06c-.2,0-.37-.15-.38-.36s.15-.37.36-.38.37.15.38.36-.15.37-.36.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.96,121.12c-.2,0-.37-.15-.37-.35s.15-.37.35-.37.37.15.37.35-.15.37-.35.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.58,121.08c-.2,0-.36-.15-.37-.34s.15-.36.34-.37.36.15.37.34-.15.36-.34.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.21,120.93c-.19,0-.35-.15-.36-.34s.15-.35.34-.36.35.15.36.34-.15.35-.34.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.86,120.67c-.19,0-.35-.14-.35-.33s.14-.35.33-.35.35.14.35.33-.14.35-.33.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.51,
    cy: 119.98,
    r: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.22,119.86c-.18,0-.34-.14-.34-.32s.14-.34.32-.34.34.14.34.32-.14.34-.32.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.95,
    cy: 118.97,
    r: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.74,118.65c-.18,0-.32-.13-.33-.31s.13-.32.31-.33.32.13.33.31-.13.32-.31.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.58,117.9c-.17,0-.32-.13-.32-.3s.13-.32.3-.32.32.13.32.3-.13.32-.3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.47,117.07c-.17,0-.31-.13-.32-.3s.13-.31.3-.32.31.13.32.3-.13.31-.3.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.42,
    cy: 115.86,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.45,
    cy: 114.88,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.57,
    cy: 113.83,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.76,
    cy: 112.71,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.04,
    cy: 111.53,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.42,
    cy: 110.3,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.89,
    cy: 109.03,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.47,
    cy: 107.72,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.14,
    cy: 106.38,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.91,
    cy: 105.02,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.79,
    cy: 103.65,
    r: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.78,102.5c-.13,0-.23-.1-.24-.22s.1-.23.22-.24.23.1.24.22-.1.23-.22.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.87,
    cy: 100.89,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.06,
    cy: 99.53,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.36,
    cy: 98.19,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.77,
    cy: 96.87,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.27,
    cy: 95.58,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.87,
    cy: 94.34,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.56,
    cy: 93.15,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.34,
    cy: 92.02,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.21,
    cy: 90.94,
    r: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.15,90.11c-.09,0-.17-.07-.17-.16s.07-.17.16-.17.17.07.17.16-.07.17-.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.17,89.17c-.09,0-.16-.07-.17-.16s.07-.16.16-.17.16.07.17.16-.07.16-.16.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.26,88.32c-.09,0-.16-.06-.16-.15s.06-.16.15-.16.16.06.16.15-.06.16-.15.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.41,87.55c-.08,0-.15-.06-.15-.15s.06-.15.15-.15.15.06.15.15-.06.15-.15.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.61,86.88c-.08,0-.15-.06-.15-.14s.06-.15.14-.15.15.06.15.14-.06.15-.14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.86,86.29c-.08,0-.14-.06-.14-.13s.06-.14.13-.14.14.06.14.13-.06.14-.13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.16,85.81c-.07,0-.13-.05-.14-.13s.05-.13.13-.14.13.05.14.13-.05.13-.13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.48,85.43c-.07,0-.13-.05-.13-.12s.05-.13.12-.13.13.05.13.12-.05.13-.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.83,85.14c-.07,0-.12-.05-.12-.11s.05-.12.11-.12.12.05.12.11-.05.12-.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.2,84.96c-.06,0-.11-.05-.12-.11s.05-.11.11-.12.11.05.12.11-.05.11-.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.57,84.89c-.06,0-.11-.04-.11-.1s.04-.11.1-.11.11.04.11.1-.04.11-.1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.95,84.92c-.06,0-.1-.04-.1-.1s.04-.1.1-.1.1.04.1.1-.04.1-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.32,85.06c-.05,0-.09-.04-.1-.09s.04-.09.09-.1.09.04.1.09-.04.09-.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.68,85.3s-.09-.04-.09-.08.04-.09.08-.09.09.04.09.08-.04.09-.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.01,85.65s-.08-.03-.08-.08.03-.08.08-.08.08.03.08.08-.03.08-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.31,86.09s-.08-.03-.08-.07.03-.08.07-.08.08.03.08.07-.03.08-.07.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.57,86.64s-.07-.03-.07-.07.03-.07.07-.07.07.03.07.07-.03.07-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.79,87.28s-.06-.03-.06-.06.03-.06.06-.06.06.03.06.06-.03.06-.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.96,88.01s-.06-.02-.06-.05.02-.06.05-.06.06.02.06.05-.02.06-.05.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.06,
    cy: 88.77,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.1,89.72s-.04-.02-.05-.04.02-.04.04-.05.04.02.05.04-.02.04-.04.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.06,
    cy: 90.66,
    r: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.95,91.75s-.03-.01-.03-.03.01-.03.03-.03.03.01.03.03-.01.03-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.76,92.86s-.03-.01-.03-.02.01-.03.02-.03.03.01.03.02-.01.03-.02.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.47,
    cy: 94.01,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.1,
    cy: 95.24,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.62,
    cy: 96.51,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.36,
    cy: 91.46,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.19,
    cy: 92.69,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.92,
    cy: 93.98,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.55,
    cy: 95.32,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.07,
    cy: 96.71,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.48,
    cy: 98.13,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.78,
    cy: 99.58,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 101.05,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.05,
    cy: 102.53,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.02,
    cy: 104.01,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.87,
    cy: 105.49,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.61,
    cy: 106.95,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.24,
    cy: 108.38,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.76,
    cy: 109.78,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.17,
    cy: 111.14,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.48,
    cy: 112.46,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.7,
    cy: 113.71,
    r: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.98,115.31c-.22.09-.48-.02-.57-.24s.02-.48.24-.57.48.02.57.24-.02.48-.24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.01,116.42c-.22.09-.47-.02-.56-.24s.02-.47.24-.56.47.02.56.24-.02.47-.24.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.95,117.46c-.22.09-.46-.02-.55-.24-.09-.22.02-.46.24-.55s.46.02.55.24-.02.46-.24.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.82,118.41c-.21.09-.46-.02-.54-.23s.02-.46.23-.54.46.02.54.23-.02.46-.23.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.62,119.28c-.21.08-.45-.02-.53-.23s.02-.45.23-.53.45.02.53.23-.02.45-.23.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.35,120.05c-.21.08-.44-.02-.52-.22s.02-.44.22-.52.44.02.52.22-.02.44-.22.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.03,120.72c-.2.08-.43-.02-.52-.22s.02-.43.22-.52.43.02.52.22-.02.43-.22.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.66,121.29c-.2.08-.43-.02-.51-.22s.02-.43.22-.51.43.02.51.22-.02.43-.22.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.26,121.75c-.2.08-.42-.02-.5-.21s.02-.42.21-.5.42.02.5.21-.02.42-.21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.82,122.1c-.19.08-.41-.02-.49-.21s.02-.41.21-.49.41.02.49.21-.02.41-.21.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.35,122.34c-.19.08-.4-.02-.48-.21s.02-.4.21-.48.4.02.48.21-.02.4-.21.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.74,
    cy: 122.13,
    r: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.39,122.48c-.18.07-.39-.02-.46-.2s.02-.39.2-.46.39.02.46.2-.02.39-.2.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.78,
    cy: 122.06,
    r: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.44,122.18c-.18.07-.37-.02-.45-.19s.02-.37.19-.45.37.02.45.19-.02.37-.19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.99,121.85c-.17.07-.37-.01-.44-.19s.01-.37.19-.44.37.01.44.19-.01.37-.19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.57,121.42c-.17.07-.36-.01-.43-.18s.01-.36.18-.43.36.01.43.18-.01.36-.18.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.06,
    cy: 120.58,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.72,
    cy: 119.95,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.44,
    cy: 119.21,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.21,
    cy: 118.37,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.06,
    cy: 117.45,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.97,
    cy: 116.44,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.97,
    cy: 115.34,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.06,
    cy: 114.18,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.23,
    cy: 112.95,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.51,
    cy: 111.66,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.88,
    cy: 110.31,
    r: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.45,109.16c-.13.05-.27-.01-.32-.14s.01-.27.14-.32.27.01.32.14-.01.27-.14.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.94,
    cy: 107.5,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.64,
    cy: 106.05,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.45,
    cy: 104.58,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.37,
    cy: 103.1,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.41,
    cy: 101.62,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.56,
    cy: 100.15,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.82,
    cy: 98.69,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.19,
    cy: 97.25,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.67,
    cy: 95.85,
    r: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.32,94.66c-.09.04-.2,0-.24-.1s0-.2.1-.24.2,0,.24.1,0,.2-.1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156,93.34c-.09.04-.19,0-.23-.1s0-.19.1-.23.19,0,.23.1,0,.19-.1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.79,92.08c-.09.03-.18,0-.22-.09s0-.18.09-.22.18,0,.22.09,0,.18-.09.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.67,90.88c-.08.03-.18,0-.21-.09s0-.18.09-.21.18,0,.21.09,0,.18-.09.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.64,89.75c-.08.03-.17,0-.2-.09s0-.17.09-.2.17,0,.2.09,0,.17-.09.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.69,88.71c-.08.03-.16,0-.19-.08s0-.16.08-.19.16,0,.19.08,0,.16-.08.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.81,87.74c-.07.03-.15,0-.18-.08s0-.15.08-.18.15,0,.18.08,0,.15-.08.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.01,86.86c-.07.03-.15,0-.17-.07s0-.15.07-.17.15,0,.17.07,0,.15-.07.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.27,86.08c-.07.03-.14,0-.17-.07s0-.14.07-.17.14,0,.17.07,0,.14-.07.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.59,85.4c-.06.02-.13,0-.16-.07s0-.13.07-.16.13,0,.16.07,0,.13-.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.95,84.82c-.06.02-.12,0-.15-.06s0-.13.06-.15.12,0,.15.06,0,.12-.06.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.35,84.34c-.06.02-.12,0-.14-.06s0-.12.06-.14.12,0,.14.06,0,.12-.06.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.79,83.98c-.05.02-.11,0-.13-.06s0-.11.06-.13.11,0,.13.06,0,.11-.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.25,83.72s-.1,0-.12-.05,0-.1.05-.12.1,0,.12.05,0,.1-.05.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.72,83.58s-.1,0-.11-.05,0-.1.05-.11.1,0,.11.05,0,.1-.05.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.2,83.56s-.09,0-.1-.04,0-.09.04-.1.09,0,.1.04,0,.09-.04.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.68,83.64s-.08,0-.1-.04,0-.08.04-.1.08,0,.1.04,0,.08-.04.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.14,83.84s-.07,0-.09-.04,0-.07.04-.09.07,0,.09.04,0,.07-.04.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.59,84.15s-.07,0-.08-.03,0-.07.03-.08.07,0,.08.03,0,.07-.03.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.98,
    cy: 84.52,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.38,85.1s-.05,0-.06-.03,0-.05.03-.06.05,0,.06.03,0,.05-.03.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.7,
    cy: 85.69,
    r: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183,86.46s-.04,0-.04-.02,0-.04.02-.04.04,0,.04.02,0,.04-.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.22,87.29s-.03,0-.03-.01,0-.03.01-.03.03,0,.03.01,0,.03-.01.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.37,
    cy: 88.19,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.45,
    cy: 89.2,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.45,
    cy: 90.29,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.32,
    cy: 85.65,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.61,
    cy: 86.59,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.82,
    cy: 87.62,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.94,
    cy: 88.75,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.98,
    cy: 89.96,
    r: 0.56,
    transform: "translate(11.24 200.48) rotate(-57.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.92,
    cy: 91.24,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.76,
    cy: 92.6,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.5,
    cy: 94.01,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.12,
    cy: 95.48,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.63,
    cy: 96.99,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.02,
    cy: 98.53,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.29,
    cy: 100.1,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.44,
    cy: 101.69,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.48,
    cy: 103.28,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.39,
    cy: 104.87,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.17,
    cy: 106.45,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.84,
    cy: 108.01,
    r: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.7,109.89c-.19.17-.49.16-.66-.04s-.16-.49.04-.66.49-.16.66.04c.17.19.16.49-.04.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.13,111.37c-.19.17-.48.15-.65-.04s-.15-.48.04-.65.48-.15.65.04.15.48-.04.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.44,112.81c-.19.17-.47.15-.64-.04s-.15-.47.04-.64.47-.15.64.04.15.47-.04.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.65,114.19c-.18.16-.47.15-.63-.04s-.15-.47.04-.63.47-.15.63.04.15.47-.04.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.75,115.5c-.18.16-.46.15-.62-.03s-.15-.46.03-.62.46-.15.62.03.15.46-.03.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.76,116.75c-.18.16-.45.14-.61-.03s-.14-.45.03-.61.45-.14.61.03.14.45-.03.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.67,117.91c-.18.16-.44.14-.6-.03s-.14-.44.03-.6.44-.14.6.03.14.44-.03.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.5,118.99c-.17.15-.44.14-.59-.03s-.14-.44.03-.59.44-.14.59.03.14.44-.03.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.25,119.97c-.17.15-.43.14-.58-.03s-.14-.43.03-.58.43-.14.58.03.14.43-.03.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.92,120.86c-.17.15-.42.13-.57-.03s-.13-.42.03-.57.42-.13.57.03.13.42-.03.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.53,121.64c-.16.15-.41.13-.56-.03s-.13-.41.03-.56.41-.13.56.03.13.41-.03.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.82,
    cy: 122.02,
    r: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.59,122.87c-.16.14-.4.13-.54-.03s-.13-.4.03-.54.4-.13.54.03.13.4-.03.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.8,
    cy: 123.04,
    r: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.49,123.65c-.15.14-.38.12-.52-.03s-.12-.38.03-.52.38-.12.52.03.12.38-.03.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.91,123.85c-.15.13-.38.12-.51-.03s-.12-.38.03-.51.38-.12.51.03.12.38-.03.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.31,123.94c-.15.13-.37.12-.5-.03s-.12-.37.03-.5.37-.12.5.03.12.37-.03.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.48,
    cy: 123.65,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.9,
    cy: 123.5,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.33,
    cy: 123.22,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.78,
    cy: 122.83,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.27,
    cy: 122.32,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.81,
    cy: 121.69,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.4,
    cy: 120.96,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.04,
    cy: 120.12,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.76,
    cy: 119.18,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.55,
    cy: 118.14,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.42,
    cy: 117.01,
    r: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.56,116c-.11.1-.28.09-.38-.02s-.09-.28.02-.38.28-.09.38.02.09.28-.02.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.44,
    cy: 114.52,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.6,
    cy: 113.17,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.87,
    cy: 111.75,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.25,
    cy: 110.28,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.74,
    cy: 108.77,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.34,
    cy: 107.23,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.07,
    cy: 105.66,
    r: 0.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.92,
    cy: 104.07,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.89,
    cy: 102.48,
    r: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.11,101.03c-.08.07-.2.06-.28-.02s-.06-.2.02-.28.2-.06.28.02.06.2-.02.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.31,99.45c-.08.07-.2.06-.27-.01s-.06-.2.01-.27.2-.06.27.01.06.2-.01.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.64,97.89c-.07.07-.19.06-.25-.01s-.06-.19.01-.25.19-.06.25.01.06.19-.01.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.09,96.35c-.07.06-.18.06-.24-.01s-.06-.18.01-.24.18-.06.24.01.06.18-.01.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.65,94.86c-.07.06-.17.06-.23-.01s-.06-.17.01-.23.17-.06.23.01.06.17-.01.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.33,93.41c-.07.06-.17.05-.22-.01s-.05-.17.01-.22.17-.05.22.01.05.17-.01.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.12,92.02c-.06.06-.16.05-.21-.01s-.05-.16.01-.21.16-.05.21.01.05.16-.01.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156,90.7c-.06.05-.15.05-.2-.01s-.05-.15.01-.2.15-.05.2.01.05.15-.01.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.99,89.44c-.06.05-.14.05-.19-.01s-.05-.14.01-.19.14-.05.19.01.05.14-.01.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.06,88.27c-.05.05-.14.04-.18-.01s-.04-.14.01-.18.14-.04.18.01.04.14-.01.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.23,87.18c-.05.05-.13.04-.17,0s-.04-.13,0-.17.13-.04.17,0,.04.13,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.47,86.18s-.12.04-.16,0-.04-.12,0-.16.12-.04.16,0,.04.12,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.79,85.29s-.11.04-.15,0-.04-.11,0-.15.11-.04.15,0,.04.11,0,.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.17,84.5s-.11.03-.14,0-.03-.11,0-.14.11-.03.14,0,.03.11,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.61,83.81s-.1.03-.13,0-.03-.1,0-.13.1-.03.13,0,.03.1,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.09,83.24s-.09.03-.12,0-.03-.09,0-.12.09-.03.12,0,.03.09,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.61,82.79s-.08.03-.11,0-.03-.08,0-.11.08-.03.11,0,.03.08,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.17,82.45s-.08.02-.1,0-.02-.08,0-.1.08-.02.1,0,.02.08,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.74,82.23s-.07.02-.09,0-.02-.07,0-.09.07-.02.09,0,.02.07,0,.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.29,
    cy: 82.09,
    r: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.92,82.16s-.05.02-.07,0-.02-.05,0-.07.05-.02.07,0,.02.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.47,
    cy: 82.27,
    r: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.06,82.57s-.04.01-.05,0-.01-.04,0-.05.04-.01.05,0,.01.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.6,82.96s-.03,0-.04,0,0-.03,0-.04.03,0,.04,0,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.09,
    cy: 83.45,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.56,
    cy: 84.07,
    r: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.97,
    cy: 84.81,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.1,
    cy: 81.26,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.74,
    cy: 81.74,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.35,
    cy: 82.34,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.9,
    cy: 83.07,
    r: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.39,
    cy: 83.91,
    r: 0.61,
    transform: "translate(38.54 224.5) rotate(-68.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.82,
    cy: 84.86,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.16,
    cy: 85.92,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.42,
    cy: 87.08,
    r: 0.58,
    transform: "translate(53.44 244.77) rotate(-74.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.59,
    cy: 88.33,
    r: 0.57,
    transform: "translate(53.04 246.76) rotate(-74.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.66,
    cy: 89.67,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.62,
    cy: 91.09,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.48,
    cy: 92.57,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.22,
    cy: 94.12,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.83,
    cy: 95.72,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.33,
    cy: 97.36,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.69,
    cy: 99.03,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.93,
    cy: 100.73,
    r: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.48,102.68c-.13.25-.44.34-.68.21s-.34-.44-.21-.68.44-.34.68-.21.34.44.21.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.45,104.39c-.13.24-.43.33-.67.2s-.33-.43-.2-.67.43-.33.67-.2.33.43.2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.28,106.09c-.13.24-.42.33-.66.2s-.33-.42-.2-.66.42-.33.66-.2.33.42.2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.99,107.77c-.13.23-.42.32-.65.2s-.32-.42-.2-.65.42-.32.65-.2.32.42.2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.56,109.43c-.12.23-.41.32-.64.19s-.32-.41-.19-.64.41-.32.64-.19.32.41.19.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.02,111.05c-.12.23-.4.31-.63.19s-.31-.4-.19-.63.4-.31.63-.19.31.4.19.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.35,112.63c-.12.22-.4.31-.62.19s-.31-.4-.19-.62.4-.31.62-.19.31.4.19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.56,114.15c-.12.22-.39.3-.61.18s-.3-.39-.18-.61.39-.3.61-.18.3.39.18.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.66,115.61c-.12.22-.38.3-.6.18s-.3-.38-.18-.6.38-.3.6-.18.3.38.18.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.64,116.99c-.11.21-.38.29-.59.18s-.29-.38-.18-.59.38-.29.59-.18.29.38.18.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.52,118.29c-.11.21-.37.29-.58.17s-.29-.37-.17-.58.37-.29.58-.17c.21.11.29.37.17.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.94,
    cy: 119.3,
    r: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.01,120.62c-.11.2-.36.28-.56.17s-.28-.36-.17-.56.36-.28.56-.17.28.36.17.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.26,
    cy: 121.44,
    r: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.16,122.54c-.1.19-.34.27-.54.16s-.27-.34-.16-.54.34-.27.54-.16.27.34.16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.64,123.33c-.1.19-.34.26-.53.16s-.26-.34-.16-.53.34-.26.53-.16.26.34.16.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.06,124.01c-.1.19-.33.25-.52.16s-.25-.33-.16-.52.33-.25.52-.16.25.33.16.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.1,
    cy: 124.38,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.44,
    cy: 124.81,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.76,
    cy: 125.11,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.05,
    cy: 125.29,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.34,
    cy: 125.32,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.63,
    cy: 125.23,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.93,
    cy: 125.01,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.25,
    cy: 124.65,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.61,
    cy: 124.18,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164,
    cy: 123.57,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.45,
    cy: 122.85,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.21,122.15c-.07.14-.25.19-.39.12s-.19-.25-.12-.39.25-.19.39-.12.19.25.12.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.53,
    cy: 121.06,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.19,
    cy: 120,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.93,
    cy: 118.84,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.76,
    cy: 117.59,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.69,
    cy: 116.25,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.72,
    cy: 114.83,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.87,
    cy: 113.34,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.13,
    cy: 111.8,
    r: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.52,
    cy: 110.2,
    r: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.21,108.66c-.05.1-.18.14-.28.09s-.14-.18-.09-.28.18-.14.28-.09.14.18.09.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.83,106.98c-.05.1-.18.14-.27.08s-.14-.18-.08-.27.18-.14.27-.08.14.18.08.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.59,105.28c-.05.09-.17.13-.26.08s-.13-.17-.08-.26.17-.13.26-.08.13.17.08.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.48,103.57c-.05.09-.16.12-.25.08s-.12-.16-.08-.25.16-.12.25-.08.12.16.08.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.5,101.85c-.05.09-.15.12-.24.07s-.12-.15-.07-.24.15-.12.24-.07.12.15.07.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.65,100.14c-.04.08-.15.11-.23.07s-.11-.15-.07-.23.15-.11.23-.07.11.15.07.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.93,98.45c-.04.08-.14.11-.22.07s-.11-.14-.07-.22.14-.11.22-.07.11.14.07.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.34,96.78c-.04.08-.13.1-.21.06s-.1-.13-.06-.21.13-.1.21-.06.1.13.06.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.87,95.15c-.04.07-.13.1-.2.06s-.1-.13-.06-.2.13-.1.2-.06.1.13.06.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.53,93.57c-.04.07-.12.09-.19.06s-.09-.12-.06-.19.12-.09.19-.06.09.12.06.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.31,92.04c-.03.06-.11.09-.18.05s-.09-.11-.05-.18.11-.09.18-.05.09.11.05.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.2,90.58c-.03.06-.11.08-.17.05s-.08-.11-.05-.17.11-.08.17-.05.08.11.05.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.2,89.19c-.03.06-.1.08-.16.05s-.08-.1-.05-.16.1-.08.16-.05.08.1.05.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.3,87.88c-.03.05-.09.07-.15.04s-.07-.09-.04-.15.09-.07.15-.04.07.09.04.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.5,86.66s-.09.07-.14.04-.07-.09-.04-.14.09-.07.14-.04.07.09.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.79,85.54s-.08.06-.13.04-.06-.08-.04-.13.08-.06.13-.04.06.08.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.16,84.52s-.07.06-.12.03-.06-.07-.03-.12.07-.06.12-.03.06.07.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.61,83.6s-.07.05-.11.03-.05-.07-.03-.11.07-.05.11-.03.05.07.03.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.12,82.8s-.06.05-.09.03-.05-.06-.03-.09.06-.05.09-.03.05.06.03.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.63,
    cy: 82.09,
    r: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.3,81.56s-.05.04-.07.02-.04-.05-.02-.07.05-.04.07-.02.04.05.02.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.91,
    cy: 81.11,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.63,80.82s-.03.03-.05.02-.03-.03-.02-.05.03-.03.05-.02.03.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.33,80.65s-.03.02-.04.01-.02-.03-.01-.04.03-.02.04-.01.02.03.01.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.01,
    cy: 80.6,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.72,
    cy: 80.69,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.42,
    cy: 80.91,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.2,
    cy: 79.13,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.03,
    cy: 79,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.88,
    cy: 79.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.71,
    cy: 79.18,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.53,
    cy: 79.48,
    r: 0.65,
    transform: "translate(66.51 239.19) rotate(-79.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.32,
    cy: 79.92,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.07,
    cy: 80.49,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.77,
    cy: 81.2,
    r: 0.63,
    transform: "translate(77.27 251.11) rotate(-82.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.41,
    cy: 82.04,
    r: 0.62,
    transform: "translate(78 253.54) rotate(-82.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.98,
    cy: 83,
    r: 0.61,
    transform: "translate(78.56 256.02) rotate(-82.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.48,
    cy: 84.07,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.89,
    cy: 85.26,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.2,
    cy: 86.55,
    r: 0.58,
    transform: "translate(79.15 263.57) rotate(-82.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.41,
    cy: 87.94,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.52,
    cy: 89.42,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.5,
    cy: 90.97,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.36,
    cy: 92.6,
    r: 0.55,
    transform: "translate(60.35 261.1) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.64,94.37c-.04.3-.32.5-.61.46s-.5-.32-.46-.61c.04-.3.32-.5.61-.46s.5.32.46.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.23,96.11c-.04.29-.31.49-.61.45s-.49-.31-.45-.61.31-.49.61-.45.49.31.45.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.69,97.89c-.04.29-.31.49-.6.45s-.49-.31-.45-.6.31-.49.6-.45.49.31.45.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.01,99.7c-.04.28-.3.48-.59.44s-.48-.3-.44-.59.3-.48.59-.44.48.3.44.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.19,101.53c-.04.28-.3.47-.58.43s-.47-.3-.43-.58.3-.47.58-.43.47.3.43.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.24,103.37c-.04.27-.29.46-.57.42s-.46-.29-.42-.57.29-.46.57-.42.46.29.42.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.14,105.21c-.04.27-.29.46-.56.42s-.46-.29-.42-.56.29-.46.56-.42.46.29.42.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.9,107.04c-.04.26-.28.45-.55.41s-.45-.28-.41-.55.28-.45.55-.41.45.28.41.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.53,108.84c-.04.26-.28.44-.54.4s-.44-.28-.4-.54c.04-.26.28-.44.54-.4s.44.28.4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.01,110.61c-.04.26-.27.43-.53.4s-.43-.27-.4-.53.27-.43.53-.4.43.27.4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.36,112.33c-.04.25-.27.43-.52.39s-.43-.27-.39-.52.27-.43.52-.39.43.27.39.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.13,
    cy: 113.94,
    r: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.67,115.61c-.03.24-.26.41-.5.37s-.41-.26-.37-.5.26-.41.5-.37.41.26.37.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.21,
    cy: 117.08,
    r: 0.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.5,118.6c-.03.23-.25.39-.48.36s-.39-.25-.36-.48.25-.39.48-.36.39.25.36.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.25,119.96c-.03.23-.24.39-.47.35s-.39-.24-.35-.47.24-.39.47-.35.39.24.35.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.91,121.22c-.03.22-.24.38-.46.35s-.38-.24-.35-.46.24-.38.46-.35.38.24.35.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.07,
    cy: 122.32,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.55,
    cy: 123.37,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.96,
    cy: 124.29,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.3,
    cy: 125.09,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.58,
    cy: 125.76,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.82,
    cy: 126.3,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.02,
    cy: 126.69,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.2,
    cy: 126.95,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.36,
    cy: 127.08,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.52,
    cy: 127.06,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.68,
    cy: 126.9,
    r: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.17,126.64c-.02.17-.18.29-.35.26s-.29-.18-.26-.35.18-.29.35-.26.29.18.26.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.07,
    cy: 126.16,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.32,
    cy: 125.59,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.62,
    cy: 124.88,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.98,
    cy: 124.04,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.41,
    cy: 123.08,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.91,
    cy: 122,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.51,
    cy: 120.82,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.19,
    cy: 119.53,
    r: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.98,
    cy: 118.14,
    r: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.1,116.69c-.02.12-.13.21-.26.19s-.21-.13-.19-.26.13-.21.26-.19.21.13.19.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.11,115.14c-.02.12-.13.2-.25.18s-.2-.13-.18-.25.13-.2.25-.18.2.13.18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.24,113.51c-.02.11-.12.19-.24.18s-.19-.12-.18-.24.12-.19.24-.18.19.12.18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.49,111.82c-.02.11-.12.19-.23.17s-.19-.12-.17-.23.12-.19.23-.17.19.12.17.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.88,110.07c-.02.1-.11.18-.22.16s-.18-.11-.16-.22.11-.18.22-.16.18.11.16.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.41,108.29c-.01.1-.11.17-.21.16s-.17-.11-.16-.21.11-.17.21-.16.17.11.16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.07,106.48c-.01.1-.1.16-.2.15s-.16-.1-.15-.2.1-.16.2-.15.16.1.15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.87,104.64c-.01.09-.1.15-.19.14s-.15-.1-.14-.19.1-.15.19-.14.15.1.14.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.81,102.8c-.01.09-.09.15-.18.13s-.15-.09-.13-.18.09-.15.18-.13.15.09.13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.89,100.96c-.01.08-.09.14-.17.13s-.14-.09-.13-.17.09-.14.17-.13.14.09.13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.11,99.13c-.01.08-.08.13-.16.12s-.13-.08-.12-.16.08-.13.16-.12.13.08.12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.47,97.32c-.01.07-.08.12-.15.11s-.12-.08-.11-.15.08-.12.15-.11.12.08.11.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.97,95.55c0,.07-.07.12-.14.11s-.12-.07-.11-.14.07-.12.14-.11.12.07.11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.61,93.82c0,.06-.07.11-.13.1s-.11-.07-.1-.13.07-.11.13-.1.11.07.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.37,92.15c0,.06-.06.1-.12.09s-.1-.06-.09-.12.06-.1.12-.09.1.06.09.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.26,90.54c0,.05-.06.09-.11.08s-.09-.06-.08-.11.06-.09.11-.08.09.06.08.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.27,89.01c0,.05-.05.09-.1.08s-.09-.05-.08-.1.05-.09.1-.08.09.05.08.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.4,87.55s-.05.08-.09.07-.08-.05-.07-.09.05-.08.09-.07.08.05.07.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.63,86.19s-.04.07-.09.06-.07-.04-.06-.09.04-.07.09-.06.07.04.06.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.89,
    cy: 84.91,
    r: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.39,83.76s-.03.05-.07.05-.05-.03-.05-.07.03-.05.07-.05.05.03.05.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.85,
    cy: 82.71,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.48,81.79s-.02.04-.05.04-.04-.02-.04-.05.02-.04.05-.04.04.02.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.13,80.99s-.02.03-.04.03-.03-.02-.03-.04.02-.03.04-.03.03.02.03.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.81,
    cy: 80.32,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.58,
    cy: 79.78,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.38,
    cy: 79.39,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.43,
    cy: 79.87,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.24,
    cy: 79.07,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.11,
    cy: 78.41,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.02,
    cy: 77.89,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.97,
    cy: 77.53,
    r: 0.7,
    transform: "translate(-.38 .82) rotate(-.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.94,
    cy: 77.31,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.92,
    cy: 77.25,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.89,
    cy: 77.34,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.86,
    cy: 77.58,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.8,
    cy: 77.98,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.71,
    cy: 78.51,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.57,
    cy: 79.2,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.37,
    cy: 80.02,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.11,
    cy: 80.97,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.76,
    cy: 82.06,
    r: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.33,
    cy: 83.27,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.8,
    cy: 84.6,
    r: 0.59,
    transform: "translate(93.13 269.05) rotate(-86.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.74,85.91c.07.32-.14.62-.45.69s-.62-.14-.69-.45.14-.62.45-.69.62.14.69.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.98,87.45c.06.31-.13.62-.44.68s-.62-.13-.68-.44.13-.62.44-.68.62.13.68.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.1,89.08c.06.31-.13.61-.44.67s-.61-.13-.67-.44.13-.61.44-.67c.31-.06.61.13.67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.09,90.79c.06.3-.13.6-.43.66s-.6-.13-.66-.43.13-.6.43-.66.6.13.66.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.95,92.58c.06.3-.13.59-.42.65s-.59-.13-.65-.42.13-.59.42-.65.59.13.65.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.67,94.42c.06.29-.13.58-.42.64s-.58-.13-.64-.42.13-.58.42-.64.58.13.64.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.25,96.31c.06.29-.12.57-.41.63s-.57-.12-.63-.41.12-.57.41-.63.57.12.63.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.68,98.25c.06.28-.12.56-.4.62s-.56-.12-.62-.4.12-.56.4-.62.56.12.62.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.96,100.21c.06.28-.12.55-.4.61s-.55-.12-.61-.4.12-.55.4-.61.55.12.61.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.09,102.19c.06.27-.12.54-.39.59s-.54-.12-.59-.39.12-.54.39-.59.54.12.59.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.07,104.17c.06.27-.12.53-.38.58s-.53-.12-.58-.38.12-.53.38-.58.53.12.58.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.42,
    cy: 106.24,
    r: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.56,108.1c.05.26-.11.51-.37.56s-.51-.11-.56-.37.11-.51.37-.56.51.11.56.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.63,
    cy: 110.13,
    r: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.47,111.92c.05.25-.11.49-.35.54s-.49-.11-.54-.35.11-.49.35-.54.49.11.54.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.71,113.75c.05.24-.1.48-.35.53s-.48-.1-.53-.35.1-.48.35-.53.48.1.53.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.81,115.52c.05.24-.1.47-.34.52s-.47-.1-.52-.34.1-.47.34-.52.47.1.52.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.36,
    cy: 117.31,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.21,
    cy: 118.92,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.94,
    cy: 120.44,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.56,
    cy: 121.86,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.07,
    cy: 123.17,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.49,
    cy: 124.36,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.82,
    cy: 125.42,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.07,
    cy: 126.36,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.26,
    cy: 127.16,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.39,
    cy: 127.82,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.48,
    cy: 128.33,
    r: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.85,128.63c.04.18-.08.36-.26.39s-.36-.08-.39-.26.08-.36.26-.39.36.08.39.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.56,
    cy: 128.91,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.58,
    cy: 128.97,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.6,
    cy: 128.88,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.63,
    cy: 128.64,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.69,
    cy: 128.25,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.79,
    cy: 127.71,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.93,
    cy: 127.03,
    r: 0.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.12,
    cy: 126.21,
    r: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.39,
    cy: 125.25,
    r: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.97,124.12c.03.13-.06.26-.19.29s-.26-.06-.29-.19.06-.26.19-.29.26.06.29.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.39,122.91c.03.13-.05.25-.18.28s-.25-.05-.28-.18.05-.25.18-.28.25.05.28.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.91,121.58c.03.12-.05.24-.17.27s-.24-.05-.27-.17.05-.24.17-.27.24.05.27.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.54,120.15c.02.12-.05.23-.17.25s-.23-.05-.25-.17.05-.23.17-.25.23.05.25.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.28,118.61c.02.11-.05.22-.16.24s-.22-.05-.24-.16.05-.22.16-.24.22.05.24.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.15,116.98c.02.11-.05.21-.15.23s-.21-.05-.23-.15.05-.21.15-.23.21.05.23.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.14,115.28c.02.1-.04.2-.15.22s-.2-.04-.22-.15.04-.2.15-.22.2.04.22.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.26,113.5c.02.1-.04.19-.14.21s-.19-.04-.21-.14.04-.19.14-.21.19.04.21.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.52,111.66c.02.09-.04.18-.13.2s-.18-.04-.2-.13.04-.18.13-.2.18.04.2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.93,109.77c.02.09-.04.17-.13.19s-.17-.04-.19-.13.04-.17.13-.19.17.04.19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.48,107.84c.02.08-.04.16-.12.18s-.16-.04-.18-.12.04-.16.12-.18.16.04.18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.18,105.88c.02.08-.03.15-.11.17s-.15-.03-.17-.11.03-.15.11-.17.15.03.17.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.03,103.91c.02.07-.03.14-.1.16s-.14-.03-.16-.1.03-.14.1-.16.14.03.16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.04,101.93c.01.07-.03.13-.1.15s-.13-.03-.15-.1.03-.13.1-.15.13.03.15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.2,99.95c.01.06-.03.12-.09.14s-.12-.03-.14-.09.03-.12.09-.14.12.03.14.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.5,98c.01.06-.03.12-.08.13s-.12-.03-.13-.08.03-.12.08-.13.12.03.13.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.96,96.08c.01.05-.02.11-.08.12s-.11-.02-.12-.08.02-.11.08-.12.11.02.12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.56,94.19s-.02.1-.07.11-.1-.02-.11-.07.02-.1.07-.11.1.02.11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.31,92.36s-.02.09-.06.1-.09-.02-.1-.06.02-.09.06-.1.09.02.1.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.12,
    cy: 90.61,
    r: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.2,88.9s-.01.07-.05.07-.07-.01-.07-.05.01-.07.05-.07.07.01.07.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.29,
    cy: 87.3,
    r: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.6,85.77s-.01.05-.03.05-.05-.01-.05-.03.01-.05.03-.05.05.01.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.97,84.35s0,.04-.03.04-.04,0-.04-.03,0-.04.03-.04.04,0,.04.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.43,
    cy: 83.05,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.01,
    cy: 81.86,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.68,
    cy: 80.8,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.84,
    cy: 83.85,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.38,
    cy: 82.37,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.02,
    cy: 81.02,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.76,
    cy: 79.79,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.6,
    cy: 78.71,
    r: 0.75,
    transform: "translate(-12.6 33.82) rotate(-11.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.51,
    cy: 77.77,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.49,
    cy: 76.98,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.52,
    cy: 76.34,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.59,
    cy: 75.86,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.7,
    cy: 75.54,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.82,
    cy: 75.38,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.95,
    cy: 75.39,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.08,
    cy: 75.56,
    r: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.18,
    cy: 75.88,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.26,
    cy: 76.37,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.28,
    cy: 77.02,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.26,
    cy: 77.82,
    r: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.7,78.44c.18.29.09.68-.2.86s-.68.09-.86-.2c-.18-.29-.09-.68.2-.86s.68-.09.86.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.52,79.54c.18.29.09.67-.2.85s-.67.09-.85-.2-.09-.67.2-.85.67-.09.85.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.25,80.77c.18.29.09.66-.2.84s-.66.09-.84-.2-.09-.66.2-.84c.29-.18.66-.09.84.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.88,82.14c.17.28.09.65-.19.82s-.65.09-.82-.19c-.17-.28-.09-.65.19-.82s.65-.09.82.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.4,83.62c.17.28.09.64-.19.81s-.64.09-.81-.19-.09-.64.19-.81.64-.09.81.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.81,85.22c.17.27.08.63-.19.8s-.63.08-.8-.19-.08-.63.19-.8.63-.08.8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.09,86.92c.17.27.08.62-.18.78s-.62.08-.78-.18-.08-.62.18-.78.62-.08.78.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.24,88.72c.16.26.08.61-.18.77s-.61.08-.77-.18c-.16-.26-.08-.61.18-.77s.61-.08.77.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.24,90.59c.16.26.08.6-.18.76s-.6.08-.76-.18-.08-.6.18-.76.6-.08.76.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.1,92.55c.16.25.08.59-.17.74s-.59.08-.74-.17-.08-.59.17-.74.59-.08.74.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.81,94.56c.15.25.08.58-.17.73s-.58.08-.73-.17-.08-.58.17-.73.58-.08.73.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.91,
    cy: 96.89,
    r: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.75,98.72c.15.24.07.56-.17.7s-.56.07-.7-.17-.07-.56.17-.7.56-.07.7.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.55,
    cy: 101.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.05,102.97c.14.23.07.53-.16.68s-.53.07-.68-.16-.07-.53.16-.68.53-.07.68.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.95,105.1c.14.23.07.52-.16.66s-.52.07-.66-.16-.07-.52.16-.66.52-.07.66.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.7,107.22c.14.22.07.51-.15.65s-.51.07-.65-.15-.07-.51.15-.65.51-.07.65.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.89,
    cy: 109.56,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.32,
    cy: 111.62,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.6,
    cy: 113.62,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.72,
    cy: 115.56,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 196.7,
    cy: 117.43,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.53,
    cy: 119.22,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.24,
    cy: 120.9,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.81,
    cy: 122.49,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.28,
    cy: 123.97,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.63,
    cy: 125.32,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.89,
    cy: 126.54,
    r: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.36,127.44c.1.17.05.39-.12.49s-.39.05-.49-.12-.05-.39.12-.49.39-.05.49.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.14,
    cy: 128.57,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.17,
    cy: 129.36,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.13,
    cy: 130,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.06,
    cy: 130.47,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.95,
    cy: 130.79,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.83,
    cy: 130.95,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.7,
    cy: 130.95,
    r: 0.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.57,
    cy: 130.78,
    r: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.47,
    cy: 130.45,
    r: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.62,129.82c.08.12.04.28-.08.36s-.28.04-.36-.08-.04-.28.08-.36.28-.04.36.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.58,129.18c.07.12.04.27-.08.35s-.27.04-.35-.08-.04-.27.08-.35.27-.04.35.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.6,128.39c.07.11.04.26-.08.33s-.26.04-.33-.08-.04-.26.08-.33.26-.04.33.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.68,127.44c.07.11.03.25-.07.32s-.25.03-.32-.07-.03-.25.07-.32.25-.03.32.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.85,126.35c.06.1.03.24-.07.31s-.24.03-.31-.07-.03-.24.07-.31.24-.03.31.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.1,125.13c.06.1.03.23-.07.29s-.23.03-.29-.07-.03-.23.07-.29.23-.03.29.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.45,123.77c.06.1.03.22-.07.28s-.22.03-.28-.07-.03-.22.07-.28.22-.03.28.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.91,122.3c.06.09.03.21-.06.27s-.21.03-.27-.06-.03-.21.06-.27.21-.03.27.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.49,120.71c.05.09.03.2-.06.25s-.2.03-.25-.06-.03-.2.06-.25.2-.03.25.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.19,119.02c.05.08.03.19-.06.24s-.19.03-.24-.06-.03-.19.06-.24.19-.03.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.03,117.23c.05.08.02.18-.05.23s-.18.02-.23-.05-.02-.18.05-.23.18-.02.23.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.01,115.37c.04.07.02.17-.05.21s-.17.02-.21-.05-.02-.17.05-.21.17-.02.21.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.13,113.43c.04.07.02.16-.05.2s-.16.02-.2-.05-.02-.16.05-.2.16-.02.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.41,111.42c.04.06.02.15-.04.19s-.15.02-.19-.04-.02-.15.04-.19.15-.02.19.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.85,109.37c.04.06.02.14-.04.17s-.14.02-.17-.04-.02-.14.04-.17.14-.02.17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.44,107.29c.03.05.02.13-.04.16s-.13.02-.16-.04-.02-.13.04-.16.13-.02.16.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.19,105.17s.02.12-.03.15-.12.02-.15-.03-.02-.12.03-.15.12-.02.15.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.11,103.05s.01.1-.03.13-.1.01-.13-.03-.01-.1.03-.13.1-.01.13.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.19,100.93s.01.09-.03.12-.09.01-.12-.03-.01-.09.03-.12.09-.01.12.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.36,
    cy: 98.86,
    r: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.83,96.73s0,.07-.02.09-.07,0-.09-.02,0-.07.02-.09.07,0,.09.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.34,
    cy: 94.71,
    r: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.1,92.69s0,.05-.02.07-.05,0-.07-.02,0-.05.02-.07.05,0,.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.97,90.75s0,.04-.01.05-.04,0-.05-.01,0-.04.01-.05.04,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.96,
    cy: 88.9,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.12,
    cy: 87.12,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.42,
    cy: 85.43,
    r: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.62,
    cy: 91.02,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.63,
    cy: 88.97,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.8,
    cy: 86.99,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 149.11,
    cy: 85.12,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.56,
    cy: 83.35,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.15,
    cy: 81.69,
    r: 0.8,
    transform: "translate(11.45 181.83) rotate(-63.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.86,
    cy: 80.17,
    r: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.68,
    cy: 78.77,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.6,
    cy: 77.53,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.61,
    cy: 76.43,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.7,
    cy: 75.49,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.85,
    cy: 74.71,
    r: 0.74,
    transform: "translate(51.38 215.35) rotate(-75.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.06,
    cy: 74.1,
    r: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.3,
    cy: 73.66,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.58,
    cy: 73.39,
    r: 0.71,
    transform: "translate(42.06 207.43) rotate(-69.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.87,
    cy: 73.29,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.16,
    cy: 73.38,
    r: 0.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.85,73.1c.29.23.34.65.11.95s-.65.34-.95.11-.34-.65-.11-.95.65-.34.95-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.09,73.55c.29.23.34.64.11.93s-.64.34-.93.11-.34-.64-.11-.93.64-.34.93-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.29,74.16c.28.22.33.63.11.92s-.63.33-.92.11c-.28-.22-.33-.63-.11-.92s.63-.33.92-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.44,74.94c.28.22.33.62.11.9s-.62.33-.9.11-.33-.62-.11-.9.62-.33.9-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.53,75.88c.27.22.32.61.11.89s-.61.32-.89.11-.32-.61-.11-.89.61-.32.89-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.54,76.98c.27.21.32.6.1.87s-.6.32-.87.1-.32-.6-.1-.87.6-.32.87-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.46,78.22c.27.21.31.59.1.86-.21.27-.59.31-.86.1s-.31-.59-.1-.86.59-.31.86-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.28,79.61c.26.21.31.58.1.85s-.58.31-.85.1-.31-.58-.1-.85.58-.31.85-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.98,81.14c.26.2.3.57.1.83s-.57.3-.83.1-.3-.57-.1-.83.57-.3.83-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.57,82.8c.25.2.3.56.1.82s-.56.3-.82.1-.3-.56-.1-.82.56-.3.82-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.02,84.57c.25.19.29.55.1.8s-.55.29-.8.1-.29-.55-.1-.8.55-.29.8-.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.99,
    cy: 86.89,
    r: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.5,88.43c.24.19.28.53.09.77s-.53.28-.77.09-.28-.53-.09-.77.53-.28.77-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.18,
    cy: 90.91,
    r: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.37,92.62c.23.18.27.51.09.74s-.51.27-.74.09-.27-.51-.09-.74.51-.27.74-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.06,94.81c.23.18.26.5.09.73s-.5.26-.73.09-.26-.5-.09-.73.5-.26.73-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.58,97.04c.22.17.26.49.09.71s-.49.26-.71.09-.26-.49-.09-.71.49-.26.71-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.62,
    cy: 99.71,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.8,
    cy: 101.99,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.81,
    cy: 104.28,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.64,
    cy: 106.56,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.29,
    cy: 108.83,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.77,
    cy: 111.06,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.08,
    cy: 113.24,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.23,
    cy: 115.37,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.22,
    cy: 117.42,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.05,
    cy: 119.4,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 196.74,
    cy: 121.27,
    r: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.53,122.74c.17.13.2.37.06.54s-.37.2-.54.06-.2-.37-.06-.54.37-.2.54-.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.7,
    cy: 124.7,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192,
    cy: 126.22,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.18,
    cy: 127.61,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.25,
    cy: 128.86,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.24,
    cy: 129.96,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.15,
    cy: 130.9,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182,
    cy: 131.68,
    r: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.79,
    cy: 132.29,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.55,
    cy: 132.73,
    r: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.45,132.78c.12.1.14.27.05.39s-.27.14-.39.05-.14-.27-.05-.39.27-.14.39-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.15,132.88c.12.09.14.26.05.38s-.26.14-.38.05-.14-.26-.05-.38.26-.14.38-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.86,132.81c.11.09.13.25.04.36s-.25.13-.36.04-.13-.25-.04-.36.25-.13.36-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.57,132.56c.11.09.13.24.04.35s-.24.13-.35.04-.13-.24-.04-.35.24-.13.35-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.32,132.13c.1.08.12.23.04.34s-.23.12-.34.04-.12-.23-.04-.34.23-.12.34-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.1,131.53c.1.08.12.22.04.32s-.22.12-.32.04-.12-.22-.04-.32.22-.12.32-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.94,130.77c.09.07.11.21.04.31s-.21.11-.31.04-.11-.21-.04-.31.21-.11.31-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.84,129.85c.09.07.11.2.03.29s-.2.11-.29.03-.11-.2-.03-.29.2-.11.29-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.82,128.77c.09.07.1.19.03.28s-.19.1-.28.03-.1-.19-.03-.28.19-.1.28-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.89,127.53c.08.06.1.18.03.26s-.18.1-.26.03-.1-.18-.03-.26.18-.1.26-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.06,126.16c.08.06.09.17.03.25s-.17.09-.25.03-.09-.17-.03-.25.17-.09.25-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.34,124.65c.07.06.08.16.03.23s-.16.08-.23.03-.08-.16-.03-.23.16-.08.23-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.74,123.01c.07.05.08.15.03.22s-.15.08-.22.03-.08-.15-.03-.22.15-.08.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.27,121.25c.06.05.07.14.02.2s-.14.07-.2.02-.07-.14-.02-.2.14-.07.2-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.95,119.39c.06.05.07.13.02.19s-.13.07-.19.02-.07-.13-.02-.19.13-.07.19-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.77,117.43c.05.04.06.12.02.17s-.12.06-.17.02-.06-.12-.02-.17.12-.06.17-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.74,115.38s.06.11.02.16-.11.06-.16.02-.06-.11-.02-.16.11-.06.16-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.88,113.27s.05.1.02.15-.1.05-.15.02-.05-.1-.02-.15.1-.05.15-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.17,111.1s.05.09.02.13-.09.05-.13.02-.05-.09-.02-.13.09-.05.13-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.59,
    cy: 108.94,
    r: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.28,106.62s.04.07.01.1-.07.04-.1.01-.04-.07-.01-.1.07-.04.1-.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.05,
    cy: 104.39,
    r: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.08,102.06s.03.05,0,.07-.05.03-.07,0-.03-.05,0-.07.05-.03.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.24,99.79s.02.04,0,.06-.04.02-.06,0-.02-.04,0-.06.04-.02.06,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.56,
    cy: 97.56,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.08,
    cy: 95.33,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.77,
    cy: 93.14,
    r: 0.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.97,
    cy: 100.93,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.24,
    cy: 98.48,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.69,
    cy: 96.06,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.32,
    cy: 93.68,
    r: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.14,
    cy: 91.35,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.13,
    cy: 89.1,
    r: 0.86,
    transform: "translate(12.99 196.41) rotate(-71.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.3,
    cy: 86.93,
    r: 0.85,
    transform: "translate(15.21 195.31) rotate(-70.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.63,
    cy: 84.85,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.11,
    cy: 82.89,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 149.74,
    cy: 81.04,
    r: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.5,
    cy: 79.32,
    r: 0.8,
    transform: "translate(26.01 195.5) rotate(-70.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.39,
    cy: 77.74,
    r: 0.79,
    transform: "translate(51.33 216.15) rotate(-80.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.39,
    cy: 76.31,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.5,
    cy: 75.04,
    r: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.7,
    cy: 73.93,
    r: 0.76,
    transform: "translate(51.15 212.44) rotate(-76.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.98,
    cy: 72.99,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.32,
    cy: 72.24,
    r: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.94,70.97c.38.13.59.54.46.92-.13.38-.54.59-.92.46s-.59-.54-.46-.92.54-.59.92-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.37,70.59c.37.12.58.53.46.9s-.53.58-.9.46c-.37-.12-.58-.53-.46-.9s.53-.58.9-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.82,70.4c.37.12.57.52.45.89s-.52.57-.89.45-.57-.52-.45-.89.52-.57.89-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.28,70.4c.36.12.56.51.44.87s-.51.56-.87.44c-.36-.12-.56-.51-.44-.87s.51-.56.87-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.74,70.58c.36.12.55.5.43.86s-.5.55-.86.43-.55-.5-.43-.86.5-.55.86-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.17,70.95c.35.12.54.49.43.85s-.49.54-.85.43-.54-.49-.43-.85.49-.54.85-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.57,71.51c.35.11.53.49.42.83s-.49.53-.83.42-.53-.49-.42-.83.49-.53.83-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.92,72.24c.34.11.52.48.41.82s-.48.52-.82.41-.52-.48-.41-.82.48-.52.82-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.2,73.16c.33.11.52.47.41.8s-.47.52-.8.41-.52-.47-.41-.8.47-.52.8-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.41,74.25c.33.11.51.46.4.79s-.46.51-.79.4-.51-.46-.4-.79c.11-.33.46-.51.79-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.53,75.51c.32.11.5.45.39.77s-.45.5-.77.39-.5-.45-.39-.77c.11-.32.45-.5.77-.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.36,
    cy: 77.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.46,78.49c.31.1.48.44.38.75s-.44.48-.75.38-.48-.44-.38-.75.44-.48.75-.38Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 196.06,
    cy: 80.75,
    r: 0.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.88,82.04c.3.1.46.42.36.72s-.42.46-.72.36c-.3-.1-.46-.42-.36-.72s.42-.46.72-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.39,84c.29.1.45.41.36.7s-.41.45-.7.36c-.29-.1-.45-.41-.36-.7s.41-.45.7-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.74,86.07c.29.09.44.4.35.69s-.4.44-.69.35c-.29-.09-.44-.4-.35-.69s.4-.44.69-.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.76,
    cy: 88.74,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.78,
    cy: 90.98,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.63,
    cy: 93.29,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.3,
    cy: 95.66,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.78,
    cy: 98.08,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.07,
    cy: 100.52,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.18,
    cy: 102.98,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.1,
    cy: 105.44,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.83,
    cy: 107.89,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.38,
    cy: 110.31,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.75,
    cy: 112.69,
    r: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.06,114.62c.22.07.33.3.26.52s-.3.33-.52.26-.33-.3-.26-.52.3-.33.52-.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.94,
    cy: 117.27,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.77,
    cy: 119.44,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.45,
    cy: 121.51,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.96,
    cy: 123.48,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 196.34,
    cy: 125.33,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.57,
    cy: 127.05,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.68,
    cy: 128.63,
    r: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.68,
    cy: 130.06,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.57,
    cy: 131.33,
    r: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.46,132.15c.16.05.24.22.19.38s-.22.24-.38.19-.24-.22-.19-.38.22-.24.38-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.18,133.1c.15.05.24.21.19.37s-.21.24-.37.19-.24-.21-.19-.37.21-.24.37-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.84,133.87c.15.05.23.21.18.35s-.21.23-.35.18-.23-.21-.18-.35.21-.23.35-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.44,134.45c.14.05.22.2.17.34s-.2.22-.34.17-.22-.2-.17-.34.2-.22.34-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177,134.85c.13.04.21.19.16.32s-.19.21-.32.16-.21-.19-.16-.32.19-.21.32-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.54,135.06c.13.04.2.18.16.31s-.18.2-.31.16-.2-.18-.16-.31.18-.2.31-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.08,135.09c.12.04.19.17.15.3s-.17.19-.3.15-.19-.17-.15-.3.17-.19.3-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.62,134.93c.12.04.18.16.14.28s-.16.18-.28.14-.18-.16-.14-.28.16-.18.28-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.18,134.58c.11.04.17.16.14.27s-.16.17-.27.14-.17-.16-.14-.27.16-.17.27-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.77,134.04c.11.03.16.15.13.25s-.15.16-.25.13-.16-.15-.13-.25.15-.16.25-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.41,133.33c.1.03.15.14.12.24s-.14.15-.24.12-.15-.14-.12-.24.14-.15.24-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.12,132.43c.09.03.14.13.11.23s-.13.14-.23.11-.14-.13-.11-.23.13-.14.23-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.9,131.36c.09.03.14.12.11.21s-.12.14-.21.11-.14-.12-.11-.21.12-.14.21-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.78,130.13c.08.03.13.12.1.2s-.12.13-.2.1-.13-.12-.1-.2.12-.13.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.75,128.73c.08.03.12.11.09.18s-.11.12-.18.09-.12-.11-.09-.18.11-.12.18-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.84,127.19c.07.02.11.1.09.17s-.1.11-.17.09-.11-.1-.09-.17.1-.11.17-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.05,125.5c.06.02.1.09.08.15s-.09.1-.15.08-.1-.09-.08-.15.09-.1.15-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.4,123.68c.06.02.09.08.07.14s-.08.09-.14.07-.09-.08-.07-.14.08-.09.14-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.89,121.74c.05.02.08.07.06.13s-.07.08-.13.06-.08-.07-.06-.13.07-.08.13-.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.51,
    cy: 119.78,
    r: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.34,117.55s.06.06.05.1-.06.06-.1.05-.06-.06-.05-.1.06-.06.1-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.29,
    cy: 115.38,
    r: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.46,113.02s.05.04.04.07-.04.05-.07.04-.05-.04-.04-.07.04-.05.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.79,110.66s.04.03.03.06-.03.04-.06.03-.04-.03-.03-.06.03-.04.06-.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.29,
    cy: 108.29,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141,
    cy: 105.84,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.89,
    cy: 103.38,
    r: 0.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.92,
    cy: 112.64,
    r: 0.98,
    transform: "translate(-2.57 222.02) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.28,
    cy: 110.07,
    r: 0.97,
    transform: "translate(-.56 219.44) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.85,
    cy: 107.46,
    r: 0.96,
    transform: "translate(1.65 217.02) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.62,
    cy: 104.82,
    r: 0.95,
    transform: "translate(4.03 214.78) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.59,
    cy: 102.17,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.76,
    cy: 99.53,
    r: 0.92,
    transform: "translate(14.12 216.26) rotate(-78.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.14,
    cy: 96.91,
    r: 0.91,
    transform: "translate(9.09 205.71) rotate(-74.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.72,
    cy: 94.33,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.49,
    cy: 91.79,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.46,
    cy: 89.33,
    r: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.61,
    cy: 86.94,
    r: 0.86,
    transform: "translate(21.13 201.57) rotate(-74.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.94,
    cy: 84.65,
    r: 0.85,
    transform: "translate(45.03 219.19) rotate(-84.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.44,
    cy: 82.47,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.1,
    cy: 80.41,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.91,
    cy: 78.48,
    r: 0.82,
    transform: "translate(55.27 218.35) rotate(-83.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.87,
    cy: 76.69,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.96,
    cy: 75.07,
    r: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.14,72.82c.43-.01.79.32.8.76.01.43-.32.79-.76.8s-.79-.32-.8-.76.32-.79.76-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.46,71.55c.42-.01.78.32.79.74s-.32.78-.74.79-.78-.32-.79-.74c-.01-.42.32-.78.74-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.86,70.46c.42-.01.77.31.78.73s-.31.77-.73.78-.77-.31-.78-.73.31-.77.73-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.35,69.55c.41-.01.75.31.77.72s-.31.75-.72.77-.75-.31-.77-.72.31-.75.72-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.89,68.83c.4-.01.74.3.75.71s-.3.74-.71.75-.74-.3-.75-.71.3-.74.71-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.49,68.31c.4-.01.73.3.74.7s-.3.73-.7.74c-.4.01-.73-.3-.74-.7s.3-.73.7-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.11,67.99c.39-.01.72.29.73.69s-.29.72-.69.73-.72-.29-.73-.69.29-.72.69-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.76,67.87c.38-.01.71.29.72.67s-.29.71-.67.72-.71-.29-.72-.67.29-.71.67-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.41,67.95c.38-.01.69.28.71.66s-.28.69-.66.71-.69-.28-.71-.66.28-.69.66-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.04,68.24c.37-.01.68.28.69.65.01.37-.28.68-.65.69s-.68-.28-.69-.65.28-.68.65-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.65,68.73c.36-.01.67.27.68.64s-.27.67-.64.68-.67-.27-.68-.64.27-.67.64-.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.23,
    cy: 70.07,
    r: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.71,70.3c.35-.01.64.26.66.62.01.35-.26.64-.62.66s-.64-.26-.66-.62.26-.64.62-.66Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.15,
    cy: 72,
    r: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.47,72.63c.34-.01.62.25.63.59s-.25.62-.59.63-.62-.25-.63-.59.25-.62.59-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.71,74.06c.33-.01.61.25.62.58.01.33-.25.61-.58.62-.33.01-.61-.25-.62-.58-.01-.33.25-.61.58-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.84,75.65c.32-.01.6.24.61.57s-.24.6-.57.61-.6-.24-.61-.57.24-.6.57-.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 196.85,
    cy: 77.98,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.71,
    cy: 79.86,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.42,
    cy: 81.89,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.96,
    cy: 84.04,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.34,
    cy: 86.3,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.54,
    cy: 88.66,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.55,
    cy: 91.11,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.37,
    cy: 93.63,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.01,
    cy: 96.2,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.44,
    cy: 98.81,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.67,
    cy: 101.45,
    r: 0.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.69,103.65c.25,0,.45.18.46.43s-.18.45-.43.46-.45-.18-.46-.43.18-.45.43-.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.53,
    cy: 106.74,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.15,
    cy: 109.36,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.57,
    cy: 111.94,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.8,
    cy: 114.48,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.83,
    cy: 116.94,
    r: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.68,
    cy: 119.33,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.35,
    cy: 121.62,
    r: 0.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.85,
    cy: 123.8,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.19,
    cy: 125.86,
    r: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.36,127.47c.18,0,.33.13.33.31s-.13.33-.31.33-.33-.13-.33-.31.13-.33.31-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.41,129.26c.17,0,.32.13.32.3s-.13.32-.3.32-.32-.13-.32-.3.13-.32.3-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.32,130.9c.17,0,.3.12.31.29s-.12.3-.29.31-.3-.12-.31-.29.12-.3.29-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.11,132.38c.16,0,.29.12.3.28s-.12.29-.28.3-.29-.12-.3-.28.12-.29.28-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.8,133.67c.15,0,.28.11.28.27s-.11.28-.27.28-.28-.11-.28-.27.11-.28.27-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.39,134.79c.15,0,.27.11.27.26s-.11.27-.26.27-.27-.11-.27-.26.11-.27.26-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.91,135.72c.14,0,.26.1.26.24s-.1.26-.24.26-.26-.1-.26-.24.1-.26.24-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.36,136.46c.13,0,.24.1.25.23s-.1.24-.23.25-.24-.1-.25-.23.1-.24.23-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.77,137.01c.13,0,.23.09.24.22s-.09.23-.22.24-.23-.09-.24-.22.09-.23.22-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.14,137.36c.12,0,.22.09.22.21s-.09.22-.21.22-.22-.09-.22-.21.09-.22.21-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.5,137.5c.11,0,.21.08.21.2s-.08.21-.2.21-.21-.08-.21-.2.08-.21.2-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.85,137.44c.11,0,.19.08.2.19s-.08.19-.19.2-.19-.08-.2-.19.08-.19.19-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.22,137.17c.1,0,.18.07.19.17s-.07.18-.17.19-.18-.07-.19-.17.07-.18.17-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.61,136.71c.09,0,.17.07.17.16s-.07.17-.16.17-.17-.07-.17-.16.07-.17.16-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.05,136.04c.09,0,.16.06.16.15s-.06.16-.15.16-.16-.06-.16-.15.06-.16.15-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.55,135.18c.08,0,.15.06.15.14s-.06.15-.14.15-.15-.06-.15-.14.06-.15.14-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.13,134.13c.07,0,.13.05.14.13s-.05.13-.13.14-.13-.05-.14-.13.05-.13.13-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.79,132.9c.07,0,.12.05.12.12s-.05.12-.12.12-.12-.05-.12-.12.05-.12.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.55,131.5c.06,0,.11.04.11.1s-.04.11-.1.11-.11-.04-.11-.1.04-.11.1-.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.43,
    cy: 130.03,
    r: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.43,128.2s.09.03.09.08-.03.09-.08.09-.09-.03-.09-.08.03-.09.08-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.58,
    cy: 126.4,
    r: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.87,124.32s.06.02.06.06-.02.06-.06.06-.06-.02-.06-.06.02-.06.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.32,122.18s.05.02.05.05-.02.05-.05.05-.05-.02-.05-.05.02-.05.05-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.95,
    cy: 119.96,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.75,
    cy: 117.6,
    r: 0.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.74,
    cy: 115.15,
    r: 0.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.16,
    cy: 124.87,
    r: 1.06,
    transform: "translate(-11.98 234.51) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.57,
    cy: 122.51,
    r: 1.05,
    transform: "translate(-10.89 231.16) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.17,
    cy: 120.03,
    r: 1.03,
    transform: "translate(-9.55 227.91) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.97,
    cy: 117.45,
    r: 1.02,
    transform: "translate(-7.97 224.76) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.96,
    cy: 114.78,
    r: 1.01,
    transform: "translate(-40.59 132.83) rotate(-45.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.17,
    cy: 112.05,
    r: 0.99,
    transform: "translate(16.62 241.81) rotate(-86.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.59,
    cy: 109.26,
    r: 0.98,
    transform: "translate(3.68 222.97) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.22,
    cy: 106.44,
    r: 0.97,
    transform: "translate(-24.47 170.19) rotate(-59.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.07,
    cy: 103.59,
    r: 0.96,
    transform: "translate(-22.29 168.17) rotate(-59.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.14,
    cy: 100.75,
    r: 0.94,
    transform: "translate(-20.01 166.33) rotate(-59.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.43,
    cy: 97.91,
    r: 0.93,
    transform: "translate(14.95 213.85) rotate(-79.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.93,
    cy: 95.11,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.64,
    cy: 92.35,
    r: 0.9,
    transform: "translate(-12.76 162.03) rotate(-58.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.56,
    cy: 89.66,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.68,
    cy: 87.04,
    r: 0.88,
    transform: "translate(-.62 1) rotate(-.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141,
    cy: 84.52,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.52,
    cy: 82.11,
    r: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.9,79.04c.43-.17.92.04,1.09.47.17.43-.04.92-.47,1.09-.43.17-.92-.04-1.09-.47s.04-.92.47-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.77,76.9c.42-.17.9.04,1.07.46s-.04.9-.46,1.07-.9-.04-1.07-.46.04-.9.46-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.8,74.91c.42-.17.89.04,1.06.45.17.42-.04.89-.45,1.06s-.89-.04-1.06-.45.04-.89.45-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.97,73.08c.41-.16.88.04,1.04.45.16.41-.04.88-.45,1.04s-.88-.04-1.04-.45.04-.88.45-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.28,71.42c.4-.16.86.03,1.02.44.16.4-.03.86-.44,1.02s-.86-.03-1.02-.44.03-.86.44-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.71,69.94c.4-.16.85.03,1.01.43s-.03.85-.43,1.01-.85-.03-1.01-.43.03-.85.43-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.25,68.64c.39-.16.83.03.99.42.16.39-.03.83-.42.99s-.83-.03-.99-.42.03-.83.42-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.88,67.55c.38-.15.82.03.97.42s-.03.82-.42.97-.82-.03-.97-.42.03-.82.42-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M162.58,66.66c.38-.15.81.03.96.41s-.03.81-.41.96-.81-.03-.96-.41.03-.81.41-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.35,65.99c.37-.15.79.03.94.4s-.03.79-.4.94-.79-.03-.94-.4.03-.79.4-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.16,65.52c.36-.15.78.03.92.4.15.36-.03.78-.4.92s-.78-.03-.92-.4.03-.78.4-.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.26,
    cy: 65.93,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.86,65.25c.35-.14.75.03.89.38s-.03.75-.38.89-.75-.03-.89-.38.03-.75.38-.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.95,
    cy: 66.06,
    r: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.53,65.85c.34-.14.72.03.86.37s-.03.72-.37.86-.72-.03-.86-.37c-.13-.34.03-.72.37-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.31,66.46c.33-.13.71.03.84.36.13.33-.03.71-.36.84s-.71-.03-.84-.36.03-.71.36-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.05,67.29c.32-.13.69.03.82.35s-.03.69-.35.82-.69-.03-.82-.35.03-.69.35-.82Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.94,
    cy: 68.9,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.51,
    cy: 70.13,
    r: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.98,
    cy: 71.54,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.33,
    cy: 73.15,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.55,
    cy: 74.93,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.63,
    cy: 76.88,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.56,
    cy: 78.97,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.31,
    cy: 81.22,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.9,
    cy: 83.58,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.3,
    cy: 86.06,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.5,
    cy: 88.64,
    r: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.33,90.86c.24-.1.52.02.62.27.1.24-.02.52-.27.62s-.52-.02-.62-.27.02-.52.27-.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.3,
    cy: 94.04,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.88,
    cy: 96.83,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.25,
    cy: 99.65,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.4,
    cy: 102.49,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.33,
    cy: 105.34,
    r: 0.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.04,
    cy: 108.17,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.54,
    cy: 110.98,
    r: 0.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 208.83,
    cy: 113.73,
    r: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.91,
    cy: 116.43,
    r: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.66,118.72c.18-.07.38.02.45.19s-.02.38-.19.45-.38-.02-.45-.19.02-.38.19-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.34,121.26c.17-.07.37.01.44.19s-.01.37-.19.44-.37-.01-.44-.19.01-.37.19-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.83,123.68c.17-.07.35.01.42.18s-.01.35-.18.42-.35-.01-.42-.18.01-.35.18-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.14,125.98c.16-.06.34.01.4.17s-.01.34-.17.4-.34-.01-.4-.17.01-.34.17-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.28,128.15c.15-.06.32.01.39.17s-.01.32-.17.39-.32-.01-.39-.17.01-.32.17-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.26,130.16c.15-.06.31.01.37.16s-.01.31-.16.37-.31-.01-.37-.16.01-.31.16-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.1,132.01c.14-.06.3.01.35.15s-.01.3-.15.35-.3-.01-.35-.15.01-.3.15-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.8,133.7c.13-.05.28.01.34.14s-.01.28-.14.34-.28-.01-.34-.14.01-.28.14-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.38,135.2c.13-.05.27.01.32.14s-.01.27-.14.32-.27-.01-.32-.14.01-.27.14-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.85,136.52c.12-.05.25.01.3.13s-.01.25-.13.3-.25-.01-.3-.13.01-.25.13-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.23,137.64c.11-.05.24,0,.29.12s0,.24-.12.29-.24,0-.29-.12,0-.24.12-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.53,138.55c.11-.04.23,0,.27.12s0,.23-.12.27-.23,0-.27-.12,0-.23.12-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.78,139.25c.1-.04.21,0,.25.11s0,.21-.11.25-.21,0-.25-.11,0-.21.11-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.97,139.73c.09-.04.2,0,.23.1s0,.2-.1.23-.2,0-.23-.1,0-.2.1-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.14,140c.09-.03.18,0,.22.09s0,.18-.09.22-.18,0-.22-.09,0-.18.09-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.3,140.05c.08-.03.17,0,.2.09s0,.17-.09.2-.17,0-.2-.09,0-.17.09-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.46,139.89c.07-.03.16,0,.18.08s0,.16-.08.18-.16,0-.18-.08,0-.16.08-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.65,139.51c.07-.03.14,0,.17.07s0,.14-.07.17-.14,0-.17-.07,0-.14.07-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.87,138.91c.06-.02.13,0,.15.06s0,.13-.06.15-.13,0-.15-.06,0-.13.06-.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.19,
    cy: 138.2,
    r: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.49,137.09s.1,0,.12.05,0,.1-.05.12-.1,0-.12-.05,0-.1.05-.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.96,
    cy: 135.96,
    r: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.46,134.48s.07,0,.08.04,0,.07-.04.08-.07,0-.08-.04,0-.07.04-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.12,132.89s.06,0,.07.03,0,.06-.03.07-.06,0-.07-.03,0-.06.03-.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.91,
    cy: 131.15,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.83,
    cy: 129.21,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.91,
    cy: 127.11,
    r: 0.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.93,
    cy: 136.04,
    r: 1.14,
    transform: "translate(-16.89 250.59) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.46,
    cy: 134.23,
    r: 1.12,
    transform: "translate(-17.02 246.81) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146.13,
    cy: 132.24,
    r: 1.11,
    transform: "translate(-16.86 243.03) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.97,
    cy: 130.08,
    r: 1.1,
    transform: "translate(-16.42 239.27) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.97,
    cy: 127.75,
    r: 1.08,
    transform: "translate(-42.2 178.3) rotate(-57.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.16,
    cy: 125.28,
    r: 1.07,
    transform: "translate(-6.28 7.4) rotate(-2.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.55,
    cy: 122.68,
    r: 1.05,
    transform: "translate(-.14 245.2) rotate(-82.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.14,
    cy: 119.96,
    r: 1.04,
    transform: "translate(-27.55 197.9) rotate(-66.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.95,
    cy: 117.14,
    r: 1.03,
    transform: "translate(-25.8 194.87) rotate(-66.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.97,
    cy: 114.24,
    r: 1.01,
    transform: "translate(-23.85 191.99) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.21,
    cy: 111.27,
    r: 1,
    transform: "translate(8.04 231.58) rotate(-83.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.69,
    cy: 108.26,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.4,
    cy: 105.21,
    r: 0.97,
    transform: "translate(-16.9 184.43) rotate(-66.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.33,
    cy: 102.15,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.51,
    cy: 99.09,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.91,
    cy: 96.06,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.55,
    cy: 93.06,
    r: 0.92,
    transform: "translate(-14.35 160.83) rotate(-59.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.82,89.45c.37-.33.94-.3,1.27.07s.3.94-.07,1.27-.94.3-1.27-.07-.3-.94.07-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.92,86.6c.37-.33.93-.3,1.25.07s.3.93-.07,1.25-.93.3-1.25-.07c-.33-.37-.3-.93.07-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.24,83.85c.36-.32.91-.29,1.23.07.32.36.29.91-.07,1.23s-.91.29-1.23-.07-.29-.91.07-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.77,81.2c.35-.32.9-.29,1.21.07s.29.9-.07,1.21-.9.29-1.21-.07-.29-.9.07-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.49,78.67c.35-.31.88-.28,1.2.07.31.35.28.88-.07,1.2-.35.31-.88.28-1.2-.07s-.28-.88.07-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.4,76.28c.34-.31.87-.28,1.18.07s.28.87-.07,1.18-.87.28-1.18-.07-.28-.87.07-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144.49,74.04c.34-.3.85-.27,1.16.06s.27.85-.06,1.16c-.34.3-.85.27-1.16-.06s-.27-.85.06-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.74,71.97c.33-.3.84-.27,1.14.06.3.33.27.84-.06,1.14s-.84.27-1.14-.06-.27-.84.06-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.15,70.08c.33-.29.83-.26,1.12.06s.26.83-.06,1.12-.83.26-1.12-.06-.26-.83.06-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.7,68.37c.32-.29.81-.26,1.1.06s.26.81-.06,1.1-.81.26-1.1-.06-.26-.81.06-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.37,66.87c.31-.28.8-.25,1.08.06s.25.8-.06,1.08-.8.25-1.08-.06-.25-.8.06-1.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.65,
    cy: 66.14,
    r: 0.75,
    transform: "translate(22.02 170.22) rotate(-60.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.02,64.5c.3-.27.77-.24,1.04.06.27.3.24.77-.06,1.04-.3.27-.77.24-1.04-.06s-.24-.77.06-1.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.45,
    cy: 64.19,
    r: 0.72,
    transform: "translate(34.13 182.98) rotate(-64.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.97,63.02c.29-.26.74-.24,1,.06s.24.74-.06,1-.74.24-1-.06-.24-.74.06-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.01,62.62c.29-.26.72-.23.98.05s.23.72-.05.98-.72.23-.98-.05c-.26-.29-.23-.72.05-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.08,62.45c.28-.25.71-.23.96.05.25.28.23.71-.05.96s-.71.23-.96-.05-.23-.71.05-.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.59,
    cy: 63.02,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.64,
    cy: 63.31,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.66,
    cy: 63.83,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.63,
    cy: 64.59,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.53,
    cy: 65.57,
    r: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.34,
    cy: 66.77,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.06,
    cy: 68.18,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.66,
    cy: 69.8,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.13,
    cy: 71.61,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.46,
    cy: 73.6,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.62,
    cy: 75.76,
    r: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.27,77.7c.21-.19.54-.17.73.04s.17.54-.04.72-.54.17-.72-.04-.17-.54.04-.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.42,
    cy: 80.56,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 208.04,
    cy: 83.16,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.45,
    cy: 85.88,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.64,
    cy: 88.7,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.62,
    cy: 91.6,
    r: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 212.37,
    cy: 94.57,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 212.9,
    cy: 97.58,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 213.19,
    cy: 100.63,
    r: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 213.25,
    cy: 103.69,
    r: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.83,106.47c.15-.14.39-.12.53.03s.12.39-.03.53-.39.12-.53-.03-.12-.39.03-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.43,109.51c.15-.13.38-.12.51.03s.12.38-.03.51-.38.12-.51-.03-.12-.38.03-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.8,112.52c.14-.13.36-.12.49.03s.12.36-.03.49-.36.12-.49-.03-.12-.36.03-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.94,115.46c.14-.12.35-.11.47.03s.11.35-.03.47-.35.11-.47-.03-.11-.35.03-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.85,118.33c.13-.12.33-.11.45.03s.11.33-.03.45-.33.11-.45-.03-.11-.33.03-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.55,121.11c.13-.11.32-.1.43.02s.1.32-.02.43-.32.1-.43-.02-.1-.32.02-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.05,123.78c.12-.11.3-.1.41.02s.1.3-.02.41-.3.1-.41-.02-.1-.3.02-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.34,126.33c.11-.1.29-.09.39.02s.09.29-.02.39-.29.09-.39-.02-.09-.29.02-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.45,128.74c.11-.1.28-.09.37.02s.09.28-.02.37-.28.09-.37-.02-.09-.28.02-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.38,131c.1-.09.26-.08.35.02s.08.26-.02.35-.26.08-.35-.02-.08-.26.02-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.15,133.09c.1-.09.25-.08.33.02s.08.25-.02.33-.25.08-.33-.02-.08-.25.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.76,135c.09-.08.23-.07.31.02s.07.23-.02.31-.23.07-.31-.02-.07-.23.02-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.23,136.73c.09-.08.22-.07.29.02s.07.22-.02.29-.22.07-.29-.02-.07-.22.02-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.57,138.25c.08-.07.2-.06.27.02s.06.2-.02.27-.2.06-.27-.02-.06-.2.02-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.81,139.56c.07-.07.19-.06.25.01s.06.19-.01.25-.19.06-.25-.01-.06-.19.01-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.96,140.66c.07-.06.17-.06.24.01s.06.17-.01.24-.17.06-.24-.01-.06-.17.01-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.03,141.53c.06-.06.16-.05.22.01s.05.16-.01.22-.16.05-.22-.01-.05-.16.01-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.05,142.18c.06-.05.14-.05.2.01s.05.14-.01.2-.14.05-.2-.01-.05-.14.01-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.02,142.6c.05-.05.13-.04.18,0s.04.13,0,.18-.13.04-.18,0-.04-.13,0-.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.05,
    cy: 142.87,
    r: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.92,142.75s.1-.03.14,0,.03.1,0,.14-.1.03-.14,0-.03-.1,0-.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.94,
    cy: 142.53,
    r: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.88,141.95s.07-.02.1,0,.02.07,0,.1-.07.02-.1,0-.02-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.92,141.21s.06-.02.08,0,.02.06,0,.08-.06.02-.08,0-.02-.06,0-.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.06,
    cy: 140.27,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.24,
    cy: 139.06,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.52,
    cy: 137.65,
    r: 0.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.89,
    cy: 144.46,
    r: 1.22,
    transform: "translate(-15.94 268.64) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.73,
    cy: 143.54,
    r: 1.21,
    transform: "translate(-17.46 264.87) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.65,
    cy: 142.38,
    r: 1.19,
    transform: "translate(-18.69 260.99) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.66,
    cy: 141,
    r: 1.18,
    transform: "translate(-19.62 257.03) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.79,
    cy: 139.38,
    r: 1.16,
    transform: "translate(-34.29 228.32) rotate(-68.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.05,
    cy: 137.55,
    r: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.47,
    cy: 135.51,
    r: 1.13,
    transform: "translate(-2.81 267.95) rotate(-84.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.04,
    cy: 133.29,
    r: 1.12,
    transform: "translate(-24.08 234.75) rotate(-74.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.8,
    cy: 130.88,
    r: 1.1,
    transform: "translate(-23.43 230.79) rotate(-74.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.74,
    cy: 128.31,
    r: 1.09,
    transform: "translate(-22.48 226.89) rotate(-74.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.89,
    cy: 125.58,
    r: 1.07,
    transform: "translate(.33 251.53) rotate(-85.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.25,
    cy: 122.73,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.83,
    cy: 119.76,
    r: 1.04,
    transform: "translate(-17.92 215.8) rotate(-74.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 132.65,
    cy: 116.69,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.7,
    cy: 113.53,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.99,
    cy: 110.32,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.54,
    cy: 107.06,
    r: 0.98,
    transform: "translate(-17.73 187.8) rotate(-67.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.48,103.31c.25-.47.84-.65,1.31-.4s.65.84.4,1.31c-.25.47-.84.65-1.31.4s-.65-.84-.4-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.55,100.03c.25-.46.83-.64,1.29-.39.46.25.64.83.39,1.29s-.83.64-1.29.39-.64-.83-.39-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.87,96.76c.25-.46.82-.63,1.27-.38s.63.82.38,1.27-.82.63-1.27.38-.63-.82-.38-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.43,93.52c.24-.45.8-.62,1.25-.38s.62.8.38,1.25-.8.62-1.25.38-.62-.8-.38-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.24,90.33c.24-.44.79-.61,1.23-.37s.61.79.37,1.23-.79.61-1.23.37-.61-.79-.37-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.3,87.22c.23-.44.78-.6,1.21-.37s.6.78.37,1.21-.78.6-1.21.37-.6-.78-.37-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.58,84.19c.23-.43.76-.59,1.19-.36s.59.76.36,1.19c-.23.43-.76.59-1.19.36s-.59-.76-.36-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.1,81.26c.23-.42.75-.58,1.17-.35s.58.75.35,1.17-.75.58-1.17.35-.58-.75-.35-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.83,78.47c.22-.41.74-.57,1.15-.35s.57.74.35,1.15-.74.57-1.15.35-.57-.74-.35-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.78,75.81c.22-.41.72-.56,1.13-.34.41.22.56.72.34,1.13s-.72.56-1.13.34-.56-.72-.34-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.93,73.31c.21-.4.71-.55,1.11-.34s.55.71.34,1.11-.71.55-1.11.34-.55-.71-.34-1.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.97,
    cy: 71.36,
    r: 0.81,
    transform: "translate(25.36 179.77) rotate(-68.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M145.77,68.84c.21-.38.69-.53,1.07-.32s.53.69.32,1.07-.69.53-1.07.32-.53-.69-.32-1.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 149.11,
    cy: 67.26,
    r: 0.78,
    transform: "translate(37.75 187.08) rotate(-71.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.23,65.15c.2-.37.66-.51,1.03-.31s.51.66.31,1.03c-.2.37-.66.51-1.03.31s-.51-.66-.31-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.16,63.63c.19-.36.65-.5,1.01-.3s.5.65.3,1.01-.65.5-1.01.3-.5-.65-.3-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.2,62.33c.19-.36.63-.49.99-.3.36.19.49.63.3.99s-.63.49-.99.3-.49-.63-.3-.99Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.96,
    cy: 61.61,
    r: 0.72,
    transform: "translate(52.69 195.7) rotate(-72.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.14,
    cy: 60.78,
    r: 0.7,
    transform: "translate(57.03 199.21) rotate(-72.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.38,
    cy: 60.2,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.66,
    cy: 59.87,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.95,
    cy: 59.8,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.24,
    cy: 59.97,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.5,
    cy: 60.41,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.72,
    cy: 61.08,
    r: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.89,
    cy: 62,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.97,
    cy: 63.16,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.95,
    cy: 64.55,
    r: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.34,65.9c.14-.27.48-.37.75-.23s.37.48.23.75c-.14.27-.48.37-.75.23s-.37-.48-.23-.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.56,
    cy: 67.99,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.15,
    cy: 70.03,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.57,
    cy: 72.26,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.81,
    cy: 74.67,
    r: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.87,
    cy: 77.24,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.72,
    cy: 79.96,
    r: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.36,
    cy: 82.81,
    r: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 212.78,
    cy: 85.79,
    r: 0.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 213.96,
    cy: 88.86,
    r: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.56,91.82c.11-.2.35-.27.55-.16s.27.35.16.55-.35.27-.55.16-.27-.35-.16-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.28,95.04c.1-.19.34-.26.53-.16s.26.34.16.53-.34.26-.53.16-.26-.34-.16-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.74,98.31c.1-.18.32-.25.51-.15s.25.32.15.51-.32.25-.51.15-.25-.32-.15-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.96,101.6c.09-.17.31-.24.48-.15s.24.31.15.48-.31.24-.48.15-.24-.31-.15-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.92,104.9c.09-.17.3-.23.46-.14s.23.3.14.46-.3.23-.46.14-.23-.3-.14-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.63,108.19c.09-.16.28-.22.44-.13s.22.28.13.44-.28.22-.44.13-.22-.28-.13-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.08,111.44c.08-.15.27-.21.42-.13s.21.27.13.42-.27.21-.42.13-.21-.27-.13-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.3,114.64c.08-.15.26-.2.4-.12s.2.26.12.4-.26.2-.4.12-.2-.26-.12-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.27,117.77c.07-.14.25-.19.38-.12s.19.25.12.38-.25.19-.38.12-.19-.25-.12-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.01,120.81c.07-.13.23-.18.36-.11s.18.23.11.36-.23.18-.36.11-.18-.23-.11-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.52,123.75c.07-.12.22-.17.34-.1s.17.22.1.34-.22.17-.34.1-.17-.22-.1-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.81,126.56c.06-.12.21-.16.32-.1s.16.21.1.32-.21.16-.32.1-.16-.21-.1-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.89,129.23c.06-.11.19-.15.3-.09s.15.19.09.3-.19.15-.3.09-.15-.19-.09-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.77,131.75c.05-.1.18-.14.28-.09s.14.18.09.28-.18.14-.28.09-.14-.18-.09-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.46,134.09c.05-.09.17-.13.26-.08s.13.17.08.26-.17.13-.26.08-.13-.17-.08-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.98,136.25c.05-.09.16-.12.24-.07s.12.16.07.24-.16.12-.24.07-.12-.16-.07-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.35,138.21c.04-.08.14-.11.22-.07s.11.14.07.22-.14.11-.22.07-.11-.14-.07-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.57,139.96c.04-.07.13-.1.2-.06s.1.13.06.2-.13.1-.2.06-.1-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.67,141.5c.04-.07.12-.09.18-.05s.09.12.05.18-.12.09-.18.05-.09-.12-.05-.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.76,
    cy: 142.87,
    r: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.56,143.89c.03-.05.09-.07.14-.04s.07.09.04.14-.09.07-.14.04-.07-.09-.04-.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.46,
    cy: 144.76,
    r: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.16,145.31s.06-.05.1-.03.05.06.03.1-.06.05-.1.03-.05-.06-.03-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.89,145.64s.05-.04.08-.02.04.05.02.08-.05.04-.08.02-.04-.05-.02-.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.65,
    cy: 145.74,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.37,
    cy: 145.56,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.1,
    cy: 145.13,
    r: 0.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.07,
    cy: 148.57,
    r: 1.32,
    transform: "translate(-8.33 286.54) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.54,
    cy: 148.8,
    r: 1.3,
    transform: "translate(-11.26 283.28) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171,
    cy: 148.77,
    r: 1.28,
    transform: "translate(-13.93 279.82) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.47,
    cy: 148.47,
    r: 1.27,
    transform: "translate(-16.33 276.16) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.98,
    cy: 147.89,
    r: 1.25,
    transform: "translate(-11.75 281.61) rotate(-79.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.54,
    cy: 147.05,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.18,
    cy: 145.94,
    r: 1.22,
    transform: "translate(-8.38 282.3) rotate(-82.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.91,
    cy: 144.58,
    r: 1.2,
    transform: "translate(-10.41 277.21) rotate(-82.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.76,
    cy: 142.97,
    r: 1.19,
    transform: "translate(-11.43 272.83) rotate(-82.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.73,
    cy: 141.13,
    r: 1.17,
    transform: "translate(-12.11 268.38) rotate(-82.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.86,
    cy: 139.06,
    r: 1.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.15,
    cy: 136.78,
    r: 1.14,
    transform: "translate(-38.28 216.53) rotate(-67.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.63,
    cy: 134.3,
    r: 1.12,
    transform: "translate(-12.03 254.85) rotate(-82.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.3,
    cy: 131.63,
    r: 1.11,
    transform: "translate(-29.95 222.21) rotate(-72.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.18,
    cy: 128.79,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.29,
    cy: 125.8,
    r: 1.08,
    transform: "translate(-27.4 213.97) rotate(-72.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.63,
    cy: 122.68,
    r: 1.06,
    transform: "translate(-17.55 223.28) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.18,119.28c.08-.57.61-.97,1.18-.88.57.08.97.61.88,1.18-.08.57-.61.97-1.18.88s-.97-.61-.88-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.04,115.94c.08-.56.6-.95,1.16-.87.56.08.95.6.87,1.16-.08.56-.6.95-1.16.87s-.95-.6-.87-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.16,112.52c.08-.55.59-.94,1.14-.86s.94.59.86,1.14c-.08.55-.59.94-1.14.86s-.94-.59-.86-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.54,109.04c.08-.54.58-.92,1.13-.84s.92.58.84,1.13-.58.92-1.13.84c-.54-.08-.92-.58-.84-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.19,105.52c.08-.54.57-.91,1.11-.83.54.08.91.57.83,1.11s-.57.91-1.11.83-.91-.57-.83-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.11,101.98c.08-.53.56-.89,1.09-.82s.89.56.82,1.09-.56.89-1.09.82-.89-.56-.82-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.29,98.45c.07-.52.55-.88,1.07-.8.52.07.88.55.8,1.07-.07.52-.55.88-1.07.8s-.88-.55-.8-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.75,94.94c.07-.51.55-.86,1.05-.79.51.07.86.55.79,1.05s-.55.86-1.05.79-.86-.55-.79-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.47,91.47c.07-.5.54-.85,1.04-.77s.85.54.77,1.04c-.07.5-.54.85-1.04.77s-.85-.54-.77-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.47,88.07c.07-.49.53-.83,1.02-.76s.83.53.76,1.02-.53.83-1.02.76-.83-.53-.76-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.72,84.76c.07-.48.52-.82,1-.75.48.07.82.52.75,1s-.52.82-1,.75-.82-.52-.75-1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 132.08,
    cy: 81.67,
    r: 0.87,
    transform: "translate(23.97 193.15) rotate(-77.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.96,78.46c.07-.46.5-.79.96-.72s.79.5.72.96-.5.79-.96.72-.79-.5-.72-.96Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.76,
    cy: 75.63,
    r: 0.83,
    transform: "translate(35.86 194.67) rotate(-79.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.13,72.72c.06-.45.48-.76.93-.69s.76.48.69.93-.48.76-.93.69-.76-.48-.69-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.53,70.1c.06-.44.47-.74.91-.68s.74.47.68.91-.47.74-.91.68-.74-.47-.68-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.12,67.68c.06-.43.46-.73.89-.67s.73.46.67.89-.46.73-.89.67-.73-.46-.67-.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.65,
    cy: 65.56,
    r: 0.77,
    transform: "translate(51.36 194.49) rotate(-78.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.56,
    cy: 63.56,
    r: 0.75,
    transform: "translate(55.65 195.76) rotate(-78.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.62,
    cy: 61.78,
    r: 0.74,
    transform: "translate(57.79 195.95) rotate(-77.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.81,
    cy: 60.24,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.11,
    cy: 58.96,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.5,
    cy: 57.93,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.96,
    cy: 57.16,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.46,
    cy: 56.66,
    r: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.99,
    cy: 56.43,
    r: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.53,
    cy: 56.46,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.06,
    cy: 56.77,
    r: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.97,57.26c.05-.32.35-.55.67-.5s.55.35.5.67-.35.55-.67.5-.55-.35-.5-.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.99,
    cy: 58.19,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.35,
    cy: 59.29,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.62,
    cy: 60.66,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.77,
    cy: 62.26,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.8,
    cy: 64.11,
    r: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.67,
    cy: 66.18,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.38,
    cy: 68.46,
    r: 0.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.9,
    cy: 70.94,
    r: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.23,
    cy: 73.6,
    r: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.92,76.38c.03-.24.25-.4.49-.37s.4.25.37.49-.25.4-.49.37-.4-.25-.37-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.83,79.37c.03-.23.24-.39.47-.35s.39.24.35.47-.24.39-.47.35-.39-.24-.35-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.5,82.5c.03-.22.23-.37.45-.34s.37.23.34.45-.23.37-.45.34-.37-.23-.34-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.93,85.75c.03-.21.23-.36.44-.33s.36.23.33.44-.23.36-.44.33-.36-.23-.33-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.1,89.1c.03-.2.22-.34.42-.31s.34.22.31.42c-.03.2-.22.34-.42.31s-.34-.22-.31-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.02,92.53c.03-.19.21-.33.4-.3s.33.21.3.4-.21.33-.4.3-.33-.21-.3-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.67,96.01c.03-.18.2-.31.38-.29s.31.2.29.38-.2.31-.38.29-.31-.2-.29-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.05,99.53c.03-.18.19-.3.36-.27s.3.19.27.36-.19.3-.36.27-.3-.19-.27-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.17,103.07c.02-.17.18-.28.35-.26s.28.18.26.35-.18.28-.35.26-.28-.18-.26-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.01,106.61c.02-.16.17-.27.33-.24s.27.17.24.33-.17.27-.33.24-.27-.17-.24-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.59,110.13c.02-.15.16-.25.31-.23s.25.16.23.31-.16.25-.31.23-.25-.16-.23-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.89,113.6c.02-.14.15-.24.29-.22s.24.15.22.29-.15.24-.29.22-.24-.15-.22-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.93,117c.02-.13.14-.22.27-.2s.22.14.2.27-.14.22-.27.2-.22-.14-.2-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.71,120.32c.02-.12.13-.21.25-.19s.21.13.19.25-.13.21-.25.19-.21-.13-.19-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.24,123.54c.02-.11.12-.19.24-.18s.19.12.18.24-.12.19-.24.18-.19-.12-.18-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.53,126.63c.02-.11.11-.18.22-.16s.18.11.16.22-.11.18-.22.16-.18-.11-.16-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.59,129.58c.01-.1.1-.16.2-.15s.16.1.15.2-.1.16-.2.15-.16-.1-.15-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.43,132.38c.01-.09.09-.15.18-.14s.15.09.14.18-.09.15-.18.14-.15-.09-.14-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.06,135c.01-.08.08-.13.16-.12s.13.08.12.16-.08.13-.16.12-.13-.08-.12-.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.63,
    cy: 137.45,
    r: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.76,139.65c0-.06.07-.1.13-.1s.1.07.1.13-.07.1-.13.1-.1-.07-.1-.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 197.96,
    cy: 141.68,
    r: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.82,143.44s.05-.07.09-.07.07.05.07.09-.05.07-.09.07-.07-.05-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.65,144.98s.04-.06.07-.05.06.04.05.07-.04.06-.07.05-.06-.04-.05-.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.41,
    cy: 146.28,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.02,
    cy: 147.3,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.57,
    cy: 148.07,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.92,
    cy: 147.14,
    r: 1.41,
    transform: "translate(5.93 301.82) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.44,
    cy: 148.68,
    r: 1.4,
    transform: "translate(1.77 299.61) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.85,
    cy: 149.94,
    r: 1.38,
    transform: "translate(-2.2 297.09) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.17,
    cy: 150.93,
    r: 1.36,
    transform: "translate(-5.97 294.27) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.43,
    cy: 151.64,
    r: 1.35,
    transform: "translate(-.74 .88) rotate(-.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.65,
    cy: 152.05,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.84,
    cy: 152.17,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.04,
    cy: 151.99,
    r: 1.29,
    transform: "translate(15.79 319.9) rotate(-89.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.26,
    cy: 151.53,
    r: 1.28,
    transform: "translate(12.86 315.99) rotate(-89.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.53,
    cy: 150.78,
    r: 1.26,
    transform: "translate(10.26 311.85) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.87,
    cy: 149.74,
    r: 1.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.29,
    cy: 148.43,
    r: 1.22,
    transform: "translate(-41.06 236.05) rotate(-68.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.83,
    cy: 146.86,
    r: 1.21,
    transform: "translate(-.56 .58) rotate(-.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.5,
    cy: 145.02,
    r: 1.19,
    transform: "translate(-36.13 240.23) rotate(-71.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.31,
    cy: 142.93,
    r: 1.17,
    transform: "translate(-52.77 192.07) rotate(-58.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.3,
    cy: 140.61,
    r: 1.16,
    transform: "translate(-36.42 230.9) rotate(-71.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.47,
    cy: 138.06,
    r: 1.14,
    transform: "translate(-8.89 266.59) rotate(-86.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.75,135.53c-.13-.61.26-1.2.87-1.33s1.2.26,1.33.87c.13.61-.26,1.2-.87,1.33s-1.2-.26-1.33-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.37,132.57c-.12-.6.26-1.18.86-1.31s1.18.26,1.31.86-.26,1.18-.86,1.31c-.6.12-1.18-.26-1.31-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.22,129.44c-.12-.59.25-1.16.84-1.29s1.16.25,1.29.84-.25,1.16-.84,1.29-1.16-.25-1.29-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.32,126.15c-.12-.58.25-1.14.83-1.27.58-.12,1.14.25,1.27.83.12.58-.25,1.14-.83,1.27-.58.12-1.14-.25-1.27-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.67,122.72c-.12-.57.25-1.13.81-1.25s1.13.25,1.25.81c.12.57-.25,1.13-.81,1.25s-1.13-.25-1.25-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.28,119.18c-.12-.56.24-1.11.8-1.22s1.11.24,1.22.8-.24,1.11-.8,1.22-1.11-.24-1.22-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.17,115.54c-.11-.55.24-1.09.79-1.2s1.09.24,1.2.79c.11.55-.24,1.09-.79,1.2s-1.09-.24-1.2-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.34,111.82c-.11-.54.23-1.07.77-1.18s1.07.23,1.18.77c.11.54-.23,1.07-.77,1.18s-1.07-.23-1.18-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.8,108.06c-.11-.53.23-1.05.76-1.16s1.05.23,1.16.76-.23,1.05-.76,1.16-1.05-.23-1.16-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.55,104.25c-.11-.52.23-1.03.75-1.14s1.03.23,1.14.75c.11.52-.23,1.03-.75,1.14s-1.03-.23-1.14-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.6,100.44c-.11-.51.22-1.02.73-1.12s1.02.22,1.12.73-.22,1.02-.73,1.12-1.02-.22-1.12-.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.84,
    cy: 96.46,
    r: 0.93,
    transform: "translate(19.78 213.98) rotate(-86.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M123.56,92.89c-.1-.49.21-.98.71-1.08s.98.21,1.08.71c.1.49-.21.98-.71,1.08s-.98-.21-1.08-.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 125.35,
    cy: 89,
    r: 0.9,
    transform: "translate(29.19 208.94) rotate(-86.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.66,85.56c-.1-.48.21-.94.68-1.04s.94.21,1.04.68-.21.94-.68,1.04-.94-.21-1.04-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.12,82.03c-.1-.47.2-.92.67-1.02s.92.2,1.02.67-.2.92-.67,1.02c-.47.1-.92-.2-1.02-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.84,78.63c-.1-.46.2-.9.65-1s.9.2,1,.65-.2.9-.65,1-.9-.2-1-.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.64,
    cy: 75.19,
    r: 0.83,
    transform: "translate(42.75 198) rotate(-83.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 133.84,
    cy: 72.09,
    r: 0.81,
    transform: "translate(46.51 196.53) rotate(-83.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.28,
    cy: 69.17,
    r: 0.79,
    transform: "translate(48.28 194.12) rotate(-81.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.94,
    cy: 66.45,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.8,
    cy: 63.93,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.84,
    cy: 61.65,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 148.06,
    cy: 59.6,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.41,
    cy: 57.81,
    r: 0.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.89,
    cy: 56.27,
    r: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.48,
    cy: 55.01,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.16,
    cy: 54.02,
    r: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.28,53.45c-.07-.35.15-.68.49-.76s.68.15.76.49c.07.35-.15.68-.49.76s-.68-.15-.76-.49Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.69,
    cy: 52.9,
    r: 0.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.49,
    cy: 52.79,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.29,
    cy: 52.96,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.07,
    cy: 53.42,
    r: 0.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.8,
    cy: 54.18,
    r: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.47,
    cy: 55.21,
    r: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.04,
    cy: 56.52,
    r: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.5,
    cy: 58.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.84,
    cy: 59.94,
    r: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.56,62.12c-.05-.25.11-.5.36-.55s.5.11.55.36-.11.5-.36.55-.5-.11-.55-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.59,64.44c-.05-.24.1-.48.35-.53s.48.1.53.35-.1.48-.35.53-.48-.1-.53-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.44,66.99c-.05-.23.1-.46.33-.51s.46.1.51.33-.1.46-.33.51-.46-.1-.51-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.08,69.74c-.05-.22.1-.44.32-.49s.44.1.49.32-.1.44-.32.49-.44-.1-.49-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.49,72.69c-.04-.21.09-.42.31-.47s.42.09.47.31-.09.42-.31.47-.42-.09-.47-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.67,75.82c-.04-.21.09-.41.29-.45s.41.09.45.29-.09.41-.29.45-.41-.09-.45-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.61,79.1c-.04-.2.08-.39.28-.43s.39.08.43.28-.08.39-.28.43-.39-.08-.43-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.29,82.52c-.04-.19.08-.37.27-.41s.37.08.41.27-.08.37-.27.41-.37-.08-.41-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.71,86.06c-.04-.18.08-.35.25-.39s.35.08.39.25-.08.35-.25.39-.35-.08-.39-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.86,89.69c-.04-.17.07-.33.24-.37s.33.07.37.24-.07.33-.24.37-.33-.07-.37-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.72,93.4c-.03-.16.07-.31.23-.35s.31.07.35.23-.07.31-.23.35-.31-.07-.35-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.3,97.16c-.03-.15.06-.3.21-.33s.3.06.33.21-.06.3-.21.33-.3-.06-.33-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.58,100.95c-.03-.14.06-.28.2-.31s.28.06.31.2-.06.28-.2.31-.28-.06-.31-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.57,104.76c-.03-.13.06-.26.19-.29s.26.06.29.19-.06.26-.19.29-.26-.06-.29-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.27,108.55c-.03-.12.05-.24.17-.27s.24.05.27.17-.05.24-.17.27-.24-.05-.27-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.67,112.3c-.02-.11.05-.22.16-.25s.22.05.24.16-.05.22-.16.24-.22-.05-.25-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.8,116c-.02-.1.04-.2.15-.22s.2.04.22.15-.04.2-.15.22-.2-.04-.22-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.64,119.61c-.02-.09.04-.18.13-.2s.18.04.2.13-.04.18-.13.2-.18-.04-.2-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.21,123.13c-.02-.08.04-.17.12-.18s.17.04.18.12-.04.17-.12.18-.17-.04-.18-.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.66,
    cy: 126.5,
    r: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.57,129.79c-.01-.07.03-.13.09-.14s.13.03.14.09-.03.13-.09.14-.13-.03-.14-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 212.48,
    cy: 132.86,
    r: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.96,135.8s.02-.09.07-.1.09.02.1.07-.02.09-.07.1-.09-.02-.1-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.32,138.52s.02-.07.05-.08.07.02.08.05-.02.07-.05.08-.07-.02-.08-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.53,
    cy: 141.02,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.48,
    cy: 143.31,
    r: 0.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.27,
    cy: 145.35,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.42,
    cy: 139.5,
    r: 1.52,
    transform: "translate(25.96 312.02) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 208.47,
    cy: 142.33,
    r: 1.5,
    transform: "translate(20.95 311.31) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.31,
    cy: 144.93,
    r: 1.48,
    transform: "translate(16.01 310.23) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.96,
    cy: 147.28,
    r: 1.47,
    transform: "translate(11.16 308.77) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.44,
    cy: 149.37,
    r: 1.45,
    transform: "translate(-26.06 43.12) rotate(-11.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.76,
    cy: 151.18,
    r: 1.43,
    transform: "translate(-36.85 235.7) rotate(-57.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.96,
    cy: 152.7,
    r: 1.41,
    transform: "translate(-19.88 276.51) rotate(-69.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.06,
    cy: 153.92,
    r: 1.39,
    transform: "translate(-13.83 18.55) rotate(-5.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.07,
    cy: 154.84,
    r: 1.37,
    transform: "translate(-14.51 19) rotate(-5.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.02,
    cy: 155.45,
    r: 1.35,
    transform: "translate(-15.17 19.43) rotate(-5.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.94,
    cy: 155.76,
    r: 1.34,
    transform: "translate(-33.95 261.73) rotate(-68.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.85,
    cy: 155.75,
    r: 1.32,
    transform: "translate(-31.35 267.83) rotate(-71.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 166.77,
    cy: 155.43,
    r: 1.3,
    transform: "translate(-17.05 20.6) rotate(-6.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.72,
    cy: 154.8,
    r: 1.28,
    transform: "translate(-31.9 266.89) rotate(-73.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.74,
    cy: 153.86,
    r: 1.26,
    transform: "translate(-50.52 225.14) rotate(-62.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.84,
    cy: 152.62,
    r: 1.24,
    transform: "translate(-35.59 257.52) rotate(-73.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.05,
    cy: 151.08,
    r: 1.22,
    transform: "translate(-11.93 12.95) rotate(-4.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.36,149.89c-.35-.57-.18-1.31.39-1.66s1.31-.18,1.66.39c.35.57.18,1.31-.39,1.66s-1.31.18-1.66-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.86,147.78c-.35-.56-.17-1.29.38-1.63.56-.35,1.29-.17,1.63.38s.17,1.29-.38,1.63-1.29.17-1.63-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.54,145.4c-.34-.55-.17-1.27.38-1.61.55-.34,1.27-.17,1.61.38s.17,1.27-.38,1.61-1.27.17-1.61-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.41,142.78c-.33-.54-.17-1.25.37-1.58.54-.33,1.25-.17,1.58.37.33.54.17,1.25-.37,1.58s-1.25.17-1.58-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.48,139.93c-.33-.53-.17-1.23.37-1.56s1.23-.17,1.56.37c.33.53.17,1.23-.37,1.56s-1.23.17-1.56-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.77,136.86c-.32-.52-.16-1.21.36-1.53.52-.32,1.21-.16,1.53.36.32.52.16,1.21-.36,1.53s-1.21.16-1.53-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.31,133.59c-.32-.51-.16-1.19.35-1.51s1.19-.16,1.51.35.16,1.19-.35,1.51-1.19.16-1.51-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.11,130.14c-.31-.51-.16-1.17.35-1.48s1.17-.16,1.48.35c.31.51.16,1.17-.35,1.48-.51.31-1.17.16-1.48-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.18,126.53c-.31-.5-.15-1.15.34-1.46s1.15-.15,1.46.34c.31.5.15,1.15-.34,1.46s-1.15.15-1.46-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.53,122.78c-.3-.49-.15-1.13.34-1.43s1.13-.15,1.43.34.15,1.13-.34,1.43c-.49.3-1.13.15-1.43-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.17,118.92c-.3-.48-.15-1.11.33-1.4.48-.3,1.11-.15,1.4.33s.15,1.11-.33,1.4-1.11.15-1.4-.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 120.97,
    cy: 114.43,
    r: 1,
    transform: "translate(-9.03 10.37) rotate(-4.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.36,110.93c-.29-.46-.14-1.07.32-1.35.46-.29,1.07-.14,1.35.32s.14,1.07-.32,1.35c-.46.29-1.07.14-1.35-.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.74,
    cy: 106.34,
    r: 0.96,
    transform: "translate(-5.68 6.77) rotate(-3.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.79,102.75c-.28-.44-.14-1.03.31-1.3s1.03-.14,1.3.31.14,1.03-.31,1.3-1.03.14-1.3-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.97,98.65c-.27-.44-.14-1.01.3-1.28.44-.27,1.01-.14,1.28.3s.14,1.01-.3,1.28-1.01.14-1.28-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.46,94.57c-.26-.43-.13-.99.29-1.25s.99-.13,1.25.29.13.99-.29,1.25-.99.13-1.25-.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 121.02,
    cy: 90.08,
    r: 0.89,
    transform: "translate(27.3 208.3) rotate(-88.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 122.11,
    cy: 86.13,
    r: 0.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.5,
    cy: 82.28,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 125.18,
    cy: 78.55,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 127.15,
    cy: 74.96,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 129.38,
    cy: 71.53,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.88,
    cy: 68.29,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.61,
    cy: 65.24,
    r: 0.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.56,
    cy: 62.41,
    r: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.72,
    cy: 59.81,
    r: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.07,
    cy: 57.45,
    r: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.01,55.73c-.2-.32-.1-.75.22-.95s.75-.1.95.22.1.75-.22.95-.75.1-.95-.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.27,
    cy: 53.56,
    r: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.07,
    cy: 52.04,
    r: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.97,
    cy: 50.82,
    r: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.96,
    cy: 49.9,
    r: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.01,
    cy: 49.29,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.09,
    cy: 48.98,
    r: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.18,
    cy: 48.99,
    r: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.26,
    cy: 49.31,
    r: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.31,
    cy: 49.95,
    r: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.87,51.15c-.15-.24-.07-.54.16-.69.24-.15.54-.07.69.16s.07.54-.16.69-.54.07-.69-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.78,52.38c-.14-.23-.07-.52.16-.66s.52-.07.66.16.07.52-.16.66-.52.07-.66-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.59,53.91c-.13-.22-.07-.5.15-.64s.5-.07.64.15.07.5-.15.64-.5.07-.64-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.27,55.72c-.13-.21-.07-.48.14-.61s.48-.07.61.14.07.48-.14.61-.48.07-.61-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.8,57.82c-.12-.2-.06-.46.14-.59s.46-.06.59.14.06.46-.14.59-.46.06-.59-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.15,60.17c-.12-.19-.06-.44.13-.56s.44-.06.56.13.06.44-.13.56-.44.06-.56-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.32,62.78c-.11-.18-.06-.42.13-.54s.42-.06.54.13.06.42-.13.54-.42.06-.54-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.28,65.61c-.11-.17-.05-.4.12-.51s.4-.05.51.12.05.4-.12.51-.4.05-.51-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.01,68.66c-.1-.17-.05-.38.11-.49s.38-.05.49.11.05.38-.11.49-.38.05-.49-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.5,71.91c-.1-.16-.05-.36.11-.46s.36-.05.46.11.05.36-.11.46-.36.05-.46-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.74,75.34c-.09-.15-.05-.34.1-.43s.34-.05.43.1.05.34-.1.43-.34.05-.43-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.7,78.93c-.09-.14-.04-.32.1-.41s.32-.04.41.1.04.32-.1.41-.32.04-.41-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.38,82.66c-.08-.13-.04-.3.09-.38s.3-.04.38.09.04.3-.09.38-.3.04-.38-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.77,86.51c-.08-.12-.04-.28.08-.36s.28-.04.36.08.04.28-.08.36-.28.04-.36-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.86,90.45c-.07-.11-.04-.26.08-.33s.26-.04.33.08.04.26-.08.33-.26.04-.33-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.64,94.46c-.06-.1-.03-.24.07-.31s.24-.03.31.07.03.24-.07.31-.24.03-.31-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.11,98.51c-.06-.1-.03-.22.07-.28s.22-.03.28.07.03.22-.07.28-.22.03-.28-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.28,102.6c-.05-.09-.03-.2.06-.26s.2-.03.26.06.03.2-.06.26-.2.03-.26-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.13,106.67c-.05-.08-.02-.18.05-.23s.18-.02.23.05.02.18-.05.23-.18.02-.23-.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.79,
    cy: 110.65,
    r: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.9,114.74c-.04-.06-.02-.14.04-.18s.14-.02.18.04.02.14-.04.18-.14.02-.18-.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 223.92,
    cy: 118.61,
    r: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.45,122.51s-.01-.1.03-.13.1-.01.13.03.01.1-.03.13-.1.01-.13-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.78,126.23s-.01-.08.02-.1.08-.01.1.02.01.08-.02.1-.08.01-.1-.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 218.88,
    cy: 129.78,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 216.64,
    cy: 133.21,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 214.15,
    cy: 136.46,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.29,
    cy: 125.71,
    r: 1.64,
    transform: "translate(49.95 314.95) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 223.34,
    cy: 129.66,
    r: 1.62,
    transform: "translate(44.63 316.08) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 221.11,
    cy: 133.45,
    r: 1.6,
    transform: "translate(39.24 316.81) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 218.59,
    cy: 137.06,
    r: 1.58,
    transform: "translate(33.8 317.11) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.8,
    cy: 140.46,
    r: 1.56,
    transform: "translate(-38.85 102.38) rotate(-24.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 212.75,
    cy: 143.64,
    r: 1.54,
    transform: "translate(-10.34 270.62) rotate(-63.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.47,
    cy: 146.57,
    r: 1.52,
    transform: "translate(-4.53 286.44) rotate(-68.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.97,
    cy: 149.24,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.28,
    cy: 151.64,
    r: 1.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.42,
    cy: 153.75,
    r: 1.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.4,
    cy: 155.55,
    r: 1.44,
    transform: "translate(-23.26 276.43) rotate(-67.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.26,
    cy: 157.05,
    r: 1.42,
    transform: "translate(-8.5 303.2) rotate(-75.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 186.02,
    cy: 158.23,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.71,
    cy: 159.08,
    r: 1.38,
    transform: "translate(-16.45 297.13) rotate(-76.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.34,
    cy: 159.6,
    r: 1.36,
    transform: "translate(-34.29 269.75) rotate(-69.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.94,
    cy: 159.78,
    r: 1.34,
    transform: "translate(-23.8 289.12) rotate(-76.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.54,
    cy: 159.62,
    r: 1.32,
    transform: "translate(-30.04 39.42) rotate(-12.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.37,160.14c-.56-.44-.66-1.26-.22-1.82s1.26-.66,1.82-.22c.56.44.66,1.26.22,1.82s-1.26.66-1.82.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.06,159.29c-.55-.44-.65-1.24-.21-1.79.44-.55,1.24-.65,1.79-.21s.65,1.24.21,1.79c-.44.55-1.24.65-1.79.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.82,158.11c-.55-.43-.64-1.22-.21-1.76.43-.55,1.22-.64,1.76-.21s.64,1.22.21,1.76-1.22.64-1.76.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.69,156.61c-.54-.42-.63-1.2-.21-1.74s1.2-.63,1.74-.21c.54.42.63,1.2.21,1.74s-1.2.63-1.74.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.69,154.81c-.53-.42-.62-1.18-.2-1.71.42-.53,1.18-.62,1.71-.2s.62,1.18.2,1.71c-.42.53-1.18.62-1.71.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.83,152.7c-.52-.41-.61-1.16-.2-1.68s1.16-.61,1.68-.2c.52.41.61,1.16.2,1.68-.41.52-1.16.61-1.68.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.14,150.3c-.51-.4-.6-1.14-.2-1.65s1.14-.6,1.65-.2c.51.4.6,1.14.2,1.65-.4.51-1.14.6-1.65.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135.64,147.63c-.5-.4-.59-1.12-.19-1.62s1.12-.59,1.62-.19.59,1.12.19,1.62c-.4.5-1.12.59-1.62.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.36,144.69c-.49-.39-.58-1.1-.19-1.6s1.1-.58,1.6-.19.58,1.1.19,1.6-1.1.58-1.6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.32,141.51c-.48-.38-.57-1.08-.19-1.57s1.08-.57,1.57-.19.57,1.08.19,1.57c-.38.48-1.08.57-1.57.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M126.52,138.1c-.48-.37-.56-1.06-.18-1.54s1.06-.56,1.54-.18c.48.37.56,1.06.18,1.54s-1.06.56-1.54.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.67,
    cy: 133.64,
    r: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.76,130.7c-.46-.36-.54-1.03-.18-1.48s1.03-.54,1.48-.18.54,1.03.18,1.48-1.03.54-1.48.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 120.45,
    cy: 125.92,
    r: 1.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.17,122.64c-.44-.35-.52-.99-.17-1.43s.99-.52,1.43-.17.52.99.17,1.43-.99.52-1.43.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.85,118.44c-.43-.34-.51-.97-.17-1.4s.97-.51,1.4-.17.51.97.17,1.4-.97.51-1.4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.84,114.14c-.42-.33-.5-.95-.16-1.37.33-.42.95-.5,1.37-.16s.5.95.16,1.37c-.33.42-.95.5-1.37.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 115.76,
    cy: 109.02,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 115.42,
    cy: 104.63,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 115.4,
    cy: 100.23,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 115.73,
    cy: 95.84,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.4,
    cy: 91.49,
    r: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.4,
    cy: 87.21,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 118.72,
    cy: 83.01,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 120.36,
    cy: 78.93,
    r: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 122.3,
    cy: 74.98,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.54,
    cy: 71.19,
    r: 0.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 127.06,
    cy: 67.58,
    r: 0.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.4,64.76c-.32-.25-.38-.72-.12-1.04s.72-.38,1.04-.12c.32.25.38.72.12,1.04s-.72.38-1.04.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 132.9,
    cy: 61,
    r: 0.72,
    transform: "translate(28.71 163.61) rotate(-69.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.18,
    cy: 58.07,
    r: 0.7,
    transform: "translate(33.83 165.03) rotate(-69.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.68,
    cy: 55.4,
    r: 0.68,
    transform: "translate(33.21 161.43) rotate(-66.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.37,
    cy: 53,
    r: 0.66,
    transform: "translate(37.26 163.02) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.23,
    cy: 50.89,
    r: 0.64,
    transform: "translate(41.95 165.71) rotate(-66.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.25,
    cy: 49.09,
    r: 0.62,
    transform: "translate(40.46 163.15) rotate(-63.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 155.39,
    cy: 47.59,
    r: 0.6,
    transform: "translate(44.7 166.57) rotate(-64.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 159.63,
    cy: 46.41,
    r: 0.58,
    transform: "translate(44.5 166.33) rotate(-62.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 163.94,
    cy: 45.56,
    r: 0.56,
    transform: "translate(46.18 168.39) rotate(-61.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.98,45.47c-.23-.18-.27-.52-.09-.76.18-.23.52-.27.76-.09s.27.52.09.76-.52.27-.76.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.39,45.27c-.23-.18-.26-.5-.09-.73s.5-.26.73-.09.26.5.09.73c-.18.23-.5.26-.73.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.8,45.42c-.22-.17-.25-.48-.08-.7s.48-.25.7-.08.25.48.08.7-.48.25-.7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.19,45.9c-.21-.16-.24-.46-.08-.67s.46-.24.67-.08.24.46.08.67-.46.24-.67.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.52,46.71c-.2-.16-.23-.45-.08-.64s.45-.23.64-.08.23.45.08.64-.45.23-.64.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M189.78,47.86c-.19-.15-.22-.43-.07-.62s.43-.22.62-.07.22.43.07.62-.43.22-.62.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.93,49.33c-.18-.14-.21-.41-.07-.59s.41-.21.59-.07c.18.14.21.41.07.59s-.41.21-.59.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.97,51.11c-.17-.14-.2-.39-.07-.56s.39-.2.56-.07.2.39.07.56-.39.2-.56.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.85,53.18c-.16-.13-.19-.37-.06-.53s.37-.19.53-.06.19.37.06.53-.37.19-.53.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.56,55.55c-.16-.12-.18-.35-.06-.5s.35-.18.5-.06.18.35.06.5-.35.18-.5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.08,58.19c-.15-.12-.17-.33-.06-.48s.33-.17.48-.06.17.33.06.48-.33.17-.48.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.39,61.1c-.14-.11-.16-.31-.05-.45s.31-.16.45-.05.16.31.05.45-.31.16-.45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.46,64.25c-.13-.1-.15-.29-.05-.42s.29-.15.42-.05.15.29.05.42-.29.15-.42.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.27,67.62c-.12-.1-.14-.27-.05-.39s.27-.14.39-.05.14.27.05.39-.27.14-.39.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.82,71.2c-.11-.09-.13-.25-.04-.36s.25-.13.36-.04.13.25.04.36-.25.13-.36.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.09,74.97c-.1-.08-.12-.23-.04-.34s.23-.12.34-.04.12.23.04.34-.23.12-.34.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.06,78.9c-.1-.07-.11-.21-.04-.31s.21-.11.31-.04.11.21.04.31-.21.11-.31.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.72,82.96c-.09-.07-.1-.19-.03-.28s.19-.1.28-.03.1.19.03.28-.19.1-.28.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.07,87.14c-.08-.06-.09-.17-.03-.25s.17-.09.25-.03.09.17.03.25-.17.09-.25.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 229.2,
    cy: 91.28,
    r: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.79,95.73c-.06-.05-.07-.14-.02-.2s.14-.07.2-.02.07.14.02.2-.14.07-.2.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.23,
    cy: 100.01,
    r: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.18,104.49s-.05-.1-.02-.14.1-.05.14-.02.05.1.02.14-.1.05-.14.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.86,108.86s-.04-.08-.01-.11.08-.04.11-.01.04.08.01.11-.08.04-.11.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 229.25,
    cy: 113.15,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.25,
    cy: 117.44,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.92,
    cy: 121.64,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.22,
    cy: 106.68,
    r: 1.76,
    transform: "translate(75.27 309.1) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 233.71,
    cy: 111.38,
    r: 1.74,
    transform: "translate(70.31 312.2) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 232.85,
    cy: 116.04,
    r: 1.72,
    transform: "translate(65.13 314.91) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 231.63,
    cy: 120.61,
    r: 1.69,
    transform: "translate(59.75 317.22) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.06,
    cy: 125.07,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.15,
    cy: 129.4,
    r: 1.65,
    transform: "translate(31.57 303.05) rotate(-71.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.91,
    cy: 133.57,
    r: 1.63,
    transform: "translate(25.15 302.6) rotate(-70.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 223.36,
    cy: 137.56,
    r: 1.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 220.51,
    cy: 141.34,
    r: 1.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 217.38,
    cy: 144.89,
    r: 1.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 213.99,
    cy: 148.19,
    r: 1.54,
    transform: "translate(2.68 300.19) rotate(-70.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.36,
    cy: 151.23,
    r: 1.52,
    transform: "translate(26.4 333.65) rotate(-80.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.51,
    cy: 153.97,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.46,
    cy: 156.42,
    r: 1.48,
    transform: "translate(9.42 324.34) rotate(-78.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.23,
    cy: 158.55,
    r: 1.46,
    transform: "translate(-1.52 315.18) rotate(-76.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.86,
    cy: 160.35,
    r: 1.44,
    transform: "translate(-1.18 319.27) rotate(-78.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.36,
    cy: 161.81,
    r: 1.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.32,164.24c-.73-.24-1.13-1.03-.89-1.76.24-.73,1.03-1.13,1.76-.89.73.24,1.13,1.03.89,1.76-.24.73-1.03,1.13-1.76.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.65,164.97c-.72-.24-1.11-1.01-.88-1.73s1.01-1.11,1.73-.88,1.11,1.01.88,1.73-1.01,1.11-1.73.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.94,165.33c-.71-.23-1.09-1-.86-1.71.23-.71,1-1.09,1.71-.86s1.09,1,.86,1.71-1,1.09-1.71.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.22,165.34c-.7-.23-1.08-.98-.85-1.68s.98-1.08,1.68-.85c.7.23,1.08.98.85,1.68-.23.7-.98,1.08-1.68.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.5,164.98c-.69-.23-1.06-.97-.83-1.65s.97-1.06,1.65-.83c.69.23,1.06.97.83,1.65s-.97,1.06-1.65.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.83,164.28c-.68-.22-1.04-.95-.82-1.62s.95-1.04,1.62-.82,1.04.95.82,1.62c-.22.68-.95,1.04-1.62.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.22,163.21c-.66-.22-1.03-.93-.81-1.6s.93-1.03,1.6-.81,1.03.93.81,1.6c-.22.66-.93,1.03-1.6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.7,161.8c-.65-.21-1.01-.92-.79-1.57s.92-1.01,1.57-.79,1.01.92.79,1.57-.92,1.01-1.57.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.31,160.03c-.64-.21-.99-.9-.78-1.54s.9-.99,1.54-.78.99.9.78,1.54c-.21.64-.9.99-1.54.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.06,157.94c-.63-.21-.97-.89-.77-1.52s.89-.97,1.52-.77.97.89.77,1.52-.89.97-1.52.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.99,155.52c-.62-.2-.96-.87-.75-1.49.2-.62.87-.96,1.49-.75s.96.87.75,1.49c-.2.62-.87.96-1.49.75Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.47,
    cy: 151.7,
    r: 1.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.45,149.79c-.6-.2-.92-.84-.72-1.43s.84-.92,1.43-.72.92.84.72,1.43-.84.92-1.43.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 128.38,
    cy: 145.45,
    r: 1.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.86,142.97c-.57-.19-.89-.81-.7-1.38s.81-.89,1.38-.7c.57.19.89.81.7,1.38-.19.57-.81.89-1.38.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.98,139.21c-.56-.18-.87-.79-.68-1.35s.79-.87,1.35-.68.87.79.68,1.35-.79.87-1.35.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.38,135.23c-.55-.18-.85-.78-.67-1.33.18-.55.78-.85,1.33-.67s.85.78.67,1.33c-.18.55-.78.85-1.33.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.42,
    cy: 130.09,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 115.46,
    cy: 125.79,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 113.83,
    cy: 121.35,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.54,
    cy: 116.79,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.62,
    cy: 112.15,
    r: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.05,
    cy: 107.45,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 110.84,
    cy: 102.73,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111,
    cy: 98,
    r: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.51,
    cy: 93.29,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.38,
    cy: 88.64,
    r: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 113.6,
    cy: 84.07,
    r: 0.82,
    transform: "translate(5.45 175.04) rotate(-76.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.92,80.36c-.42-.14-.64-.59-.51-1s.59-.64,1-.51.64.59.51,1c-.14.42-.59.64-1,.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.08,
    cy: 75.27,
    r: 0.77,
    transform: "translate(14.03 168.84) rotate(-74.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.31,
    cy: 71.1,
    r: 0.75,
    transform: "translate(21.26 169.47) rotate(-75.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 121.86,
    cy: 67.11,
    r: 0.73,
    transform: "translate(24.62 166.61) rotate(-74.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.71,
    cy: 63.34,
    r: 0.71,
    transform: "translate(30.29 166.53) rotate(-74.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 127.84,
    cy: 59.79,
    r: 0.69,
    transform: "translate(37.59 168.29) rotate(-75.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.23,
    cy: 56.48,
    r: 0.66,
    transform: "translate(40.09 166.51) rotate(-73.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.86,
    cy: 53.45,
    r: 0.64,
    transform: "translate(47.21 169.04) rotate(-74.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.72,
    cy: 50.7,
    r: 0.62,
    transform: "translate(50.92 169.46) rotate(-73.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.77,
    cy: 48.26,
    r: 0.6,
    transform: "translate(56.13 171.56) rotate(-73.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.81,46.68c-.3-.1-.47-.43-.37-.73.1-.3.43-.47.73-.37.3.1.47.43.37.73s-.43.47-.73.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.2,44.86c-.29-.1-.45-.41-.36-.7s.41-.45.7-.36.45.41.36.7-.41.45-.7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.7,43.38c-.28-.09-.43-.4-.34-.68s.4-.43.68-.34.43.4.34.68-.4.43-.68.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.31,42.25c-.27-.09-.42-.38-.33-.65s.38-.42.65-.33.42.38.33.65-.38.42-.65.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.99,41.48c-.26-.09-.4-.36-.31-.62s.36-.4.62-.31.4.36.31.62-.36.4-.62.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.72,41.08c-.25-.08-.38-.35-.3-.6s.35-.38.6-.3.38.35.3.6-.35.38-.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.45,41.03c-.24-.08-.36-.33-.29-.57s.33-.36.57-.29.36.33.29.57-.33.36-.57.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.18,41.35c-.23-.07-.35-.32-.27-.54s.32-.35.54-.27.35.32.27.54-.32.35-.54.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.87,42.01c-.21-.07-.33-.3-.26-.51s.3-.33.51-.26.33.3.26.51-.3.33-.51.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.49,43.04c-.2-.07-.31-.28-.25-.49s.28-.31.49-.25.31.28.25.49-.28.31-.49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.02,44.41c-.19-.06-.3-.27-.23-.46s.27-.3.46-.23.3.27.23.46-.27.3-.46.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.43,46.13c-.18-.06-.28-.25-.22-.43s.25-.28.43-.22.28.25.22.43-.25.28-.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.69,48.19c-.17-.06-.26-.24-.21-.41s.24-.26.41-.21.26.24.21.41-.24.26-.41.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.78,50.56c-.16-.05-.24-.22-.19-.38s.22-.24.38-.19.24.22.19.38-.22.24-.38.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.67,53.25c-.15-.05-.23-.21-.18-.35s.21-.23.35-.18.23.21.18.35-.21.23-.35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.34,56.22c-.14-.04-.21-.19-.16-.32s.19-.21.32-.16.21.19.16.32-.19.21-.32.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.78,59.46c-.12-.04-.19-.17-.15-.3s.17-.19.3-.15.19.17.15.3-.17.19-.3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.95,62.95c-.11-.04-.17-.16-.14-.27s.16-.17.27-.14.17.16.14.27-.16.17-.27.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.85,66.68c-.1-.03-.16-.14-.12-.24s.14-.16.24-.12.16.14.12.24-.14.16-.24.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.51,
    cy: 70.45,
    r: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.75,74.73c-.08-.03-.12-.11-.1-.19s.11-.12.19-.1.12.11.1.19-.11.12-.19.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 229.77,
    cy: 78.89,
    r: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.36,83.44c-.06-.02-.09-.08-.07-.14s.08-.09.14-.07.09.08.07.14-.08.09-.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.65,87.97s-.07-.06-.05-.11.06-.07.11-.05.07.06.05.11-.06.07-.11.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 233.61,
    cy: 92.53,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.17,
    cy: 97.23,
    r: 0.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.38,
    cy: 101.96,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 236.25,
    cy: 84.16,
    r: 1.89,
    transform: "translate(98.7 293.87) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 237.47,
    cy: 89.1,
    r: 1.87,
    transform: "translate(94.83 298.83) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.3,
    cy: 94.12,
    r: 1.85,
    transform: "translate(90.59 303.47) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.75,
    cy: 99.19,
    r: 1.82,
    transform: "translate(86.01 307.78) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.81,
    cy: 104.28,
    r: 1.8,
    transform: "translate(-20.04 134.28) rotate(-30.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.47,
    cy: 109.36,
    r: 1.78,
    transform: "translate(84.77 321.97) rotate(-78.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 237.75,
    cy: 114.39,
    r: 1.75,
    transform: "translate(64.93 313.75) rotate(-74.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 236.64,
    cy: 119.36,
    r: 1.73,
    transform: "translate(5.14 248.41) rotate(-55.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 235.15,
    cy: 124.23,
    r: 1.71,
    transform: "translate(-.27 247.94) rotate(-55.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 233.29,
    cy: 128.96,
    r: 1.68,
    transform: "translate(-5.69 247.04) rotate(-55.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 231.08,
    cy: 133.55,
    r: 1.66,
    transform: "translate(41.31 321.22) rotate(-74.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.53,
    cy: 137.95,
    r: 1.64,
    transform: "translate(67.96 351.19) rotate(-84.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.65,
    cy: 142.14,
    r: 1.61,
    transform: "translate(-21.74 241.76) rotate(-54.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 222.45,
    cy: 146.1,
    r: 1.59,
    transform: "translate(41.88 341.62) rotate(-80.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 218.97,
    cy: 149.81,
    r: 1.57,
    transform: "translate(47.05 351.89) rotate(-83.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.21,
    cy: 153.24,
    r: 1.55,
    transform: "translate(29.17 340.82) rotate(-80.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 211.19,
    cy: 156.37,
    r: 1.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207,160.68c-.83.03-1.52-.62-1.55-1.45s.62-1.52,1.45-1.55,1.52.62,1.55,1.45c.03.83-.62,1.52-1.45,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.55,163.13c-.81.03-1.5-.61-1.52-1.43s.61-1.5,1.43-1.52c.81-.03,1.5.61,1.52,1.43.03.81-.61,1.5-1.43,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.93,165.23c-.8.03-1.47-.6-1.5-1.41-.03-.8.6-1.47,1.41-1.5s1.47.6,1.5,1.41c.03.8-.6,1.47-1.41,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.15,166.97c-.79.02-1.45-.59-1.47-1.38s.59-1.45,1.38-1.47c.79-.02,1.45.59,1.47,1.38s-.59,1.45-1.38,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.26,168.35c-.78.02-1.43-.59-1.45-1.36-.02-.78.59-1.43,1.36-1.45.78-.02,1.43.59,1.45,1.36s-.59,1.43-1.36,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.28,169.35c-.76.02-1.4-.58-1.43-1.34s.58-1.4,1.34-1.43,1.4.58,1.43,1.34-.58,1.4-1.34,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.23,169.97c-.75.02-1.38-.57-1.4-1.32s.57-1.38,1.32-1.4c.75-.02,1.38.57,1.4,1.32.02.75-.57,1.38-1.32,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.14,170.2c-.74.02-1.36-.56-1.38-1.29s.56-1.36,1.29-1.38c.74-.02,1.36.56,1.38,1.29s-.56,1.36-1.29,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.06,170.04c-.73.02-1.33-.55-1.36-1.27s.55-1.33,1.27-1.36,1.33.55,1.36,1.27-.55,1.33-1.27,1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163,169.48c-.71.02-1.31-.54-1.33-1.25-.02-.71.54-1.31,1.25-1.33.71-.02,1.31.54,1.33,1.25.02.71-.54,1.31-1.25,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.99,168.54c-.7.02-1.29-.53-1.31-1.23s.53-1.29,1.23-1.31,1.29.53,1.31,1.23c.02.7-.53,1.29-1.23,1.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.03,
    cy: 165.97,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.26,165.52c-.67.02-1.24-.51-1.26-1.18s.51-1.24,1.18-1.26,1.24.51,1.26,1.18c.02.67-.51,1.24-1.18,1.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.56,
    cy: 162.26,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.1,161.05c-.65.02-1.19-.49-1.21-1.14s.49-1.19,1.14-1.21,1.19.49,1.21,1.14-.49,1.19-1.14,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.8,158.31c-.64.02-1.17-.48-1.19-1.12-.02-.64.48-1.17,1.12-1.19s1.17.48,1.19,1.12-.48,1.17-1.12,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.72,155.25c-.62.02-1.15-.47-1.17-1.09-.02-.62.47-1.15,1.09-1.17s1.15.47,1.17,1.09c.02.62-.47,1.15-1.09,1.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 126.85,
    cy: 150.78,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.28,
    cy: 147.15,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 120,
    cy: 143.26,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.03,
    cy: 139.13,
    r: 1.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 114.38,
    cy: 134.78,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.08,
    cy: 130.24,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 110.14,
    cy: 125.54,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.55,
    cy: 120.71,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.34,
    cy: 115.76,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.5,
    cy: 110.74,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.05,
    cy: 105.68,
    r: 0.88,
    transform: "translate(-15.65 192.87) rotate(-80.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.02,101.44c-.47.01-.86-.36-.88-.83s.36-.86.83-.88.86.36.88.83-.36.86-.83.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.33,
    cy: 95.51,
    r: 0.83,
    transform: "translate(-4.73 185.47) rotate(-80.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.06,
    cy: 90.47,
    r: 0.81,
    transform: "translate(3.34 184.76) rotate(-82.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.17,
    cy: 85.51,
    r: 0.78,
    transform: "translate(9.43 181.76) rotate(-82.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 109.66,
    cy: 80.64,
    r: 0.76,
    transform: "translate(15.75 179.18) rotate(-82.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.52,
    cy: 75.9,
    r: 0.74,
    transform: "translate(24.57 179.04) rotate(-84.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 113.73,
    cy: 71.32,
    r: 0.71,
    transform: "translate(29.99 176.25) rotate(-83.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.28,
    cy: 66.92,
    r: 0.69,
    transform: "translate(39.07 176.64) rotate(-84.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.17,
    cy: 62.73,
    r: 0.67,
    transform: "translate(45.81 175.66) rotate(-84.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 122.36,
    cy: 58.76,
    r: 0.65,
    transform: "translate(53.81 175.92) rotate(-85.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.86,55.68c-.34.01-.63-.26-.64-.6s.26-.63.6-.64.63.26.64.6-.26.63-.6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.62,52.23c-.33.01-.61-.25-.62-.58s.25-.61.58-.62.61.25.62.58-.25.61-.58.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.64,49.08c-.32.01-.58-.24-.59-.56s.24-.58.56-.59.58.24.59.56-.24.58-.56.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.88,46.25c-.31,0-.56-.23-.57-.54s.23-.56.54-.57.56.23.57.54-.23.56-.54.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.33,43.75c-.29,0-.54-.22-.55-.51s.22-.54.51-.55.54.22.55.51-.22.54-.51.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.95,41.6c-.28,0-.51-.21-.52-.49,0-.28.21-.51.49-.52s.51.21.52.49-.21.51-.49.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.72,39.81c-.27,0-.49-.2-.5-.47s.2-.49.47-.5.49.2.5.47-.2.49-.47.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.61,38.39c-.25,0-.47-.19-.48-.45s.19-.47.45-.48.47.19.48.45-.19.47-.45.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.59,37.34c-.24,0-.44-.18-.45-.42s.18-.44.42-.45.44.18.45.42-.18.44-.42.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.64,36.68c-.23,0-.42-.17-.43-.4s.17-.42.4-.43.42.17.43.4-.17.42-.4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.72,36.4c-.22,0-.4-.16-.4-.38s.16-.4.38-.4.4.16.4.38-.16.4-.38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.81,36.52c-.2,0-.37-.15-.38-.36s.15-.37.36-.38.37.15.38.36-.15.37-.36.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.87,37.03c-.19,0-.35-.14-.36-.33s.14-.35.33-.36.35.14.36.33-.14.35-.33.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.87,37.93c-.18,0-.33-.13-.33-.31s.13-.33.31-.33.33.13.33.31-.13.33-.31.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.79,39.2c-.17,0-.3-.12-.31-.29s.12-.3.29-.31.3.12.31.29-.12.3-.29.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M196.6,40.86c-.15,0-.28-.12-.29-.27s.12-.28.27-.29.28.12.29.27-.12.28-.27.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M201.26,42.87c-.14,0-.26-.11-.26-.25s.11-.26.25-.26.26.11.26.25-.11.26-.25.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.75,45.23c-.13,0-.23-.1-.24-.22s.1-.23.22-.24.23.1.24.22-.1.23-.22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.05,47.93c-.11,0-.21-.09-.21-.2s.09-.21.2-.21.21.09.21.2-.09.21-.2.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 214.13,
    cy: 50.76,
    r: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.97,54.26c-.09,0-.16-.07-.17-.16s.07-.16.16-.17.16.07.17.16-.07.16-.16.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 221.53,
    cy: 57.73,
    r: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M224.82,61.73c-.06,0-.12-.05-.12-.11s.05-.12.11-.12.12.05.12.11-.05.12-.11.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.79,65.84c-.05,0-.09-.04-.1-.09s.04-.09.09-.1.09.04.1.09-.04.09-.09.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.43,
    cy: 70.1,
    r: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 232.73,
    cy: 74.64,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.67,
    cy: 79.34,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.02,
    cy: 60.66,
    r: 2.03,
    transform: "translate(116.78 269.87) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 233.07,
    cy: 65.21,
    r: 2.01,
    transform: "translate(114.68 276.3) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 235.76,
    cy: 69.97,
    r: 1.98,
    transform: "translate(112.11 282.55) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.08,
    cy: 74.93,
    r: 1.96,
    transform: "translate(109.06 288.59) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.01,
    cy: 80.05,
    r: 1.93,
    transform: "translate(14.75 195.25) rotate(-45.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 241.53,
    cy: 85.31,
    r: 1.91,
    transform: "translate(141.03 320.92) rotate(-86.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 242.65,
    cy: 90.66,
    r: 1.88,
    transform: "translate(108.15 312.04) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 243.36,
    cy: 96.09,
    r: 1.86,
    transform: "translate(37.46 257.52) rotate(-59.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 243.64,
    cy: 101.55,
    r: 1.84,
    transform: "translate(32.39 259.81) rotate(-59.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 243.51,
    cy: 107.02,
    r: 1.81,
    transform: "translate(27.12 261.71) rotate(-59.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 242.96,
    cy: 112.47,
    r: 1.79,
    transform: "translate(87.46 330.4) rotate(-79.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 242,
    cy: 117.85,
    r: 1.76,
    transform: "translate(104.55 349.28) rotate(-85.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.63,
    cy: 123.15,
    r: 1.74,
    transform: "translate(10.43 264.85) rotate(-58.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.86,
    cy: 128.33,
    r: 1.71,
    transform: "translate(73.68 343.36) rotate(-80.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 236.7,
    cy: 133.35,
    r: 1.69,
    transform: "translate(-.95 1.69) rotate(-.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.16,
    cy: 138.2,
    r: 1.66,
    transform: "translate(60.5 347.43) rotate(-80.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 231.26,
    cy: 142.84,
    r: 1.64,
    transform: "translate(-24.77 234.13) rotate(-51.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.6,148.73c-.83.33-1.76-.07-2.1-.9-.33-.83.07-1.76.9-2.1s1.76.07,2.1.9-.07,1.76-.9,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.01,152.85c-.81.33-1.74-.07-2.06-.88s.07-1.74.88-2.06,1.74.07,2.06.88c.33.81-.07,1.74-.88,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.11,156.67c-.8.32-1.71-.07-2.03-.87-.32-.8.07-1.71.87-2.03s1.71.07,2.03.87c.32.8-.07,1.71-.87,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M216.93,160.19c-.79.32-1.68-.07-2-.86s.07-1.68.86-2,1.68.07,2,.86-.07,1.68-.86,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.49,163.38c-.78.31-1.66-.07-1.97-.84-.31-.78.07-1.66.84-1.97s1.66.07,1.97.84c.31.78-.07,1.66-.84,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.82,166.22c-.76.31-1.63-.07-1.93-.83-.31-.76.07-1.63.83-1.93.76-.31,1.63.07,1.93.83s-.07,1.63-.83,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.95,168.71c-.75.3-1.6-.06-1.9-.82s.06-1.6.82-1.9,1.6.06,1.9.82c.3.75-.06,1.6-.82,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.9,170.81c-.74.3-1.57-.06-1.87-.8s.06-1.57.8-1.87c.74-.3,1.57.06,1.87.8.3.74-.06,1.57-.8,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.7,172.52c-.72.29-1.55-.06-1.84-.79s.06-1.55.79-1.84,1.55.06,1.84.79-.06,1.55-.79,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.38,173.82c-.71.28-1.52-.06-1.81-.77s.06-1.52.77-1.81c.71-.28,1.52.06,1.81.77s-.06,1.52-.77,1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.98,174.7c-.7.28-1.49-.06-1.77-.76s.06-1.49.76-1.77,1.49.06,1.77.76c.28.7-.06,1.49-.76,1.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.02,
    cy: 173.93,
    r: 1.34,
    transform: "translate(-68.93 209.07) rotate(-52.82)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M171.04,175.23c-.67.27-1.44-.06-1.71-.73s.06-1.44.73-1.71,1.44.06,1.71.73-.06,1.44-.73,1.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.09,
    cy: 173.67,
    r: 1.29,
    transform: "translate(-69.58 222.11) rotate(-58.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.14,174.09c-.65.26-1.38-.06-1.64-.7s.06-1.38.7-1.64,1.38.06,1.64.7c.26.65-.06,1.38-.7,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.78,172.9c-.64.25-1.36-.05-1.61-.69-.25-.64.05-1.36.69-1.61s1.36.05,1.61.69-.05,1.36-.69,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.53,171.3c-.62.25-1.33-.05-1.58-.68-.25-.62.05-1.33.68-1.58.62-.25,1.33.05,1.58.68s-.05,1.33-.68,1.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.98,
    cy: 168.21,
    r: 1.19,
    transform: "translate(-70.82 221.95) rotate(-63.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.04,
    cy: 165.86,
    r: 1.17,
    transform: "translate(-69.89 222.35) rotate(-65.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.29,
    cy: 163.14,
    r: 1.14,
    transform: "translate(-68.21 223.48) rotate(-67.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 129.77,
    cy: 160.05,
    r: 1.12,
    transform: "translate(-66.3 223.4) rotate(-68.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 125.5,
    cy: 156.63,
    r: 1.09,
    transform: "translate(-63.07 225.39) rotate(-71.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 121.51,
    cy: 152.89,
    r: 1.07,
    transform: "translate(-62.38 218.67) rotate(-71.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.81,
    cy: 148.86,
    r: 1.04,
    transform: "translate(-59.32 217.14) rotate(-72.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 114.43,
    cy: 144.55,
    r: 1.02,
    transform: "translate(-53.05 221.63) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.39,
    cy: 140.01,
    r: 0.99,
    transform: "translate(-50.96 215.2) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.7,
    cy: 135.24,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 106.38,
    cy: 130.29,
    r: 0.94,
    transform: "translate(-35.36 220.84) rotate(-83.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.79,126.02c-.47.19-1-.04-1.19-.51-.19-.47.04-1,.51-1.19s1,.04,1.19.51-.04,1-.51,1.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.92,
    cy: 119.91,
    r: 0.89,
    transform: "translate(-23.59 214.6) rotate(-86.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 101.81,
    cy: 114.55,
    r: 0.87,
    transform: "translate(-15.82 212.8) rotate(-88.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 101.1,
    cy: 109.13,
    r: 0.84,
    transform: "translate(-.53 .5) rotate(-.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 100.82,
    cy: 103.66,
    r: 0.82,
    transform: "translate(-1.03 1.01) rotate(-.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 100.95,
    cy: 98.19,
    r: 0.79,
    transform: "translate(-4.34 4.67) rotate(-2.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 101.5,
    cy: 92.75,
    r: 0.77,
    transform: "translate(-5.2 6.03) rotate(-3.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.46,
    cy: 87.36,
    r: 0.74,
    transform: "translate(-7.49 9.64) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 103.83,
    cy: 82.07,
    r: 0.72,
    transform: "translate(-8.19 11.6) rotate(-6.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 105.6,
    cy: 76.89,
    r: 0.69,
    transform: "translate(-9.06 14.3) rotate(-7.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M108.01,72.48c-.34.14-.73-.03-.87-.37s.03-.73.37-.87.73.03.87.37c.14.34-.03.73-.37.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.54,67.61c-.33.13-.71-.03-.84-.36-.13-.33.03-.71.36-.84s.71.03.84.36c.13.33-.03.71-.36.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M113.44,62.95c-.32.13-.68-.03-.81-.35s.03-.68.35-.81.68.03.81.35-.03.68-.35.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.68,58.53c-.31.12-.65-.03-.77-.33s.03-.65.33-.77.65.03.77.33-.03.65-.33.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.26,54.37c-.29.12-.62-.03-.74-.32s.03-.62.32-.74.62.03.74.32-.03.62-.32.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.14,50.5c-.28.11-.6-.02-.71-.3-.11-.28.02-.6.3-.71s.6.02.71.3-.02.6-.3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.3,46.94c-.27.11-.57-.02-.68-.29s.02-.57.29-.68.57.02.68.29-.02.57-.29.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.72,43.71c-.25.1-.54-.02-.64-.28s.02-.54.28-.64.54.02.64.28c.1.25-.02.54-.28.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.37,40.81c-.24.1-.52-.02-.61-.26s.02-.52.26-.61.52.02.61.26c.1.24-.02.52-.26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.22,38.28c-.23.09-.49-.02-.58-.25s.02-.49.25-.58.49.02.58.25-.02.49-.25.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.26,36.14c-.22.09-.46-.02-.55-.23s.02-.46.23-.55.46.02.55.23-.02.46-.23.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.44,34.39c-.2.08-.43-.02-.52-.22s.02-.43.22-.52.43.02.52.22-.02.43-.22.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M157.74,33.04c-.19.08-.41-.02-.48-.21s.02-.41.21-.48.41.02.48.21-.02.41-.21.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.13,32.11c-.18.07-.38-.02-.45-.19s.02-.38.19-.45.38.02.45.19-.02.38-.19.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M168.57,31.59c-.17.07-.35-.01-.42-.18s.01-.35.18-.42.35.01.42.18-.01.35-.18.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.03,31.49c-.15.06-.33-.01-.39-.17s.01-.33.17-.39.33.01.39.17-.01.33-.17.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.48,31.81c-.14.06-.3-.01-.35-.15s.01-.3.15-.35.3.01.35.15-.01.3-.15.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.89,32.54c-.13.05-.27-.01-.32-.14s.01-.27.14-.32.27.01.32.14-.01.27-.14.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.23,33.69c-.11.05-.24,0-.29-.12s0-.24.12-.29.24,0,.29.12,0,.24-.12.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.38,
    cy: 35.05,
    r: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200.55,37.18c-.09.04-.19,0-.23-.1s0-.19.1-.23.19,0,.23.1,0,.19-.1.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 205.43,
    cy: 39.37,
    r: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.22,42.21c-.06.03-.14,0-.16-.07s0-.14.07-.16.14,0,.16.07,0,.14-.07.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.73,45.27c-.05.02-.11,0-.13-.06s0-.11.06-.13.11,0,.13.06,0,.11-.06.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 218.97,
    cy: 48.59,
    r: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 222.96,
    cy: 52.33,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.65,
    cy: 56.37,
    r: 0.02
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.09,
    cy: 39.21,
    r: 2.19,
    transform: "translate(126.21 238.97) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 219.84,
    cy: 42.69,
    r: 2.16,
    transform: "translate(126.46 246.23) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 224.31,
    cy: 46.51,
    r: 2.13,
    transform: "translate(126.16 253.5) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.47,
    cy: 50.67,
    r: 2.11,
    transform: "translate(125.31 260.72) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 232.3,
    cy: 55.13,
    r: 2.08,
    transform: "translate(60.5 220.93) rotate(-57.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 235.78,
    cy: 59.88,
    r: 2.05,
    transform: "translate(-2.78 12.25) rotate(-2.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.88,
    cy: 64.88,
    r: 2.03,
    transform: "translate(145.3 294.04) rotate(-82.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 241.59,
    cy: 70.1,
    r: 2,
    transform: "translate(80.98 263.71) rotate(-66.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 243.88,
    cy: 75.52,
    r: 1.97,
    transform: "translate(77.1 268.82) rotate(-66.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 245.76,
    cy: 81.09,
    r: 1.95,
    transform: "translate(72.82 273.62) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 247.21,
    cy: 86.8,
    r: 1.92,
    transform: "translate(132.16 322.19) rotate(-83.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 248.22,
    cy: 92.59,
    r: 1.89,
    transform: "translate(119.28 324.02) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 248.78,
    cy: 98.45,
    r: 1.87,
    transform: "translate(57.84 285.87) rotate(-66.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 248.9,
    cy: 104.33,
    r: 1.84,
    transform: "translate(97.11 327.48) rotate(-78.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 248.57,
    cy: 110.21,
    r: 1.81,
    transform: "translate(-7.26 18.09) rotate(-4.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 247.79,
    cy: 116.04,
    r: 1.79,
    transform: "translate(85.04 335.98) rotate(-78.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 246.56,
    cy: 121.79,
    r: 1.76,
    transform: "translate(15.54 270.97) rotate(-59.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.04,128.72c-.71.64-1.81.58-2.45-.14s-.58-1.81.14-2.45,1.81-.58,2.45.14.58,1.81-.14,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243.92,134.2c-.7.63-1.78.57-2.41-.13-.63-.7-.57-1.78.13-2.41.7-.63,1.78-.57,2.41.13s.57,1.78-.13,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.39,139.5c-.69.62-1.75.56-2.37-.13s-.56-1.75.13-2.37,1.75-.56,2.37.13c.62.69.56,1.75-.13,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.46,144.59c-.68.61-1.73.55-2.33-.13-.61-.68-.55-1.73.13-2.33.68-.61,1.73-.55,2.33.13.61.68.55,1.73-.13,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.15,149.44c-.67.6-1.7.54-2.3-.13-.6-.67-.54-1.7.13-2.3.67-.6,1.7-.54,2.3.13.6.67.54,1.7-.13,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.48,154.04c-.66.59-1.67.53-2.26-.13s-.53-1.67.13-2.26c.66-.59,1.67-.53,2.26.13s.53,1.67-.13,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M227.47,158.34c-.65.58-1.64.52-2.22-.12-.58-.65-.52-1.64.12-2.22.65-.58,1.64-.52,2.22.12.58.65.52,1.64-.12,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.14,162.32c-.64.57-1.61.51-2.18-.12s-.51-1.61.12-2.18c.64-.57,1.61-.51,2.18.12.57.64.51,1.61-.12,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.51,165.96c-.63.56-1.59.51-2.15-.12-.56-.63-.51-1.59.12-2.15s1.59-.51,2.15.12c.56.63.51,1.59-.12,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.61,169.23c-.61.55-1.56.5-2.11-.12-.55-.61-.5-1.56.12-2.11s1.56-.5,2.11.12.5,1.56-.12,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.48,172.11c-.6.54-1.53.49-2.07-.12s-.49-1.53.12-2.07c.6-.54,1.53-.49,2.07.12.54.6.49,1.53-.12,2.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 202.18,
    cy: 173.52,
    r: 1.44,
    transform: "translate(-48.78 263) rotate(-60.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.62,176.66c-.58.52-1.48.47-2-.11-.52-.58-.47-1.48.11-2,.58-.52,1.48-.47,2,.11.52.58.47,1.48-.11,2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.03,
    cy: 177.27,
    r: 1.39,
    transform: "translate(-52.02 271.31) rotate(-64.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.19,179.52c-.56.5-1.42.45-1.92-.11-.5-.56-.45-1.42.11-1.92.56-.5,1.42-.45,1.92.11s.45,1.42-.11,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.34,180.28c-.55.49-1.39.44-1.88-.11s-.44-1.39.11-1.88,1.39-.44,1.88.11.44,1.39-.11,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.45,180.61c-.54.48-1.36.43-1.84-.1s-.43-1.36.1-1.84,1.36-.43,1.84.1c.48.54.43,1.36-.1,1.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.7,
    cy: 179.52,
    r: 1.28,
    transform: "translate(-63.58 262.36) rotate(-66.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.84,
    cy: 178.97,
    r: 1.25,
    transform: "translate(-65.03 261.12) rotate(-67.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.04,
    cy: 177.96,
    r: 1.23,
    transform: "translate(-66.59 258.3) rotate(-68.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150.34,
    cy: 176.51,
    r: 1.2,
    transform: "translate(-66.79 257.82) rotate(-70.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.77,
    cy: 174.62,
    r: 1.17,
    transform: "translate(-66.13 258.12) rotate(-71.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.36,
    cy: 172.31,
    r: 1.15,
    transform: "translate(-67.8 251.04) rotate(-71.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.14,
    cy: 169.59,
    r: 1.12,
    transform: "translate(-68.32 245.54) rotate(-72.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 129.14,
    cy: 166.49,
    r: 1.09,
    transform: "translate(-63.12 252.68) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.39,
    cy: 163.01,
    r: 1.07,
    transform: "translate(-63.38 245.41) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.92,
    cy: 159.19,
    r: 1.04,
    transform: "translate(-61.84 240.94) rotate(-77.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 115.76,
    cy: 155.03,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M112.59,151.3c-.41.36-1.03.33-1.39-.08s-.33-1.03.08-1.39,1.03-.33,1.39.08c.36.41.33,1.03-.08,1.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.45,
    cy: 145.82,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 105.35,
    cy: 140.82,
    r: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.65,
    cy: 135.59,
    r: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 100.35,
    cy: 130.18,
    r: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 98.47,
    cy: 124.6,
    r: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 97.03,
    cy: 118.9,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 96.02,
    cy: 113.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.45,
    cy: 107.25,
    r: 0.77,
    transform: "translate(-29.07 35.78) rotate(-18.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 95.34,
    cy: 101.36,
    r: 0.75,
    transform: "translate(-29.9 40.7) rotate(-20.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.15,96.03c-.3.27-.75.24-1.02-.06s-.24-.75.06-1.02.75-.24,1.02.06.24.75-.06,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.92,90.18c-.29.26-.72.23-.98-.05s-.23-.72.05-.98.72-.23.98.05.23.72-.05.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.13,84.4c-.27.25-.7.22-.94-.05s-.22-.7.05-.94.7-.22.94.05.22.7-.05.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.78,78.74c-.26.24-.67.21-.9-.05s-.21-.67.05-.9.67-.21.9.05.21.67-.05.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.86,73.23c-.25.23-.64.2-.87-.05s-.2-.64.05-.87.64-.2.87.05c.23.25.2.64-.05.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.36,67.89c-.24.22-.61.2-.83-.05s-.2-.61.05-.83.61-.2.83.05.2.61-.05.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.26,62.76c-.23.21-.58.19-.79-.04s-.19-.58.04-.79c.23-.21.58-.19.79.04s.19.58-.04.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.53,57.86c-.22.2-.56.18-.75-.04s-.18-.56.04-.75.56-.18.75.04.18.56-.04.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.17,53.23c-.21.19-.53.17-.72-.04s-.17-.53.04-.72.53-.17.72.04.17.53-.04.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.14,48.89c-.2.18-.5.16-.68-.04s-.16-.5.04-.68.5-.16.68.04.16.5-.04.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.44,44.87c-.19.17-.47.15-.64-.04s-.15-.47.04-.64.47-.15.64.04.15.47-.04.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.03,41.19c-.18.16-.45.14-.6-.03s-.14-.45.03-.6.45-.14.6.03.14.45-.03.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.89,37.88c-.16.15-.42.13-.56-.03s-.13-.42.03-.56.42-.13.56.03.13.42-.03.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.99,34.96c-.15.14-.39.12-.53-.03s-.12-.39.03-.53.39-.12.53.03.12.39-.03.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.3,32.44c-.14.13-.36.12-.49-.03s-.12-.36.03-.49.36-.12.49.03.12.36-.03.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M147.78,30.33c-.13.12-.33.11-.45-.03s-.11-.33.03-.45.33-.11.45.03.11.33-.03.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.41,28.65c-.12.11-.31.1-.41-.02s-.1-.31.02-.41.31-.1.41.02.1.31-.02.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.14,27.4c-.11.1-.28.09-.38-.02s-.09-.28.02-.38.28-.09.38.02.09.28-.02.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.95,26.59c-.1.09-.25.08-.34-.02s-.08-.25.02-.34.25-.08.34.02.08.25-.02.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.67,
    cy: 26.07,
    r: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176.67,26.32c-.08.07-.19.06-.26-.01s-.06-.19.01-.26.19-.06.26.01.06.19-.01.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 182.41,
    cy: 26.74,
    r: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.29,27.85c-.05.05-.14.04-.19-.01s-.04-.14.01-.19.14-.04.19.01.04.14-.01.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.98,29.28s-.11.04-.15,0-.04-.11,0-.15.11-.04.15,0,.04.11,0,.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.48,
    cy: 31.08,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.89,
    cy: 33.39,
    r: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.11,
    cy: 36.11,
    r: 0.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.11,
    cy: 23.03,
    r: 2.35,
    transform: "translate(124.38 204.27) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.18,
    cy: 24.79,
    r: 2.32,
    transform: "translate(127.31 211.52) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 204.11,
    cy: 27.01,
    r: 2.29,
    transform: "translate(129.68 218.98) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.84,
    cy: 29.68,
    r: 2.27,
    transform: "translate(131.47 226.59) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.36,
    cy: 32.78,
    r: 2.24,
    transform: "translate(105.65 220.98) rotate(-68.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 220.62,
    cy: 36.3,
    r: 2.21,
    transform: "translate(-2.61 23.72) rotate(-6.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.59,
    cy: 40.21,
    r: 2.18,
    transform: "translate(164.86 261.16) rotate(-84.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.24,
    cy: 44.5,
    r: 2.15,
    transform: "translate(124.88 254) rotate(-74.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.56,
    cy: 49.12,
    r: 2.12,
    transform: "translate(123.51 261.49) rotate(-74.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.5,
    cy: 54.07,
    r: 2.09,
    transform: "translate(121.56 268.85) rotate(-74.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 242.06,
    cy: 59.3,
    r: 2.06,
    transform: "translate(162.79 295.58) rotate(-85.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 245.22,
    cy: 64.78,
    r: 2.04,
    transform: "translate(111.22 280.13) rotate(-72.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 247.94,
    cy: 70.49,
    r: 2.01,
    transform: "translate(112.42 289.76) rotate(-74.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 250.22,
    cy: 76.39,
    r: 1.98,
    transform: "translate(111.18 298.01) rotate(-74.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.05,
    cy: 82.45,
    r: 1.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 253.4,
    cy: 88.63,
    r: 1.92,
    transform: "translate(101.51 309.98) rotate(-74.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 254.27,
    cy: 94.89,
    r: 1.89,
    transform: "translate(70.78 294.87) rotate(-67.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.3,102.09c-.49.91-1.62,1.25-2.52.76-.91-.49-1.25-1.62-.76-2.52s1.62-1.25,2.52-.76,1.25,1.62.76,2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.18,108.4c-.48.89-1.59,1.23-2.48.75-.89-.48-1.23-1.59-.75-2.48s1.59-1.23,2.48-.75c.89.48,1.23,1.59.75,2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.57,114.69c-.47.88-1.57,1.21-2.45.74-.88-.47-1.21-1.57-.74-2.45.47-.88,1.57-1.21,2.45-.74s1.21,1.57.74,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M254.48,120.91c-.46.87-1.54,1.19-2.41.73-.87-.46-1.19-1.54-.73-2.41s1.54-1.19,2.41-.73,1.19,1.54.73,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.92,127.03c-.46.85-1.52,1.17-2.37.71-.85-.46-1.17-1.52-.71-2.37s1.52-1.17,2.37-.71c.85.46,1.17,1.52.71,2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.9,133.02c-.45.84-1.49,1.15-2.33.7-.84-.45-1.15-1.49-.7-2.33.45-.84,1.49-1.15,2.33-.7.84.45,1.15,1.49.7,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.43,138.84c-.44.82-1.47,1.13-2.29.69-.82-.44-1.13-1.47-.69-2.29s1.47-1.13,2.29-.69,1.13,1.47.69,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.51,144.46c-.43.81-1.44,1.11-2.25.68s-1.11-1.44-.68-2.25c.43-.81,1.44-1.11,2.25-.68s1.11,1.44.68,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.18,149.84c-.43.8-1.42,1.09-2.21.67s-1.09-1.42-.67-2.21c.43-.8,1.42-1.09,2.21-.67.8.43,1.09,1.42.67,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.43,154.94c-.42.78-1.39,1.08-2.17.66-.78-.42-1.08-1.39-.66-2.17s1.39-1.08,2.17-.66,1.08,1.39.66,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.31,159.74c-.41.77-1.37,1.06-2.14.64s-1.06-1.37-.64-2.14,1.37-1.06,2.14-.64,1.06,1.37.64,2.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.46,
    cy: 163.49,
    r: 1.55,
    transform: "translate(-6.61 317.32) rotate(-68.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.01,168.34c-.4.74-1.32,1.02-2.06.62s-1.02-1.32-.62-2.06,1.32-1.02,2.06-.62,1.02,1.32.62,2.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 218.58,
    cy: 171.38,
    r: 1.49,
    transform: "translate(-13.64 323.76) rotate(-71.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.51,175.43c-.38.71-1.27.98-1.98.6-.71-.38-.98-1.27-.6-1.98.38-.71,1.27-.98,1.98-.6s.98,1.27.6,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M208.88,178.35c-.37.7-1.24.96-1.94.59-.7-.37-.96-1.24-.59-1.94.37-.7,1.24-.96,1.94-.59.7.37.96,1.24.59,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.04,180.84c-.37.68-1.22.94-1.9.57-.68-.37-.94-1.22-.57-1.9s1.22-.94,1.9-.57.94,1.22.57,1.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 195.82,
    cy: 182.23,
    r: 1.38,
    transform: "translate(-37.95 312.26) rotate(-72.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 189.7,
    cy: 183.82,
    r: 1.35,
    transform: "translate(-42.47 309.82) rotate(-72.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.47,
    cy: 184.94,
    r: 1.32,
    transform: "translate(-48.13 304.2) rotate(-72.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.18,
    cy: 185.57,
    r: 1.29,
    transform: "translate(-51.24 302.42) rotate(-73.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 170.85,
    cy: 185.71,
    r: 1.26,
    transform: "translate(-54.32 299.63) rotate(-74.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.54,
    cy: 185.37,
    r: 1.23,
    transform: "translate(-58.67 293.13) rotate(-74.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.26,
    cy: 184.54,
    r: 1.2,
    transform: "translate(-63.55 284.05) rotate(-73.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.07,
    cy: 183.24,
    r: 1.18,
    transform: "translate(-61.88 287.76) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 146,
    cy: 181.47,
    r: 1.15,
    transform: "translate(-64.81 280.51) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 140.07,
    cy: 179.25,
    r: 1.12,
    transform: "translate(-68.14 270.91) rotate(-75.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.34,
    cy: 176.59,
    r: 1.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.76,173.98c-.28.52-.92.71-1.44.43s-.71-.92-.43-1.44.92-.71,1.44-.43c.52.28.71.92.43,1.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.57,
    cy: 169.96,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 118.6,
    cy: 166.05,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 113.94,
    cy: 161.77,
    r: 0.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 109.63,
    cy: 157.14,
    r: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 105.68,
    cy: 152.2,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.12,
    cy: 146.97,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 98.97,
    cy: 141.48,
    r: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 96.25,
    cy: 135.77,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 93.97,
    cy: 129.87,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.82,124.18c-.2.38-.67.52-1.05.32-.38-.2-.52-.67-.32-1.05s.67-.52,1.05-.32.52.67.32,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.45,117.98c-.19.36-.65.5-1.01.3-.36-.19-.5-.65-.3-1.01s.65-.5,1.01-.3.5.65.3,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.55,111.71c-.19.35-.62.48-.97.29s-.48-.62-.29-.97.62-.48.97-.29.48.62.29.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.14,105.38c-.18.33-.6.46-.93.28s-.46-.6-.28-.93.6-.46.93-.28.46.6.28.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.21,99.04c-.17.32-.57.44-.89.27s-.44-.57-.27-.89.57-.44.89-.27.44.57.27.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.77,92.73c-.16.31-.55.42-.85.26s-.42-.55-.26-.85.55-.42.85-.26.42.55.26.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.81,86.48c-.16.29-.52.4-.82.25s-.4-.52-.25-.82.52-.4.82-.25c.29.16.4.52.25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.32,80.33c-.15.28-.5.38-.78.23s-.38-.5-.23-.78.5-.38.78-.23.38.5.23.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.29,74.31c-.14.27-.47.36-.74.22s-.36-.47-.22-.74.47-.36.74-.22.36.47.22.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.71,68.46c-.13.25-.45.35-.7.21s-.35-.45-.21-.7.45-.35.7-.21.35.45.21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.57,62.82c-.13.24-.42.33-.66.2s-.33-.42-.2-.66.42-.33.66-.2.33.42.2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.86,57.42c-.12.22-.4.31-.62.19s-.31-.4-.19-.62.4-.31.62-.19.31.4.19.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.56,52.28c-.11.21-.37.29-.58.18s-.29-.37-.18-.58.37-.29.58-.18.29.37.18.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.63,47.45c-.1.2-.35.27-.54.16s-.27-.35-.16-.54.35-.27.54-.16.27.35.16.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.07,42.95c-.1.18-.32.25-.5.15s-.25-.32-.15-.5.32-.25.5-.15.25.32.15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.83,38.81c-.09.17-.3.23-.47.14s-.23-.3-.14-.47.3-.23.47-.14.23.3.14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.9,35.04c-.08.15-.27.21-.43.13s-.21-.27-.13-.43.27-.21.43-.13.21.27.13.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.23,31.67c-.07.14-.25.19-.39.12s-.19-.25-.12-.39.25-.19.39-.12.19.25.12.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.81,28.71c-.07.13-.22.17-.35.11s-.17-.22-.11-.35.22-.17.35-.11.17.22.11.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.39,
    cy: 26.09,
    r: 0.23,
    transform: "translate(58 143.7) rotate(-64.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.55,24.13c-.05.1-.17.13-.27.08s-.13-.17-.08-.27.17-.13.27-.08.13.17.08.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.5,
    cy: 22.45,
    r: 0.17,
    transform: "translate(66.82 151.62) rotate(-64.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.85,21.4c-.04.07-.12.1-.19.06s-.1-.12-.06-.19.12-.1.19-.06.1.12.06.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.12,20.75c-.03.06-.1.08-.16.05s-.08-.1-.05-.16.1-.08.16-.05.08.1.05.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 173.35,
    cy: 20.56,
    r: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.66,
    cy: 20.9,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 185.93,
    cy: 21.73,
    r: 0.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.94,
    cy: 15.13,
    r: 2.53,
    transform: "translate(109.77 169.89) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.73,
    cy: 14.68,
    r: 2.5,
    transform: "translate(115.4 176.14) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.53,
    cy: 14.74,
    r: 2.47,
    transform: "translate(120.53 182.8) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 183.3,
    cy: 15.33,
    r: 2.44,
    transform: "translate(125.14 189.83) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.02,
    cy: 16.43,
    r: 2.4,
    transform: "translate(138.64 200.11) rotate(-79.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 196.62,
    cy: 18.06,
    r: 2.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 203.08,
    cy: 20.18,
    r: 2.34,
    transform: "translate(156.06 218.77) rotate(-82.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 209.36,
    cy: 22.8,
    r: 2.31,
    transform: "translate(158.07 227.06) rotate(-82.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.42,
    cy: 25.89,
    r: 2.28,
    transform: "translate(160.42 235.77) rotate(-82.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 221.23,
    cy: 29.43,
    r: 2.25,
    transform: "translate(162.11 244.63) rotate(-82.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.75,
    cy: 33.4,
    r: 2.22,
    transform: "translate(165.14 254.16) rotate(-82.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 231.95,
    cy: 37.79,
    r: 2.19,
    transform: "translate(109.12 238.14) rotate(-67.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 236.81,
    cy: 42.55,
    r: 2.16,
    transform: "translate(163.17 271.61) rotate(-82.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 241.28,
    cy: 47.68,
    r: 2.13,
    transform: "translate(122.25 262.9) rotate(-72.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 245.35,
    cy: 53.13,
    r: 2.1,
    transform: "translate(88.64 249.24) rotate(-63.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 248.99,
    cy: 58.87,
    r: 2.07,
    transform: "translate(116.43 277.71) rotate(-72.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.18,
    cy: 64.88,
    r: 2.03,
    transform: "translate(132.14 295.95) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.88,71.41c-.16,1.1-1.17,1.86-2.27,1.7-1.1-.16-1.86-1.17-1.7-2.27s1.17-1.86,2.27-1.7c1.1.16,1.86,1.17,1.7,2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M259.07,77.83c-.16,1.08-1.16,1.83-2.23,1.67-1.08-.16-1.83-1.16-1.67-2.23.16-1.08,1.16-1.83,2.23-1.67,1.08.16,1.83,1.16,1.67,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.76,84.4c-.15,1.06-1.14,1.8-2.2,1.65-1.06-.15-1.8-1.14-1.65-2.2s1.14-1.8,2.2-1.65,1.8,1.14,1.65,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.95,91.09c-.15,1.04-1.12,1.77-2.16,1.62s-1.77-1.12-1.62-2.16c.15-1.04,1.12-1.77,2.16-1.62s1.77,1.12,1.62,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.63,97.85c-.15,1.03-1.1,1.74-2.13,1.59s-1.74-1.1-1.59-2.13,1.1-1.74,2.13-1.59,1.74,1.1,1.59,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.79,104.65c-.15,1.01-1.08,1.71-2.09,1.57s-1.71-1.08-1.57-2.09,1.08-1.71,2.09-1.57c1.01.15,1.71,1.08,1.57,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.44,111.44c-.14.99-1.07,1.68-2.06,1.54-.99-.14-1.68-1.07-1.54-2.06.14-.99,1.07-1.68,2.06-1.54s1.68,1.07,1.54,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.56,118.19c-.14.98-1.05,1.66-2.02,1.51-.98-.14-1.66-1.05-1.51-2.02.14-.98,1.05-1.66,2.02-1.51s1.66,1.05,1.51,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.16,124.85c-.14.96-1.03,1.63-1.99,1.49s-1.63-1.03-1.49-1.99c.14-.96,1.03-1.63,1.99-1.49s1.63,1.03,1.49,1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.26,131.38c-.14.94-1.01,1.6-1.96,1.46-.94-.14-1.6-1.01-1.46-1.96s1.01-1.6,1.96-1.46,1.6,1.01,1.46,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.85,137.75c-.13.93-.99,1.57-1.92,1.44s-1.57-.99-1.44-1.92.99-1.57,1.92-1.44,1.57.99,1.44,1.92Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 251.32,
    cy: 143.68,
    r: 1.66,
    transform: "translate(57.06 358.32) rotate(-77.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.62,149.85c-.13.89-.96,1.51-1.85,1.38-.89-.13-1.51-.96-1.38-1.85.13-.89.96-1.51,1.85-1.38s1.51.96,1.38,1.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 244.24,
    cy: 155.29,
    r: 1.6,
    transform: "translate(45.63 365.81) rotate(-79.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.61,160.88c-.12.86-.92,1.46-1.78,1.33-.86-.12-1.46-.92-1.33-1.78.12-.86.92-1.46,1.78-1.33s1.46.92,1.33,1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237,165.9c-.12.84-.9,1.43-1.75,1.31s-1.43-.9-1.31-1.75.9-1.43,1.75-1.31c.84.12,1.43.9,1.31,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M232.02,170.57c-.12.83-.88,1.4-1.71,1.28-.83-.12-1.4-.88-1.28-1.71s.88-1.4,1.71-1.28c.83.12,1.4.88,1.28,1.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 225.24,
    cy: 174.63,
    r: 1.48,
    transform: "translate(7.78 358.85) rotate(-78.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 219.64,
    cy: 178.48,
    r: 1.45,
    transform: "translate(-.42 356.46) rotate(-78.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 213.75,
    cy: 181.9,
    r: 1.42,
    transform: "translate(-10.98 350.04) rotate(-77.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.63,
    cy: 184.85,
    r: 1.39,
    transform: "translate(-17.89 347.41) rotate(-77.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.29,
    cy: 187.32,
    r: 1.36,
    transform: "translate(-26.08 341.96) rotate(-77.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.78,
    cy: 189.3,
    r: 1.33,
    transform: "translate(-33.03 337.21) rotate(-77.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.14,
    cy: 190.77,
    r: 1.29,
    transform: "translate(-42.8 326.63) rotate(-75.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 181.4,
    cy: 191.73,
    r: 1.26,
    transform: "translate(-47.73 322.75) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 174.62,
    cy: 192.18,
    r: 1.23,
    transform: "translate(-53.36 316.5) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.81,
    cy: 192.12,
    r: 1.2,
    transform: "translate(-61.95 302.93) rotate(-74.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.04,
    cy: 191.53,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.45,190.59c-.09.62-.67,1.06-1.29.97-.62-.09-1.06-.67-.97-1.29s.67-1.06,1.29-.97c.62.09,1.06.67.97,1.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 147.72,
    cy: 188.8,
    r: 1.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 141.26,
    cy: 186.68,
    r: 1.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 134.98,
    cy: 184.06,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 128.92,
    cy: 180.97,
    r: 1.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.11,
    cy: 177.43,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.59,
    cy: 173.45,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.39,
    cy: 169.07,
    r: 0.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 107.54,
    cy: 164.3,
    r: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 103.06,
    cy: 159.18,
    r: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.82,153.85c-.07.46-.49.77-.94.71s-.77-.49-.71-.94c.07-.46.49-.77.94-.71s.77.49.71.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.15,148.09c-.06.44-.47.74-.91.68s-.74-.47-.68-.91.47-.74.91-.68.74.47.68.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.93,142.08c-.06.42-.45.71-.87.65s-.71-.45-.65-.87.45-.71.87-.65.71.45.65.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.19,135.84c-.06.4-.43.69-.84.63s-.69-.43-.63-.84c.06-.4.43-.69.84-.63.4.06.69.43.63.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.93,129.41c-.06.39-.42.66-.8.6s-.66-.42-.6-.8c.06-.39.42-.66.8-.6s.66.42.6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.18,122.82c-.05.37-.4.63-.77.57-.37-.05-.63-.4-.57-.77s.4-.63.77-.57c.37.05.63.4.57.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.93,116.12c-.05.35-.38.6-.73.55-.35-.05-.6-.38-.55-.73s.38-.6.73-.55.6.38.55.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.19,109.35c-.05.34-.36.57-.7.52s-.57-.36-.52-.7.36-.57.7-.52.57.36.52.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.97,102.55c-.05.32-.34.54-.66.5s-.54-.34-.5-.66c.05-.32.34-.54.66-.5s.54.34.5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.27,95.75c-.04.3-.33.51-.63.47s-.51-.33-.47-.63.33-.51.63-.47.51.33.47.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.08,89c-.04.29-.31.49-.59.44-.29-.04-.49-.31-.44-.59s.31-.49.59-.44.49.31.44.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.42,82.33c-.04.27-.29.46-.56.42s-.46-.29-.42-.56.29-.46.56-.42.46.29.42.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.26,75.78c-.04.25-.27.43-.52.39s-.43-.27-.39-.52.27-.43.52-.39.43.27.39.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.61,69.41c-.03.24-.25.4-.49.37s-.4-.25-.37-.49.25-.4.49-.37.4.25.37.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.43,63.23c-.03.22-.23.37-.45.34s-.37-.23-.34-.45.23-.37.45-.34.37.23.34.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.72,57.29c-.03.2-.22.34-.42.31s-.34-.22-.31-.42.22-.34.42-.31.34.22.31.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.45,51.61c-.03.19-.2.31-.38.29s-.31-.2-.29-.38.2-.31.38-.29.31.2.29.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.6,46.24c-.02.17-.18.29-.35.26s-.29-.18-.26-.35.18-.29.35-.26.29.18.26.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.15,41.21c-.02.15-.16.26-.31.24s-.26-.16-.24-.31.16-.26.31-.24.26.16.24.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 113.83,
    cy: 36.5,
    r: 0.25,
    transform: "translate(59.38 142.92) rotate(-80.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.33,32.26c-.02.12-.13.2-.24.18s-.2-.13-.18-.24.13-.2.24-.18.2.13.18.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.72,
    cy: 28.37,
    r: 0.18,
    transform: "translate(77.02 147.05) rotate(-80.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.76,24.98c-.01.08-.09.14-.17.13s-.14-.09-.13-.17.09-.14.17-.13.14.09.13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.85,22.02c0,.07-.07.11-.14.1s-.11-.07-.1-.14.07-.11.14-.1.11.07.1.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 143.07,
    cy: 19.53,
    r: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 149.58,
    cy: 17.56,
    r: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 156.22,
    cy: 16.09,
    r: 0.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.56,
    cy: 17.87,
    r: 2.72,
    transform: "translate(82.37 140.52) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 137.25,
    cy: 14.92,
    r: 2.69,
    transform: "translate(90.35 144.77) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 144.15,
    cy: 12.49,
    r: 2.65,
    transform: "translate(97.99 149.61) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.21,
    cy: 10.59,
    r: 2.62,
    transform: "translate(105.23 155.02) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 158.4,
    cy: 9.23,
    r: 2.59,
    transform: "translate(-.04 .77) rotate(-.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 165.67,
    cy: 8.44,
    r: 2.55,
    transform: "translate(70.92 144.6) rotate(-58.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 172.98,
    cy: 8.21,
    r: 2.52,
    transform: "translate(120.71 173.31) rotate(-75.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 180.29,
    cy: 8.55,
    r: 2.49,
    transform: "translate(170.4 188.77) rotate(-89.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 187.55,
    cy: 9.44,
    r: 2.45,
    transform: "translate(177.12 196.93) rotate(-89.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.72,
    cy: 10.88,
    r: 2.42,
    transform: "translate(183.24 205.57) rotate(-89.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 201.76,
    cy: 12.87,
    r: 2.39,
    transform: "translate(137.29 204.48) rotate(-75.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 208.62,
    cy: 15.39,
    r: 2.35,
    transform: "translate(116.36 203.13) rotate(-68.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 215.28,
    cy: 18.42,
    r: 2.32,
    transform: "translate(-.07 .83) rotate(-.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 221.69,
    cy: 21.95,
    r: 2.29,
    transform: "translate(132.03 225.88) rotate(-71.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 227.8,
    cy: 25.96,
    r: 2.25,
    transform: "translate(87.35 207.18) rotate(-58.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 233.6,
    cy: 30.43,
    r: 2.22,
    transform: "translate(131.71 242.82) rotate(-71.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 239.03,
    cy: 35.33,
    r: 2.19,
    transform: "translate(187.15 271.31) rotate(-86.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.17,40.19c.24,1.16-.5,2.31-1.67,2.55-1.16.24-2.31-.5-2.55-1.67-.24-1.16.5-2.31,1.67-2.55,1.16-.24,2.31.5,2.55,1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.75,45.87c.24,1.15-.5,2.27-1.64,2.51-1.15.24-2.27-.5-2.51-1.64s.5-2.27,1.64-2.51c1.15-.24,2.27.5,2.51,1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M254.88,51.9c.24,1.13-.49,2.24-1.62,2.47-1.13.24-2.24-.49-2.47-1.62s.49-2.24,1.62-2.47c1.13-.24,2.24.49,2.47,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.54,58.22c.23,1.11-.48,2.2-1.59,2.43-1.11.23-2.2-.48-2.43-1.59s.48-2.2,1.59-2.43c1.11-.23,2.2.48,2.43,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.71,64.8c.23,1.09-.47,2.16-1.57,2.39s-2.16-.47-2.39-1.57.47-2.16,1.57-2.39c1.09-.23,2.16.47,2.39,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.37,71.61c.22,1.08-.46,2.13-1.54,2.35s-2.13-.46-2.35-1.54c-.22-1.08.46-2.13,1.54-2.35s2.13.46,2.35,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.51,78.6c.22,1.06-.46,2.09-1.51,2.31-1.06.22-2.09-.46-2.31-1.51s.46-2.09,1.51-2.31,2.09.46,2.31,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.11,85.74c.22,1.04-.45,2.06-1.49,2.28-1.04.22-2.06-.45-2.28-1.49s.45-2.06,1.49-2.28c1.04-.22,2.06.45,2.28,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.14,92.98c.21,1.02-.44,2.02-1.46,2.24-1.02.21-2.02-.44-2.24-1.46-.21-1.02.44-2.02,1.46-2.24s2.02.44,2.24,1.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.62,100.28c.21,1-.43,1.99-1.44,2.2s-1.99-.43-2.2-1.44c-.21-1,.43-1.99,1.44-2.2,1-.21,1.99.43,2.2,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.54,107.6c.21.99-.43,1.95-1.41,2.16s-1.95-.43-2.16-1.41c-.21-.99.43-1.95,1.41-2.16.99-.21,1.95.43,2.16,1.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 267.14,
    cy: 115.26,
    r: 1.79,
    transform: "translate(135.27 374.61) rotate(-86.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M267.69,122.13c.2.95-.41,1.88-1.36,2.08-.95.2-1.88-.41-2.08-1.36s.41-1.88,1.36-2.08,1.88.41,2.08,1.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.25,
    cy: 129.59,
    r: 1.72,
    transform: "translate(119.46 385.84) rotate(-86.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.65,136.21c.19.91-.4,1.81-1.31,2-.91.19-1.81-.4-2-1.31s.4-1.81,1.31-2,1.81.4,2,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.84,142.98c.19.9-.39,1.77-1.28,1.96s-1.77-.39-1.96-1.28c-.19-.9.39-1.77,1.28-1.96.9-.19,1.77.39,1.96,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257.53,149.52c.18.88-.38,1.74-1.26,1.92s-1.74-.38-1.92-1.26c-.18-.88.38-1.74,1.26-1.92s1.74.38,1.92,1.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.17,
    cy: 156.12,
    r: 1.59,
    transform: "translate(69.89 390.09) rotate(-83.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 247.92,
    cy: 162.08,
    r: 1.56,
    transform: "translate(57.82 389.23) rotate(-83.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 243.24,
    cy: 167.7,
    r: 1.52,
    transform: "translate(42.39 384.36) rotate(-81.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.13,
    cy: 172.93,
    r: 1.49,
    transform: "translate(30.96 381.96) rotate(-81.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 232.63,
    cy: 177.76,
    r: 1.46,
    transform: "translate(16.69 375.46) rotate(-79.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.78,
    cy: 182.15,
    r: 1.43,
    transform: "translate(7.79 373.59) rotate(-79.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 220.61,
    cy: 186.08,
    r: 1.39,
    transform: "translate(-6.2 364.55) rotate(-78.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 214.16,
    cy: 189.53,
    r: 1.36,
    transform: "translate(-20.56 352.9) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.47,
    cy: 192.48,
    r: 1.33,
    transform: "translate(-28.54 348.65) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.57,
    cy: 194.92,
    r: 1.29,
    transform: "translate(-41.2 335.51) rotate(-74.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 193.51,
    cy: 196.81,
    r: 1.26,
    transform: "translate(-59.58 306.94) rotate(-69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.52,197.91c.14.66-.29,1.31-.95,1.45s-1.31-.29-1.45-.95c-.14-.66.29-1.31.95-1.45s1.31.29,1.45.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 179.05,
    cy: 198.96,
    r: 1.19,
    transform: "translate(-78.26 272.68) rotate(-64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 171.74,
    cy: 199.18,
    r: 1.16,
    transform: "translate(-85.45 254.16) rotate(-61.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 164.43,
    cy: 198.85,
    r: 1.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 157.17,
    cy: 197.96,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150,
    cy: 196.51,
    r: 1.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 142.96,
    cy: 194.52,
    r: 1.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 136.1,
    cy: 192.01,
    r: 0.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 129.44,
    cy: 188.98,
    r: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.03,
    cy: 185.44,
    r: 0.93,
    transform: "translate(-82.73 100.66) rotate(-34.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.79,181.25c.1.48-.21.96-.69,1.06s-.96-.21-1.06-.69.21-.96.69-1.06.96.21,1.06.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.97,176.79c.1.47-.2.92-.67,1.02s-.92-.2-1.02-.67.2-.92.67-1.02.92.2,1.02.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.51,171.9c.09.45-.19.89-.64.98s-.89-.19-.98-.64.19-.89.64-.98.89.19.98.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.44,166.6c.09.43-.19.85-.62.94s-.85-.19-.94-.62.19-.85.62-.94.85.19.94.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.8,160.93c.09.41-.18.82-.59.9s-.82-.18-.9-.59.18-.82.59-.9.82.18.9.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.6,154.92c.08.39-.17.78-.56.86s-.78-.17-.86-.56.17-.78.56-.86c.39-.08.78.17.86.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.88,148.61c.08.38-.16.75-.54.82s-.75-.16-.82-.54c-.08-.38.16-.75.54-.82s.75.16.82.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.64,142.04c.07.36-.15.71-.51.78-.36.07-.71-.15-.78-.51s.15-.71.51-.78.71.15.78.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.92,135.25c.07.34-.15.67-.49.75s-.67-.15-.75-.49.15-.67.49-.75.67.15.75.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.71,128.27c.07.32-.14.64-.46.71s-.64-.14-.71-.46.14-.64.46-.71.64.14.71.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.06,121.14c.06.3-.13.6-.44.67-.3.06-.6-.13-.67-.44s.13-.6.44-.67.6.13.67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.95,113.92c.06.29-.12.57-.41.63s-.57-.12-.63-.41.12-.57.41-.63.57.12.63.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.41,106.63c.06.27-.12.53-.39.59s-.53-.12-.59-.39.12-.53.39-.59.53.12.59.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.43,99.32c.05.25-.11.5-.36.55s-.5-.11-.55-.36.11-.5.36-.55.5.11.55.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M78.01,92.04c.05.23-.1.46-.33.51s-.46-.1-.51-.33.1-.46.33-.51c.23-.05.46.1.51.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.15,84.82c.04.22-.09.43-.31.47s-.43-.09-.47-.31.09-.43.31-.47.43.09.47.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.84,77.72c.04.2-.09.39-.28.43s-.39-.09-.43-.28.09-.39.28-.43.39.09.43.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.06,70.77c.04.18-.08.35-.26.39s-.35-.08-.39-.26.08-.35.26-.39.35.08.39.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.8,64.01c.03.16-.07.32-.23.35s-.32-.07-.35-.23.07-.32.23-.35.32.07.35.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 88.8,
    cy: 57.53,
    r: 0.27,
    transform: "translate(-6.28 11.12) rotate(-6.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.8,51.22c.03.13-.05.25-.18.27s-.25-.05-.27-.18.05-.25.18-.27.25.05.27.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 96.81,
    cy: 45.31,
    r: 0.2,
    transform: "translate(-5.36 13.9) rotate(-7.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.66,39.66c.02.09-.04.18-.13.2s-.18-.04-.2-.13.04-.18.13-.2.18.04.2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.74,34.43c.01.07-.03.14-.1.16s-.14-.03-.16-.1.03-.14.1-.16.14.03.16.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.1,
    cy: 29.63,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.95,
    cy: 25.24,
    r: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.12,
    cy: 21.31,
    r: 0.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 98.85,
    cy: 32.56,
    r: 2.92,
    transform: "translate(43.88 120.93) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 104.52,
    cy: 27.11,
    r: 2.89,
    transform: "translate(53.5 122.28) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 110.6,
    cy: 22.11,
    r: 2.85,
    transform: "translate(63 124.37) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 117.04,
    cy: 17.6,
    r: 2.82,
    transform: "translate(72.31 127.17) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.8,
    cy: 13.59,
    r: 2.78,
    transform: "translate(-.2 25.26) rotate(-11.64)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 130.86,
    cy: 10.11,
    r: 2.74,
    transform: "translate(52.69 115.55) rotate(-57.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.16,
    cy: 7.19,
    r: 2.71,
    transform: "translate(82.08 133.67) rotate(-69.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 145.67,
    cy: 4.84,
    r: 2.67,
    transform: "translate(.2 13.92) rotate(-5.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 153.33,
    cy: 3.08,
    r: 2.64,
    transform: "translate(.46 15.28) rotate(-5.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.11,
    cy: 1.9,
    r: 2.6,
    transform: "translate(.67 16.74) rotate(-5.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.95,
    cy: 1.32,
    r: 2.57,
    transform: "translate(106.02 158.12) rotate(-68.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.82,
    cy: 1.33,
    r: 2.53,
    transform: "translate(119.02 168.44) rotate(-71.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.66,
    cy: 1.95,
    r: 2.5,
    transform: "translate(1.04 21.64) rotate(-6.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 192.43,
    cy: 3.16,
    r: 2.46,
    transform: "translate(134.78 186.77) rotate(-73.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 200.08,
    cy: 4.96,
    r: 2.42,
    transform: "translate(104.57 180.84) rotate(-62.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.58,
    cy: 7.35,
    r: 2.39,
    transform: "translate(141.35 204.21) rotate(-73.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 214.87,
    cy: 10.3,
    r: 2.35,
    transform: "translate(-.12 17.73) rotate(-4.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.87,12.59c.67,1.09.34,2.52-.75,3.19-1.09.67-2.52.34-3.19-.75s-.34-2.52.75-3.19c1.09-.67,2.52-.34,3.19.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.59,16.64c.66,1.07.33,2.48-.74,3.14-1.07.66-2.48.33-3.14-.74s-.33-2.48.74-3.14c1.07-.66,2.48-.33,3.14.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.98,21.21c.65,1.05.33,2.44-.73,3.09-1.05.65-2.44.33-3.09-.73s-.33-2.44.73-3.09,2.44-.33,3.09.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M243,26.25c.64,1.04.32,2.4-.71,3.04-1.04.64-2.4.32-3.04-.71-.64-1.04-.32-2.4.71-3.04,1.04-.64,2.4-.32,3.04.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.62,31.74c.63,1.02.32,2.36-.7,2.99s-2.36.32-2.99-.7-.32-2.36.7-2.99c1.02-.63,2.36-.32,2.99.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.82,37.63c.62,1,.31,2.32-.69,2.94-1,.62-2.32.31-2.94-.69-.62-1-.31-2.32.69-2.94s2.32-.31,2.94.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.55,43.91c.61.99.31,2.28-.68,2.9s-2.28.31-2.9-.68c-.61-.99-.31-2.28.68-2.9s2.28-.31,2.9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.79,50.54c.6.97.3,2.24-.67,2.85-.97.6-2.24.3-2.85-.67-.6-.97-.3-2.24.67-2.85s2.24-.3,2.85.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.5,57.48c.59.95.3,2.21-.66,2.8-.95.59-2.21.3-2.8-.66-.59-.95-.3-2.21.66-2.8s2.21-.3,2.8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.67,64.68c.58.94.29,2.17-.64,2.75s-2.17.29-2.75-.64c-.58-.94-.29-2.17.64-2.75.94-.58,2.17-.29,2.75.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.28,72.11c.57.92.29,2.13-.63,2.7s-2.13.29-2.7-.63-.29-2.13.63-2.7c.92-.57,2.13-.29,2.7.63Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 272.67,
    cy: 80.73,
    r: 1.92,
    transform: "translate(-5.73 22.76) rotate(-4.73)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.75,87.46c.55.89.28,2.05-.61,2.6s-2.05.28-2.6-.61c-.55-.89-.28-2.05.61-2.6s2.05-.28,2.6.61Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 275.02,
    cy: 96.27,
    r: 1.85,
    transform: "translate(-4.89 15.32) rotate(-3.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.85,103.18c.53.85.27,1.97-.59,2.5s-1.97.27-2.5-.59c-.53-.85-.27-1.97.59-2.5.85-.53,1.97-.27,2.5.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M276.5,111.05c.52.84.26,1.94-.58,2.45-.84.52-1.94.26-2.45-.58s-.26-1.94.58-2.45,1.94-.26,2.45.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.56,118.88c.51.82.26,1.9-.56,2.4-.82.51-1.9.26-2.4-.56s-.26-1.9.56-2.4c.82-.51,1.9-.26,2.4.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 272.57,
    cy: 127.52,
    r: 1.71,
    transform: "translate(136.8 396.08) rotate(-88.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 270.47,
    cy: 135.1,
    r: 1.68,
    transform: "translate(121.17 398) rotate(-86.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 267.8,
    cy: 142.5,
    r: 1.64,
    transform: "translate(102.51 396.87) rotate(-85)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 264.57,
    cy: 149.67,
    r: 1.6,
    transform: "translate(86.45 395.99) rotate(-83.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 260.79,
    cy: 156.57,
    r: 1.57,
    transform: "translate(66.83 390.88) rotate(-81.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 256.49,
    cy: 163.16,
    r: 1.53,
    transform: "translate(57.12 392.63) rotate(-81.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 251.7,
    cy: 169.39,
    r: 1.5,
    transform: "translate(41.74 388.4) rotate(-80.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 246.45,
    cy: 175.25,
    r: 1.46,
    transform: "translate(17.98 373.37) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 240.78,
    cy: 180.7,
    r: 1.43,
    transform: "translate(8.35 372.01) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 234.7,
    cy: 185.69,
    r: 1.39,
    transform: "translate(-5.37 364.39) rotate(-75.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 228.27,
    cy: 190.21,
    r: 1.35,
    transform: "translate(-29.67 337.7) rotate(-69.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.62,193.52c.38.62.19,1.43-.43,1.82-.62.38-1.43.19-1.82-.43-.38-.62-.19-1.43.43-1.82s1.43-.19,1.82.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 214.44,
    cy: 197.69,
    r: 1.28,
    transform: "translate(-55.83 307.34) rotate(-64.76)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 207.14,
    cy: 200.61,
    r: 1.25,
    transform: "translate(-64.32 297.89) rotate(-63.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 199.63,
    cy: 202.96,
    r: 1.21,
    transform: "translate(-76.82 270.94) rotate(-59.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 191.97,
    cy: 204.73,
    r: 1.18,
    transform: "translate(-82.5 263.33) rotate(-58.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 184.19,
    cy: 205.9,
    r: 1.14,
    transform: "translate(-87.85 254.01) rotate(-58.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.35,
    cy: 206.49,
    r: 1.11,
    transform: "translate(-94.34 227.99) rotate(-54.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 168.48,
    cy: 206.47,
    r: 1.07,
    transform: "translate(-97.68 219.61) rotate(-53.61)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.64,
    cy: 205.85,
    r: 1.03,
    transform: "translate(-100.4 199.64) rotate(-50.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 152.87,
    cy: 204.64,
    r: 1,
    transform: "translate(-101.92 186.58) rotate(-49.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.04,202.33c.28.45.14,1.05-.31,1.33-.45.28-1.05.14-1.33-.31s-.14-1.05.31-1.33c.45-.28,1.05-.14,1.33.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.51,199.96c.27.44.14,1.01-.3,1.28s-1.01.14-1.28-.3-.14-1.01.3-1.28,1.01-.14,1.28.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.19,197.03c.26.42.13.97-.29,1.23-.42.26-.97.13-1.23-.29s-.13-.97.29-1.23.97-.13,1.23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.12,193.54c.25.4.13.93-.28,1.18s-.93.13-1.18-.28-.13-.93.28-1.18c.4-.25.93-.13,1.18.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.34,189.52c.24.38.12.89-.26,1.13-.38.24-.89.12-1.13-.26s-.12-.89.26-1.13.89-.12,1.13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.9,184.99c.23.37.11.85-.25,1.08s-.85.11-1.08-.25-.11-.85.25-1.08.85-.11,1.08.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104.82,179.98c.22.35.11.81-.24,1.03s-.81.11-1.03-.24c-.22-.35-.11-.81.24-1.03s.81-.11,1.03.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.13,174.53c.21.33.1.77-.23.98s-.77.1-.98-.23-.1-.77.23-.98.77-.1.98.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.88,168.67c.2.32.1.74-.22.93s-.74.1-.93-.22-.1-.74.22-.93.74-.1.93.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.09,162.43c.19.3.09.7-.21.88s-.7.09-.88-.21c-.19-.3-.09-.7.21-.88s.7-.09.88.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.79,155.84c.18.28.09.66-.2.83s-.66.09-.83-.2-.09-.66.2-.83.66-.09.83.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.02,148.94c.17.27.08.62-.18.79s-.62.08-.79-.18c-.17-.27-.08-.62.18-.79s.62-.08.79.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.79,141.78c.16.25.08.58-.17.74s-.58.08-.74-.17-.08-.58.17-.74.58-.08.74.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.12,134.39c.15.23.07.54-.16.69s-.54.07-.69-.16-.07-.54.16-.69c.23-.15.54-.07.69.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.03,126.82c.13.22.07.5-.15.64s-.5.07-.64-.15-.07-.5.15-.64.5-.07.64.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.53,119.11c.12.2.06.46-.14.59s-.46.06-.59-.14-.06-.46.14-.59.46-.06.59.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.62,111.31c.11.18.06.43-.13.54s-.43.06-.54-.13c-.11-.18-.06-.43.13-.54s.43-.06.54.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.31,103.47c.1.17.05.39-.12.49s-.39.05-.49-.12-.05-.39.12-.49.39-.05.49.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.59,95.63c.09.15.05.35-.1.44s-.35.05-.44-.1-.05-.35.1-.44.35-.05.44.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.24,
    cy: 87.99,
    r: 0.29,
    transform: "translate(-30.12 37.55) rotate(-24.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.96,80.14c.07.12.04.27-.08.34s-.27.04-.34-.08-.04-.27.08-.34.27-.04.34.08Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 74.84,
    cy: 72.69,
    r: 0.21,
    transform: "translate(-24.47 40.71) rotate(-26.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.66,65.2c.05.08.03.19-.06.25s-.19.03-.25-.06-.03-.19.06-.25.19-.03.25.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.87,58.05c.04.07.02.15-.05.2s-.15.02-.2-.05-.02-.15.05-.2.15-.02.2.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 84.52,
    cy: 51.22,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 88.82,
    cy: 44.64,
    r: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 93.61,
    cy: 38.4,
    r: 0.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 72.21,
    cy: 59.05,
    r: 3.14,
    transform: "translate(-2.22 115.28) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 75.94,
    cy: 51.47,
    r: 3.1,
    transform: "translate(8 113.11) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80.24,
    cy: 44.18,
    r: 3.07,
    transform: "translate(18.37 111.73) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 85.08,
    cy: 37.25,
    r: 3.03,
    transform: "translate(28.8 111.14) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 90.45,
    cy: 30.71,
    r: 2.99,
    transform: "translate(-4.58 40.37) rotate(-24.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 96.3,
    cy: 24.61,
    r: 2.95,
    transform: "translate(31.54 100) rotate(-63.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.6,
    cy: 18.97,
    r: 2.91,
    transform: "translate(46.81 107.14) rotate(-68.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 109.32,
    cy: 13.83,
    r: 2.87,
    transform: "translate(-.79 9.64) rotate(-5.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.42,
    cy: 9.23,
    r: 2.84,
    transform: "translate(-.35 11.12) rotate(-5.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 123.84,
    cy: 5.18,
    r: 2.8,
    transform: "translate(.12 12.78) rotate(-5.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 131.55,
    cy: 1.71,
    r: 2.76,
    transform: "translate(80.08 122.78) rotate(-67.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 139.51,
    cy: -1.17,
    r: 2.72,
    transform: "translate(106.57 134.4) rotate(-75.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M207.61-3.21c1.05.82,1.23,2.34.4,3.39s-2.34,1.23-3.39.4-1.23-2.34-.4-3.39c.82-1.05,2.34-1.23,3.39-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.55-.33c1.03.81,1.21,2.31.4,3.34s-2.31,1.21-3.34.4-1.21-2.31-.4-3.34c.81-1.03,2.31-1.21,3.34-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223.25,3.14c1.01.8,1.19,2.27.39,3.28-.8,1.01-2.27,1.19-3.28.39-1.01-.8-1.19-2.27-.39-3.28s2.27-1.19,3.28-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.66,7.19c1,.79,1.17,2.23.39,3.23-.79,1-2.23,1.17-3.23.39-1-.79-1.17-2.23-.39-3.23.79-1,2.23-1.17,3.23-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M237.75,11.8c.98.77,1.15,2.19.38,3.18-.77.98-2.19,1.15-3.18.38-.98-.77-1.15-2.19-.38-3.18.77-.98,2.19-1.15,3.18-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.47,16.93c.96.76,1.13,2.16.37,3.12s-2.16,1.13-3.12.37-1.13-2.16-.37-3.12c.76-.96,2.16-1.13,3.12-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.77,22.58c.95.75,1.11,2.12.37,3.07s-2.12,1.11-3.07.37c-.95-.75-1.11-2.12-.37-3.07.75-.95,2.12-1.11,3.07-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.62,28.69c.93.73,1.09,2.08.36,3.01-.73.93-2.08,1.09-3.01.36-.93-.73-1.09-2.08-.36-3.01.73-.93,2.08-1.09,3.01-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.99,35.24c.91.72,1.07,2.05.35,2.96-.72.91-2.05,1.07-2.96.35s-1.07-2.05-.35-2.96c.72-.91,2.05-1.07,2.96-.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 265.56,
    cy: 43.81,
    r: 2.07,
    transform: "translate(-3.41 53.62) rotate(-11.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M271.14,49.47c.88.69,1.03,1.97.34,2.85s-1.97,1.03-2.85.34c-.88-.69-1.03-1.97-.34-2.85.69-.88,1.97-1.03,2.85-.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 273.65,
    cy: 58.64,
    r: 1.99,
    transform: "translate(-4.62 28.85) rotate(-5.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.04,64.95c.85.67,1,1.9.33,2.75s-1.9,1-2.75.33-.99-1.9-.33-2.75c.67-.85,1.9-1,2.75-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.58,73.03c.83.65.98,1.86.32,2.69-.65.83-1.86.98-2.69.32-.83-.65-.98-1.86-.32-2.69.65-.83,1.86-.98,2.69-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.51,81.29c.82.64.96,1.82.31,2.64-.64.82-1.82.96-2.64.31-.82-.64-.96-1.82-.31-2.64s1.82-.96,2.64-.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 282.66,
    cy: 91.12,
    r: 1.84,
    transform: "translate(185.36 371.72) rotate(-88.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 283.33,
    cy: 99.55,
    r: 1.8,
    transform: "translate(167.85 376.78) rotate(-86.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 283.36,
    cy: 108.01,
    r: 1.76,
    transform: "translate(151.2 380.94) rotate(-85.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 282.72,
    cy: 116.44,
    r: 1.72,
    transform: "translate(132.55 382.79) rotate(-82.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 281.45,
    cy: 124.8,
    r: 1.69,
    transform: "translate(112.5 382.18) rotate(-80.63)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 279.53,
    cy: 133.04,
    r: 1.65,
    transform: "translate(103.26 387.52) rotate(-80.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.98,
    cy: 141.1,
    r: 1.61,
    transform: "translate(91.73 390.72) rotate(-80.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 273.83,
    cy: 148.95,
    r: 1.57,
    transform: "translate(64.45 379.88) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 270.1,
    cy: 156.54,
    r: 1.53,
    transform: "translate(54.22 382.05) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 265.8,
    cy: 163.82,
    r: 1.49,
    transform: "translate(43.35 382.92) rotate(-76.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 260.95,
    cy: 170.75,
    r: 1.46,
    transform: "translate(19.9 368.61) rotate(-72.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.47,176.18c.62.48.72,1.38.24,1.99s-1.38.72-1.99.24-.72-1.38-.24-1.99,1.38-.72,1.99-.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 249.74,
    cy: 183.4,
    r: 1.38,
    transform: "translate(-10.34 351.81) rotate(-69.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 243.43,
    cy: 189.03,
    r: 1.34,
    transform: "translate(-19.29 350.18) rotate(-69.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 236.71,
    cy: 194.17,
    r: 1.3,
    transform: "translate(-35.7 333.89) rotate(-66.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 229.62,
    cy: 198.77,
    r: 1.26,
    transform: "translate(-44.62 329.26) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 222.19,
    cy: 202.82,
    r: 1.23,
    transform: "translate(-52.3 325.95) rotate(-66.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 214.48,
    cy: 206.29,
    r: 1.19,
    transform: "translate(-65.29 307.73) rotate(-63.81)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 206.53,
    cy: 209.17,
    r: 1.15,
    transform: "translate(-71.85 303.57) rotate(-64.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 198.38,
    cy: 211.43,
    r: 1.11,
    transform: "translate(-80.93 289.18) rotate(-62.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 190.08,
    cy: 213.06,
    r: 1.07,
    transform: "translate(-87.59 279.59) rotate(-61.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M182.32,213.24c.45.35.53,1,.17,1.45-.35.45-1,.53-1.45.17-.45-.35-.53-1-.17-1.45s1-.53,1.45-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.85,213.62c.43.34.51.97.17,1.4s-.97.51-1.4.17c-.43-.34-.51-.97-.17-1.4.34-.43.97-.51,1.4-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.38,213.34c.42.33.49.93.16,1.35s-.93.49-1.35.16c-.42-.33-.49-.93-.16-1.35s.93-.49,1.35-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.95,212.42c.4.31.47.89.15,1.29s-.89.47-1.29.15-.47-.89-.15-1.29.89-.47,1.29-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M148.62,210.85c.38.3.45.86.15,1.24-.3.38-.86.45-1.24.15-.38-.3-.45-.86-.15-1.24s.86-.45,1.24-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.44,208.64c.37.29.43.82.14,1.18-.29.37-.82.43-1.18.14s-.43-.82-.14-1.18.82-.43,1.18-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.46,205.82c.35.27.41.78.13,1.13s-.78.41-1.13.13-.41-.78-.13-1.13c.27-.35.78-.41,1.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.71,202.41c.33.26.39.74.13,1.08s-.74.39-1.08.13-.39-.74-.13-1.08.74-.39,1.08-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.24,198.42c.32.25.37.71.12,1.02s-.71.37-1.02.12-.37-.71-.12-1.02c.25-.32.71-.37,1.02-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.11,193.87c.3.24.35.67.12.97s-.67.35-.97.12-.35-.67-.12-.97.67-.35.97-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.34,188.8c.28.22.33.63.11.92s-.63.33-.92.11-.33-.63-.11-.92c.22-.28.63-.33.92-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.99,183.21c.27.21.31.6.1.86s-.6.31-.86.1-.31-.6-.1-.86.6-.31.86-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.1,177.16c.25.2.29.56.1.81s-.56.29-.81.1c-.25-.2-.29-.56-.1-.81s.56-.29.81-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.68,170.67c.23.18.27.52.09.75s-.52.27-.75.09-.27-.52-.09-.75.52-.27.75-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.79,163.79c.22.17.25.48.08.7s-.48.25-.7.08-.25-.48-.08-.7.48-.25.7-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.44,156.55c.2.16.23.45.08.65s-.45.23-.65.08-.23-.45-.08-.65.45-.23.65-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.65,149.01c.18.14.21.41.07.59s-.41.21-.59.07-.21-.41-.07-.59.41-.21.59-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.45,141.2c.17.13.2.37.06.54s-.37.2-.54.06c-.17-.13-.2-.37-.06-.54s.37-.2.54-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.86,133.18c.15.12.18.33.06.48s-.33.18-.48.06-.18-.33-.06-.48.33-.18.48-.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 64.7,
    cy: 125.22,
    r: 0.31,
    transform: "translate(-69.75 82.91) rotate(-45.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.55,116.65c.12.09.14.26.04.38s-.26.14-.38.04-.14-.26-.04-.38.26-.14.38-.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 62.71,
    cy: 108.43,
    r: 0.23,
    transform: "translate(-59.39 80.46) rotate(-47.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.81,99.83c.08.07.1.19.03.27s-.19.1-.27.03-.1-.19-.03-.27.19-.1.27-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.42,91.42c.07.05.08.15.03.22s-.15.08-.22.03-.08-.15-.03-.22.15-.08.22-.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 64.6,
    cy: 83.18,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 66.52,
    cy: 74.95,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 69.07,
    cy: 66.88,
    r: 0.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.04,
    cy: 95.63,
    r: 3.38,
    transform: "translate(-50.88 126.53) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.02,
    cy: 86.58,
    r: 3.34,
    transform: "translate(-41.34 120.58) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 57.68,
    cy: 77.64,
    r: 3.3,
    transform: "translate(-31.38 115.37) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 60.03,
    cy: 68.86,
    r: 3.26,
    transform: "translate(-21.06 110.93) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 63.04,
    cy: 60.28,
    r: 3.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 66.71,
    cy: 51.96,
    r: 3.17,
    transform: "translate(-4.12 98.14) rotate(-71.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.01,
    cy: 43.94,
    r: 3.13,
    transform: "translate(6.05 96.42) rotate(-70.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 75.91,
    cy: 36.28,
    r: 3.09,
    transform: "translate(13.83 93.07) rotate(-67.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 81.38,
    cy: 29.02,
    r: 3.05,
    transform: "translate(23.63 93.29) rotate(-67.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 87.39,
    cy: 22.2,
    r: 3.01,
    transform: "translate(33.26 94.31) rotate(-67.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 93.91,
    cy: 15.86,
    r: 2.97,
    transform: "translate(47.51 99.03) rotate(-70.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 100.89,
    cy: 10.03,
    r: 2.93,
    transform: "translate(74.3 107.86) rotate(-80.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 108.29,
    cy: 4.74,
    r: 2.89,
    transform: "translate(60.25 101.91) rotate(-66.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.07,
    cy: 0.04,
    r: 2.84,
    transform: "translate(93.31 113.86) rotate(-78.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M230.21-2.88c1.21.4,1.87,1.7,1.47,2.91-.4,1.21-1.7,1.87-2.91,1.47s-1.87-1.7-1.47-2.91c.4-1.21,1.7-1.87,2.91-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.04,1.77c1.19.39,1.84,1.67,1.45,2.86-.39,1.19-1.67,1.84-2.86,1.45-1.19-.39-1.84-1.67-1.45-2.86.39-1.19,1.67-1.84,2.86-1.45Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 244.79,
    cy: 9.11,
    r: 2.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.52,12.78c1.15.38,1.77,1.61,1.39,2.76-.38,1.15-1.61,1.77-2.76,1.39-1.15-.38-1.77-1.61-1.39-2.76.38-1.15,1.61-1.77,2.76-1.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 258.43,
    cy: 21.13,
    r: 2.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M265.18,25.88c1.1.36,1.7,1.55,1.34,2.65-.36,1.1-1.55,1.7-2.65,1.34s-1.7-1.55-1.34-2.65c.36-1.1,1.55-1.7,2.65-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M270.72,33.12c1.08.36,1.67,1.52,1.31,2.6-.36,1.08-1.52,1.67-2.6,1.31s-1.67-1.52-1.31-2.6c.36-1.08,1.52-1.67,2.6-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.71,40.75c1.06.35,1.64,1.49,1.29,2.55-.35,1.06-1.49,1.64-2.55,1.29-1.06-.35-1.64-1.49-1.29-2.55.35-1.06,1.49-1.64,2.55-1.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 279.48,
    cy: 50.63,
    r: 1.98,
    transform: "translate(179.61 316.52) rotate(-79.68)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 283.26,
    cy: 58.9,
    r: 1.94,
    transform: "translate(169.78 325.03) rotate(-78.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 286.39,
    cy: 67.44,
    r: 1.9,
    transform: "translate(166.82 336.27) rotate(-79.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 288.85,
    cy: 76.19,
    r: 1.85,
    transform: "translate(153.89 342.7) rotate(-77.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 290.63,
    cy: 85.11,
    r: 1.81,
    transform: "translate(143.77 349.95) rotate(-77.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 291.72,
    cy: 94.14,
    r: 1.77,
    transform: "translate(135.94 358.13) rotate(-77.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 292.12,
    cy: 103.22,
    r: 1.73,
    transform: "translate(133.03 369.07) rotate(-78.56)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 291.82,
    cy: 112.31,
    r: 1.69,
    transform: "translate(113.8 369.37) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 290.84,
    cy: 121.35,
    r: 1.65,
    transform: "translate(104.26 375.32) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 289.17,
    cy: 130.29,
    r: 1.61,
    transform: "translate(99.22 384.29) rotate(-77.46)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 286.83,
    cy: 139.08,
    r: 1.57,
    transform: "translate(84.96 385.78) rotate(-76.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M284.29,146.21c.8.26,1.24,1.12.97,1.92-.26.8-1.12,1.24-1.92.97s-1.24-1.12-.97-1.92c.26-.8,1.12-1.24,1.92-.97Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 280.14,
    cy: 155.98,
    r: 1.48,
    transform: "translate(56.89 386.12) rotate(-74.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 275.85,
    cy: 163.99,
    r: 1.44,
    transform: "translate(49.54 391.52) rotate(-75.89)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 270.94,
    cy: 171.65,
    r: 1.4,
    transform: "translate(33.13 386.86) rotate(-74.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 265.47,
    cy: 178.91,
    r: 1.36,
    transform: "translate(22 386.77) rotate(-74.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 259.46,
    cy: 185.73,
    r: 1.32,
    transform: "translate(14 389.61) rotate(-75.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 252.94,
    cy: 192.07,
    r: 1.28,
    transform: "translate(-2.56 380.73) rotate(-73.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 245.96,
    cy: 197.9,
    r: 1.24,
    transform: "translate(-10.65 381.8) rotate(-74.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.56,
    cy: 203.19,
    r: 1.2,
    transform: "translate(-23.7 374.69) rotate(-73.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 230.78,
    cy: 207.89,
    r: 1.15,
    transform: "translate(-33.86 370.49) rotate(-73.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M223,210.92c.58.19.9.82.71,1.4s-.82.9-1.4.71-.9-.82-.71-1.4.82-.9,1.4-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M214.58,214.42c.56.18.87.79.68,1.35s-.79.87-1.35.68-.87-.79-.68-1.35.79-.87,1.35-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.92,217.26c.54.18.83.76.66,1.3-.18.54-.76.83-1.3.66-.54-.18-.83-.76-.66-1.3s.76-.83,1.3-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.06,219.42c.52.17.8.73.63,1.25-.17.52-.73.8-1.25.63-.52-.17-.8-.73-.63-1.25.17-.52.73-.8,1.25-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.07,220.9c.5.16.77.7.6,1.2-.16.5-.7.77-1.2.6-.5-.16-.77-.7-.6-1.2.16-.5.7-.77,1.2-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.99,221.68c.48.16.73.67.58,1.14-.16.48-.67.73-1.14.58-.48-.16-.73-.67-.58-1.14s.67-.73,1.14-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.89,221.76c.45.15.7.64.55,1.09-.15.45-.64.7-1.09.55-.45-.15-.7-.64-.55-1.09s.64-.7,1.09-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.8,221.16c.43.14.67.61.53,1.04s-.61.67-1.04.53-.67-.61-.53-1.04c.14-.43.61-.67,1.04-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.79,219.88c.41.14.63.58.5.99s-.58.63-.99.5-.63-.58-.5-.99.58-.63.99-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.91,217.91c.39.13.6.55.47.94s-.55.6-.94.47-.6-.55-.47-.94.55-.6.94-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.21,215.27c.37.12.57.52.45.88s-.52.57-.88.45c-.37-.12-.57-.52-.45-.88s.52-.57.88-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.74,211.96c.35.11.53.49.42.83s-.49.53-.83.42-.53-.49-.42-.83.49-.53.83-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.56,208.01c.32.11.5.46.39.78s-.46.5-.78.39-.5-.46-.39-.78.46-.5.78-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.7,203.45c.3.1.47.43.37.73s-.43.47-.73.37c-.3-.1-.47-.43-.37-.73s.43-.47.73-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M102.22,198.3c.28.09.43.4.34.68s-.4.43-.68.34-.43-.4-.34-.68.4-.43.68-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.16,192.59c.26.09.4.36.32.62s-.36.4-.62.32-.4-.36-.32-.62.36-.4.62-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.56,186.36c.24.08.37.33.29.57s-.33.37-.57.29c-.24-.08-.37-.33-.29-.57s.33-.37.57-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.46,179.64c.22.07.33.3.26.52s-.3.33-.52.26-.33-.3-.26-.52.3-.33.52-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.89,172.49c.19.06.3.27.24.47s-.27.3-.47.24-.3-.27-.24-.47.27-.3.47-.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.78,
    cy: 165.24,
    r: 0.33,
    transform: "translate(-108 176.92) rotate(-70.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.47,157.01c.15.05.23.21.18.36s-.21.23-.36.18-.23-.21-.18-.36.21-.23.36-.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 63.6,
    cy: 149.01,
    r: 0.25,
    transform: "translate(-98.06 159.84) rotate(-70.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.53,140.28c.11.04.17.15.13.26s-.15.17-.26.13-.17-.15-.13-.26.15-.17.26-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.06,131.56c.09.03.13.12.11.21s-.12.13-.21.11-.13-.12-.11-.21.12-.13.21-.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.22,
    cy: 122.8,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.13,
    cy: 113.78,
    r: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 54.74,
    cy: 104.69,
    r: 0.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 51.14,
    cy: 138.89,
    r: 3.63,
    transform: "translate(-95.9 155.8) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 48.8,
    cy: 129.4,
    r: 3.59,
    transform: "translate(-88.46 146.27) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.2,
    cy: 119.75,
    r: 3.55,
    transform: "translate(-80.31 137.34) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.33,
    cy: 110.01,
    r: 3.5,
    transform: "translate(-71.51 129.07) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.22,
    cy: 100.23,
    r: 3.46,
    transform: "translate(-44.15 36.86) rotate(-30.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.87,
    cy: 90.48,
    r: 3.41,
    transform: "translate(-51 118.83) rotate(-78.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 48.27,
    cy: 80.8,
    r: 3.37,
    transform: "translate(-42.37 106.15) rotate(-74.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.4,
    cy: 71.26,
    r: 3.32,
    transform: "translate(-36.86 73.05) rotate(-55.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 53.26,
    cy: 61.91,
    r: 3.28,
    transform: "translate(-27.91 70.84) rotate(-55.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.83,
    cy: 52.8,
    r: 3.24,
    transform: "translate(-18.96 69.37) rotate(-55.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.08,
    cy: 44,
    r: 3.19,
    transform: "translate(2.53 91.3) rotate(-74.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 65.98,
    cy: 35.54,
    r: 3.15,
    transform: "translate(23.89 97.55) rotate(-84.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.52,
    cy: 27.48,
    r: 3.1,
    transform: "translate(7.35 69.35) rotate(-54.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 77.65,
    cy: 19.86,
    r: 3.06,
    transform: "translate(45.34 93.21) rotate(-80.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 84.35,
    cy: 12.74,
    r: 3.01,
    transform: "translate(62.85 95.3) rotate(-83.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 91.58,
    cy: 6.15,
    r: 2.97,
    transform: "translate(70.69 95.53) rotate(-80.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 99.29,
    cy: 0.14,
    r: 2.92,
    transform: "translate(34.45 75.33) rotate(-49.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.08-3.59c1.22-.04,2.25.92,2.28,2.15s-.92,2.25-2.15,2.28-2.25-.92-2.28-2.15c-.04-1.22.92-2.25,2.15-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.93,2.29c1.2-.04,2.2.9,2.24,2.1.04,1.2-.9,2.2-2.1,2.24-1.2.04-2.2-.9-2.24-2.1-.04-1.2.9-2.2,2.1-2.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 261.37,
    cy: 10.89,
    r: 2.13,
    transform: "translate(146.7 246.01) rotate(-66.39)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 268.23,
    cy: 17.85,
    r: 2.08,
    transform: "translate(150.9 259.72) rotate(-67.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 274.53,
    cy: 25.33,
    r: 2.04,
    transform: "translate(159.7 275.97) rotate(-70.66)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 280.24,
    cy: 33.27,
    r: 1.99,
    transform: "translate(159.77 288.47) rotate(-71.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 285.32,
    cy: 41.62,
    r: 1.95,
    transform: "translate(163.46 302.94) rotate(-73.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 289.74,
    cy: 50.34,
    r: 1.91,
    transform: "translate(157.87 313.2) rotate(-73.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 293.48,
    cy: 59.38,
    r: 1.86,
    transform: "translate(161.54 328.16) rotate(-75.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 296.52,
    cy: 68.67,
    r: 1.82,
    transform: "translate(159.8 340.6) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 298.86,
    cy: 78.16,
    r: 1.77,
    transform: "translate(152.35 350.12) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.46,
    cy: 87.81,
    r: 1.73,
    transform: "translate(153.38 364.13) rotate(-78.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 301.32,
    cy: 97.55,
    r: 1.68,
    transform: "translate(155.47 378.69) rotate(-80.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M301.38,105.69c.91-.03,1.66.68,1.69,1.59.03.91-.68,1.66-1.59,1.69s-1.66-.68-1.69-1.59.68-1.66,1.59-1.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.78,
    cy: 117.08,
    r: 1.6,
    transform: "translate(137.79 395.67) rotate(-80.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 299.39,
    cy: 126.76,
    r: 1.55,
    transform: "translate(134.49 406.96) rotate(-82.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 297.25,
    cy: 136.3,
    r: 1.51,
    transform: "translate(123.76 413.5) rotate(-82.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 294.39,
    cy: 145.65,
    r: 1.46,
    transform: "translate(112.54 419.17) rotate(-82.71)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 290.82,
    cy: 154.76,
    r: 1.42,
    transform: "translate(107.03 428.16) rotate(-84.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 286.57,
    cy: 163.56,
    r: 1.37,
    transform: "translate(91.62 429.78) rotate(-83.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 281.67,
    cy: 172.02,
    r: 1.33,
    transform: "translate(84.74 436.88) rotate(-84.78)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 276.13,
    cy: 180.08,
    r: 1.29,
    transform: "translate(71.55 438.59) rotate(-84.75)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 269.99,
    cy: 187.69,
    r: 1.24,
    transform: "translate(60.9 441.48) rotate(-85.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.26,193.62c.66-.02,1.21.5,1.23,1.16.02.66-.5,1.21-1.16,1.23-.66.02-1.21-.5-1.23-1.16s.5-1.21,1.16-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.03,200.25c.64-.02,1.17.48,1.19,1.12s-.48,1.17-1.12,1.19c-.64.02-1.17-.48-1.19-1.12-.02-.64.48-1.17,1.12-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.32,206.31c.61-.02,1.12.46,1.14,1.07s-.46,1.12-1.07,1.14c-.61.02-1.12-.46-1.14-1.07s.46-1.12,1.07-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M240.17,211.75c.59-.02,1.08.44,1.1,1.03s-.44,1.08-1.03,1.1-1.08-.44-1.1-1.03.44-1.08,1.03-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.62,216.55c.56-.02,1.03.42,1.05.99s-.42,1.03-.99,1.05-1.03-.42-1.05-.99.42-1.03.99-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.74,220.67c.54-.02.99.41,1.01.94s-.41.99-.94,1.01-.99-.41-1.01-.94.41-.99.94-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M213.57,224.11c.51-.02.94.39.96.9s-.39.94-.9.96-.94-.39-.96-.9c-.02-.51.39-.94.9-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.17,226.84c.49-.02.9.37.91.86s-.37.9-.86.91-.9-.37-.91-.86.37-.9.86-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.6,228.86c.46-.01.85.35.87.82s-.35.85-.82.87-.85-.35-.87-.82c-.01-.46.35-.85.82-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.9,230.14c.44-.01.81.33.82.77s-.33.81-.77.82-.81-.33-.82-.77.33-.81.77-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.13,230.67c.42-.01.76.31.78.73s-.31.76-.73.78c-.42.01-.76-.31-.78-.73-.01-.42.31-.76.73-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.36,230.44c.39-.01.72.3.73.69s-.3.72-.69.73-.72-.3-.73-.69.3-.72.69-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M155.64,229.46c.37-.01.67.28.69.64s-.28.67-.64.69-.67-.28-.69-.64.28-.67.64-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.02,227.74c.34-.01.63.26.64.6s-.26.63-.6.64c-.34.01-.63-.26-.64-.6-.01-.34.26-.63.6-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.57,225.28c.32,0,.58.24.59.56,0,.32-.24.58-.56.59s-.58-.24-.59-.56.24-.58.56-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.34,222.11c.29,0,.54.22.55.51s-.22.54-.51.55-.54-.22-.55-.51.22-.54.51-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M118.38,218.24c.27,0,.49.2.5.47s-.2.49-.47.5-.49-.2-.5-.47.2-.49.47-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.74,213.7c.24,0,.45.18.46.43s-.18.45-.43.46-.45-.18-.46-.43.18-.45.43-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.48,208.52c.22,0,.4.17.41.39s-.17.4-.39.41-.4-.17-.41-.39.17-.4.39-.41Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 93.65,
    cy: 203.08,
    r: 0.35,
    transform: "translate(-22.8 12.16) rotate(-6.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M86.27,196.34c.17,0,.31.13.32.3s-.13.31-.3.32-.31-.13-.32-.3.13-.31.3-.32Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.42,
    cy: 189.69,
    r: 0.27,
    transform: "translate(-16.85 7.97) rotate(-5.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.11,181.99c.12,0,.22.09.23.21s-.09.22-.21.23-.22-.09-.23-.21.09-.22.21-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.4,174.1c.1,0,.18.07.18.17s-.07.18-.17.18-.18-.07-.18-.17.07-.18.17-.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 62.33,
    cy: 165.92,
    r: 0.13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 57.91,
    cy: 157.2,
    r: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 54.17,
    cy: 148.16,
    r: 0.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 63.11,
    cy: 184.04,
    r: 3.91,
    transform: "translate(-130.63 201.92) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 57.25,
    cy: 175.31,
    r: 3.86,
    transform: "translate(-126.61 189.56) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 52.08,
    cy: 166.15,
    r: 3.81,
    transform: "translate(-121.67 177.54) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 47.63,
    cy: 156.63,
    r: 3.76,
    transform: "translate(-115.81 165.94) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 43.93,
    cy: 146.79,
    r: 3.72,
    transform: "translate(-91.6 75.31) rotate(-45.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 40.99,
    cy: 136.69,
    r: 3.67,
    transform: "translate(-98.03 168.9) rotate(-86.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 38.84,
    cy: 126.4,
    r: 3.62,
    transform: "translate(-92.6 140.88) rotate(-79.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 37.49,
    cy: 115.97,
    r: 3.57,
    transform: "translate(-81.53 89.72) rotate(-59.65)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 36.94,
    cy: 105.48,
    r: 3.53,
    transform: "translate(-72.68 83.71) rotate(-59.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 37.2,
    cy: 94.96,
    r: 3.48,
    transform: "translate(-63.45 78.44) rotate(-59.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 38.25,
    cy: 84.5,
    r: 3.43,
    transform: "translate(-51.87 106.45) rotate(-79.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 40.1,
    cy: 74.15,
    r: 3.38,
    transform: "translate(-37.12 107.98) rotate(-85.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 42.73,
    cy: 63.97,
    r: 3.34,
    transform: "translate(-34.13 67.27) rotate(-58.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.13,
    cy: 54.02,
    r: 3.29,
    transform: "translate(-14.63 90.83) rotate(-80.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.28,
    cy: 44.36,
    r: 3.24,
    transform: "translate(-.32 .36) rotate(-.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 55.15,
    cy: 35.05,
    r: 3.19,
    transform: "translate(11.78 83.93) rotate(-80.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 60.73,
    cy: 26.14,
    r: 3.15,
    transform: "translate(2.37 57.22) rotate(-51.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M65.84,14.81c1.59-.64,3.39.14,4.03,1.73.64,1.59-.14,3.39-1.73,4.03s-3.39-.14-4.03-1.73.14-3.39,1.73-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.74,6.91c1.56-.63,3.34.14,3.96,1.7.63,1.56-.14,3.34-1.7,3.96-1.56.63-3.34-.14-3.96-1.7-.63-1.56.14-3.34,1.7-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.23-.44c1.54-.62,3.29.13,3.9,1.67s-.13,3.29-1.67,3.9c-1.54.62-3.29-.13-3.9-1.67s.13-3.29,1.67-3.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 263.96,
    cy: -0.37,
    r: 2.1,
    transform: "translate(179.81 249.82) rotate(-71.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 271.63,
    cy: 6.82,
    r: 2.05,
    transform: "translate(177.68 261.78) rotate(-71.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 278.73,
    cy: 14.57,
    r: 2,
    transform: "translate(182.03 276.4) rotate(-72.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 285.22,
    cy: 22.85,
    r: 1.95,
    transform: "translate(195.7 294.62) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 291.07,
    cy: 31.58,
    r: 1.91,
    transform: "translate(191.68 306.97) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 296.24,
    cy: 40.74,
    r: 1.86,
    transform: "translate(195.86 322.41) rotate(-78.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 300.7,
    cy: 50.26,
    r: 1.81,
    transform: "translate(215.91 343.1) rotate(-83.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303.75,58.46c.9-.36,1.93.08,2.29.98s-.08,1.93-.98,2.29c-.9.36-1.93-.08-2.29-.98-.36-.9.08-1.93.98-2.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 307.33,
    cy: 70.2,
    r: 1.72,
    transform: "translate(216.78 372.16) rotate(-86.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 309.48,
    cy: 80.49,
    r: 1.67,
    transform: "translate(219.53 387.36) rotate(-88.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 310.83,
    cy: 90.92,
    r: 1.62,
    transform: "translate(-.44 1.52) rotate(-.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 311.38,
    cy: 101.42,
    r: 1.57,
    transform: "translate(-.99 3.1) rotate(-.57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 311.13,
    cy: 111.93,
    r: 1.52,
    transform: "translate(-4.75 14.2) rotate(-2.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 310.07,
    cy: 122.39,
    r: 1.48,
    transform: "translate(-6.57 18.16) rotate(-3.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 308.22,
    cy: 132.74,
    r: 1.43,
    transform: "translate(-10.76 28.47) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 305.59,
    cy: 142.92,
    r: 1.38,
    transform: "translate(-13.55 33.56) rotate(-6.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 302.19,
    cy: 152.87,
    r: 1.33,
    transform: "translate(-17.23 40.37) rotate(-7.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.56,161.33c.66-.26,1.41.06,1.67.72s-.06,1.41-.72,1.67c-.66.26-1.41-.06-1.67-.72-.26-.66.06-1.41.72-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.7,170.69c.64-.25,1.36.05,1.61.69s-.05,1.36-.69,1.61-1.36-.05-1.61-.69.05-1.36.69-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M287.14,179.64c.61-.24,1.3.05,1.55.66.24.61-.05,1.3-.66,1.55-.61.24-1.3-.05-1.55-.66-.24-.61.05-1.3.66-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.9,188.14c.59-.23,1.25.05,1.49.64s-.05,1.25-.64,1.49-1.25-.05-1.49-.64c-.23-.59.05-1.25.64-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M274.03,196.13c.56-.22,1.2.05,1.42.61s-.05,1.2-.61,1.42-1.2-.05-1.42-.61.05-1.2.61-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.57,203.57c.54-.22,1.15.05,1.36.58s-.05,1.15-.58,1.36-1.15-.05-1.36-.58c-.22-.54.05-1.15.58-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M258.57,210.41c.51-.21,1.1.04,1.3.56.21.51-.04,1.1-.56,1.3s-1.1-.04-1.3-.56.04-1.1.56-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250.08,216.63c.49-.2,1.04.04,1.24.53s-.04,1.04-.53,1.24c-.49.2-1.04-.04-1.24-.53-.2-.49.04-1.04.53-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.15,222.19c.46-.19.99.04,1.18.5.19.46-.04.99-.5,1.18s-.99-.04-1.18-.5.04-.99.5-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.82,227.05c.44-.18.94.04,1.11.48.18.44-.04.94-.48,1.11s-.94-.04-1.11-.48.04-.94.48-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M222.15,231.17c.42-.17.89.04,1.05.45s-.04.89-.45,1.05-.89-.04-1.05-.45.04-.89.45-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M212.19,234.54c.39-.16.83.03.99.42s-.03.83-.42.99c-.39.16-.83-.03-.99-.42s.03-.83.42-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202,237.12c.37-.15.78.03.93.4s-.03.78-.4.93-.78-.03-.93-.4.03-.78.4-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.65,238.92c.34-.14.73.03.87.37s-.03.73-.37.87-.73-.03-.87-.37.03-.73.37-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.2,239.91c.32-.13.68.03.81.35s-.03.68-.35.81c-.32.13-.68-.03-.81-.35s.03-.68.35-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.71,240.1c.29-.12.63.03.74.32s-.03.63-.32.74-.63-.03-.74-.32.03-.63.32-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.23,239.49c.27-.11.57.02.68.29s-.02.57-.29.68c-.27.11-.57-.02-.68-.29s.02-.57.29-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.84,238.08c.24-.1.52.02.62.27s-.02.52-.27.62-.52-.02-.62-.27.02-.52.27-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.58,235.88c.22-.09.47.02.56.24s-.02.47-.24.56-.47-.02-.56-.24.02-.47.24-.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 129.67,
    cy: 233.26,
    r: 0.38,
    transform: "translate(-97.43 93.09) rotate(-29.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.73,229.18c.17-.07.37.01.43.19s-.01.37-.19.43-.37-.01-.43-.19.01-.37.19-.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 110.36,
    cy: 224.97,
    r: 0.29,
    transform: "translate(-90.93 75.73) rotate(-27.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M101.16,219.51c.12-.05.26.01.31.13s-.01.26-.13.31-.26-.01-.31-.13.01-.26.13-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.49,213.63c.1-.04.21,0,.25.11s0,.21-.11.25-.21,0-.25-.11,0-.21.11-.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 84.35,
    cy: 207.24,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 76.68,
    cy: 200.05,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 69.58,
    cy: 192.29,
    r: 0.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 91.8,
    cy: 225.27,
    r: 4.2,
    transform: "translate(-148.77 261.3) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 82.68,
    cy: 218.59,
    r: 4.15,
    transform: "translate(-149.25 247.33) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 74.09,
    cy: 211.24,
    r: 4.1,
    transform: "translate(-148.67 233.37) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 66.09,
    cy: 203.26,
    r: 4.05,
    transform: "translate(-147.02 219.49) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 58.72,
    cy: 194.68,
    r: 4,
    transform: "translate(-136.85 139.03) rotate(-57.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 52.04,
    cy: 185.55,
    r: 3.95,
    transform: "translate(-9.51 2.93) rotate(-2.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.09,
    cy: 175.95,
    r: 3.89,
    transform: "translate(-134.17 200.19) rotate(-82.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 40.89,
    cy: 165.91,
    r: 3.84,
    transform: "translate(-127.56 137.26) rotate(-66.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 36.47,
    cy: 155.5,
    r: 3.79,
    transform: "translate(-120.63 126.72) rotate(-66.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 32.86,
    cy: 144.79,
    r: 3.74,
    transform: "translate(-112.93 116.76) rotate(-66.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 30.08,
    cy: 133.83,
    r: 3.69,
    transform: "translate(-106.34 148.09) rotate(-83.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 28.14,
    cy: 122.69,
    r: 3.64,
    transform: "translate(-97.39 132.02) rotate(-81.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 27.06,
    cy: 111.44,
    r: 3.59,
    transform: "translate(-85.77 90.94) rotate(-66.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.83,
    cy: 100.13,
    r: 3.54,
    transform: "translate(-76.64 106.5) rotate(-78.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 27.47,
    cy: 88.85,
    r: 3.48,
    transform: "translate(-6.29 2.2) rotate(-4.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 28.98,
    cy: 77.64,
    r: 3.43,
    transform: "translate(-52.86 90.69) rotate(-78.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 31.34,
    cy: 66.59,
    r: 3.38,
    transform: "translate(-41.9 59.33) rotate(-59.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.33,53.26c1.37-1.23,3.48-1.11,4.7.26,1.23,1.37,1.11,3.48-.26,4.7-1.37,1.23-3.48,1.11-4.7-.26s-1.11-3.48.26-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.4,42.74c1.35-1.21,3.42-1.09,4.63.26,1.21,1.35,1.09,3.42-.26,4.63-1.35,1.21-3.42,1.09-4.63-.26-1.21-1.35-1.09-3.42.26-4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.26,32.56c1.33-1.19,3.37-1.07,4.56.25,1.19,1.33,1.07,3.37-.25,4.56s-3.37,1.07-4.56-.25c-1.19-1.33-1.07-3.37.25-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.9,22.78c1.31-1.17,3.32-1.06,4.49.25,1.17,1.31,1.06,3.32-.25,4.49s-3.32,1.06-4.49-.25c-1.17-1.31-1.06-3.32.25-4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.26,13.45c1.29-1.15,3.26-1.04,4.41.25,1.15,1.29,1.04,3.26-.25,4.41s-3.26,1.04-4.41-.25c-1.15-1.29-1.04-3.26.25-4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M60.31,4.62c1.27-1.13,3.21-1.02,4.34.24,1.13,1.27,1.02,3.21-.24,4.34-1.27,1.13-3.21,1.02-4.34-.24-1.13-1.27-1.02-3.21.24-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M68.02-3.64c1.24-1.11,3.16-1.01,4.27.24,1.11,1.24,1.01,3.16-.24,4.27s-3.16,1.01-4.27-.24-1.01-3.16.24-4.27Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 282.67,
    cy: 2.71,
    r: 1.95,
    transform: "translate(248.08 283.27) rotate(-83.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288.77,9.88c.78-.7,1.98-.63,2.68.15.7.78.63,1.98-.15,2.68-.78.7-1.98.63-2.68-.15s-.63-1.98.15-2.68Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 296.71,
    cy: 20.41,
    r: 1.84,
    transform: "translate(271.51 316.76) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 302.67,
    cy: 30.02,
    r: 1.79,
    transform: "translate(-.64 7.37) rotate(-1.39)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 307.87,
    cy: 40.06,
    r: 1.74,
    transform: "translate(-2.55 34.97) rotate(-6.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 312.28,
    cy: 50.47,
    r: 1.69,
    transform: "translate(-3.83 38.63) rotate(-7.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 315.89,
    cy: 61.18,
    r: 1.64,
    transform: "translate(-5.82 55.46) rotate(-9.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 318.67,
    cy: 72.14,
    r: 1.59,
    transform: "translate(-8.06 73.62) rotate(-13.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 320.61,
    cy: 83.28,
    r: 1.54,
    transform: "translate(-10.55 91.1) rotate(-15.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 321.69,
    cy: 94.53,
    r: 1.49,
    transform: "translate(-13.38 106.82) rotate(-18.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 321.92,
    cy: 105.84,
    r: 1.43,
    transform: "translate(-16.57 121.86) rotate(-20.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.35,116.09c.57-.51,1.44-.46,1.95.11s.46,1.44-.11,1.95-1.44.46-1.95-.11-.46-1.44.11-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M318.88,127.33c.55-.49,1.39-.44,1.88.11s.44,1.39-.11,1.88c-.55.49-1.39.44-1.88-.11-.49-.55-.44-1.39.11-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M316.55,138.43c.53-.47,1.34-.43,1.81.1.47.53.43,1.34-.1,1.81s-1.34.43-1.81-.1c-.47-.53-.43-1.34.1-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.38,149.31c.51-.45,1.28-.41,1.74.1.45.51.41,1.28-.1,1.74-.51.45-1.28.41-1.74-.1s-.41-1.28.1-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309.38,159.9c.49-.43,1.23-.39,1.66.09s.39,1.23-.09,1.66-1.23.39-1.66-.09c-.43-.49-.39-1.23.09-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M304.57,170.16c.46-.41,1.18-.38,1.59.09s.38,1.18-.09,1.59-1.18.38-1.59-.09-.38-1.18.09-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.01,180.02c.44-.4,1.12-.36,1.52.08.4.44.36,1.12-.08,1.52s-1.12.36-1.52-.08-.36-1.12.08-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M292.71,189.43c.42-.38,1.07-.34,1.45.08.38.42.34,1.07-.08,1.45-.42.38-1.07.34-1.45-.08s-.34-1.07.08-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M285.73,198.33c.4-.36,1.02-.32,1.37.08s.32,1.02-.08,1.37-1.02.32-1.37-.08-.32-1.02.08-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.09,206.67c.38-.34.96-.31,1.3.07s.31.96-.07,1.3-.96.31-1.3-.07-.31-.96.07-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.83,214.39c.36-.32.91-.29,1.23.07s.29.91-.07,1.23-.91.29-1.23-.07c-.32-.36-.29-.91.07-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M261.01,221.46c.34-.3.86-.27,1.16.06.3.34.27.86-.06,1.16-.34.3-.86.27-1.16-.06s-.27-.86.06-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.67,227.82c.32-.28.8-.26,1.09.06s.26.8-.06,1.09-.8.26-1.09-.06c-.28-.32-.26-.8.06-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M241.87,233.44c.3-.26.75-.24,1.01.06s.24.75-.06,1.01-.75.24-1.01-.06c-.26-.3-.24-.75.06-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.68,238.28c.27-.25.7-.22.94.05.25.27.22.7-.05.94s-.7.22-.94-.05c-.25-.27-.22-.7.05-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M221.14,242.33c.25-.23.64-.2.87.05s.2.64-.05.87-.64.2-.87-.05-.2-.64.05-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M210.33,245.57c.23-.21.59-.19.8.04s.19.59-.04.8-.59.19-.8-.04-.19-.59.04-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M199.31,247.97c.21-.19.53-.17.72.04s.17.53-.04.72-.53.17-.72-.04-.17-.53.04-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.14,249.52c.19-.17.48-.15.65.04s.15.48-.04.65-.48.15-.65-.04-.15-.48.04-.65Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 177.16,
    cy: 250.52,
    r: 0.41,
    transform: "translate(-127.56 214.63) rotate(-48.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.62,250.04c.15-.13.37-.12.51.03s.12.37-.03.51-.37.12-.51-.03-.12-.37.03-.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 154.61,
    cy: 249.23,
    r: 0.31,
    transform: "translate(-132.7 190.29) rotate(-46.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.3,247.11c.11-.09.27-.09.36.02s.09.27-.02.36-.27.09-.36-.02-.09-.27.02-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M132.37,244.36c.08-.08.21-.07.29.02s.07.21-.02.29-.21.07-.29-.02-.07-.21.02-.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 121.8,
    cy: 240.88,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.41,
    cy: 236.44,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 101.38,
    cy: 231.22,
    r: 0.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 135.96,
    cy: 256.36,
    r: 4.52,
    transform: "translate(-145.25 327.97) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 124.29,
    cy: 252.97,
    r: 4.46,
    transform: "translate(-150.87 314.03) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.9,
    cy: 248.71,
    r: 4.41,
    transform: "translate(-155.42 299.71) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 101.88,
    cy: 243.58,
    r: 4.35,
    transform: "translate(-158.86 285.08) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 91.29,
    cy: 237.62,
    r: 4.3,
    transform: "translate(-163.25 235.09) rotate(-68.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 81.18,
    cy: 230.86,
    r: 4.24,
    transform: "translate(-24.15 9.97) rotate(-6.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 71.63,
    cy: 223.34,
    r: 4.19,
    transform: "translate(-157.33 274.2) rotate(-84.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 62.69,
    cy: 215.11,
    r: 4.13,
    transform: "translate(-161.36 217.01) rotate(-74.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 54.4,
    cy: 206.22,
    r: 4.08,
    transform: "translate(-158.84 202.5) rotate(-74.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 46.81,
    cy: 196.72,
    r: 4.02,
    transform: "translate(-155.22 188.22) rotate(-74.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 39.97,
    cy: 186.67,
    r: 3.97,
    transform: "translate(-149.38 210.94) rotate(-85.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.91,
    cy: 176.13,
    r: 3.91,
    transform: "translate(-144.4 156.78) rotate(-72.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 28.68,
    cy: 165.16,
    r: 3.86,
    transform: "translate(-138.03 147.64) rotate(-74.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 24.29,
    cy: 153.82,
    r: 3.8,
    transform: "translate(-130.54 137.13) rotate(-74.87)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.79,
    cy: 142.18,
    r: 3.75,
    transform: "translate(-122.23 156.04) rotate(-87.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 18.19,
    cy: 130.31,
    r: 3.69,
    transform: "translate(-112.33 113.74) rotate(-74.82)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 16.51,
    cy: 118.27,
    r: 3.64,
    transform: "translate(-99.29 89.13) rotate(-67.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.61,104.44c.93-1.74,3.11-2.4,4.85-1.46,1.74.93,2.4,3.11,1.46,4.85-.93,1.74-3.11,2.4-4.85,1.46s-2.4-3.11-1.46-4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.85,92.31c.92-1.72,3.06-2.36,4.77-1.44,1.72.92,2.36,3.06,1.44,4.77-.92,1.72-3.06,2.36-4.77,1.44-1.72-.92-2.36-3.06-1.44-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.03,80.23c.91-1.69,3.01-2.32,4.7-1.42,1.69.91,2.32,3.01,1.42,4.7-.91,1.69-3.01,2.32-4.7,1.42s-2.32-3.01-1.42-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16.12,68.28c.89-1.66,2.96-2.29,4.62-1.4,1.66.89,2.29,2.96,1.4,4.62-.89,1.66-2.96,2.29-4.62,1.4-1.66-.89-2.29-2.96-1.4-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.12,56.51c.88-1.64,2.91-2.25,4.55-1.37,1.64.88,2.25,2.91,1.37,4.55s-2.91,2.25-4.55,1.37c-1.64-.88-2.25-2.91-1.37-4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23,45c.86-1.61,2.87-2.21,4.48-1.35,1.61.86,2.21,2.87,1.35,4.48-.86,1.61-2.87,2.21-4.48,1.35-1.61-.86-2.21-2.87-1.35-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.74,33.81c.85-1.58,2.82-2.18,4.4-1.33s2.18,2.82,1.33,4.4c-.85,1.58-2.82,2.18-4.4,1.33-1.58-.85-2.18-2.82-1.33-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.34,23.02c.83-1.56,2.77-2.14,4.33-1.31,1.56.83,2.14,2.77,1.31,4.33-.83,1.56-2.77,2.14-4.33,1.31-1.56-.83-2.14-2.77-1.31-4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.75,12.69c.82-1.53,2.72-2.1,4.25-1.28,1.53.82,2.1,2.72,1.28,4.25-.82,1.53-2.72,2.1-4.25,1.28-1.53-.82-2.1-2.72-1.28-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.95,2.88c.81-1.5,2.68-2.07,4.18-1.26,1.5.81,2.07,2.68,1.26,4.18-.81,1.5-2.68,2.07-4.18,1.26-1.5-.81-2.07-2.68-1.26-4.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 294.45,
    cy: -1.34,
    r: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 302.04,
    cy: 8.16,
    r: 1.76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 308.88,
    cy: 18.21,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 314.93,
    cy: 28.75,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 320.17,
    cy: 39.72,
    r: 1.6,
    transform: "translate(36.09 192.64) rotate(-35.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 324.55,
    cy: 51.06,
    r: 1.54,
    transform: "translate(44.6 223.02) rotate(-40.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.74,62c.39-.72,1.29-1,2.01-.61.72.39,1,1.29.61,2.01s-1.29,1-2.01.61c-.72-.39-1-1.29-.61-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M329.39,73.9c.37-.7,1.24-.96,1.94-.59.7.37.96,1.24.59,1.94s-1.24.96-1.94.59c-.7-.37-.96-1.24-.59-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.12,85.96c.36-.67,1.19-.92,1.86-.56.67.36.92,1.19.56,1.86-.36.67-1.19.92-1.86.56-.67-.36-.92-1.19-.56-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.91,98.12c.35-.64,1.15-.89,1.79-.54.64.35.89,1.15.54,1.79s-1.15.89-1.79.54-.89-1.15-.54-1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.76,110.3c.33-.62,1.1-.85,1.72-.52s.85,1.1.52,1.72-1.1.85-1.72.52-.85-1.1-.52-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M330.69,122.43c.32-.59,1.05-.81,1.64-.5.59.32.81,1.05.5,1.64s-1.05.81-1.64.5-.81-1.05-.5-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.68,134.44c.3-.56,1-.77,1.57-.47.56.3.77,1,.47,1.57-.3.56-1,.77-1.57.47-.56-.3-.77-1-.47-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.79,146.26c.29-.54.96-.74,1.49-.45s.74.96.45,1.49c-.29.54-.96.74-1.49.45s-.74-.96-.45-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M322,157.82c.27-.51.91-.7,1.42-.43.51.27.7.91.43,1.42-.27.51-.91.7-1.42.43s-.7-.91-.43-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M317.35,169.06c.26-.48.86-.66,1.34-.41.48.26.66.86.41,1.34s-.86.66-1.34.41-.66-.86-.41-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.85,179.9c.24-.46.81-.63,1.27-.38.46.24.63.81.38,1.27-.24.46-.81.63-1.27.38-.46-.24-.63-.81-.38-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M305.53,190.29c.23-.43.76-.59,1.19-.36s.59.76.36,1.19c-.23.43-.76.59-1.19.36s-.59-.76-.36-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M298.43,200.15c.22-.4.72-.55,1.12-.34s.55.72.34,1.12-.72.55-1.12.34-.55-.72-.34-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.6,209.43c.2-.38.67-.52,1.04-.32s.52.67.32,1.04-.67.52-1.04.32-.52-.67-.32-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M282.08,218.07c.19-.35.62-.48.97-.29.35.19.48.62.29.97s-.62.48-.97.29-.48-.62-.29-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M272.93,226.04c.17-.32.57-.44.9-.27s.44.57.27.9-.57.44-.9.27-.44-.57-.27-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.19,233.29c.16-.29.53-.41.82-.25s.41.53.25.82-.53.41-.82.25c-.29-.16-.41-.53-.25-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M252.94,239.76c.14-.27.48-.37.75-.23s.37.48.23.75-.48.37-.75.23-.37-.48-.23-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.22,245.44c.13-.24.43-.33.67-.2s.33.43.2.67-.43.33-.67.2-.33-.43-.2-.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 231.5,
    cy: 250.48,
    r: 0.44,
    transform: "translate(-93.86 352.84) rotate(-64.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M219.66,254.25c.1-.19.33-.26.52-.16s.26.33.16.52-.33.26-.52.16-.26-.33-.16-.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 102.81,
    cy: 256.81,
    r: 4.44,
    transform: "translate(-165.68 323.42) rotate(-82.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 91.16,
    cy: 250.87,
    r: 4.38,
    transform: "translate(-169.8 306.99) rotate(-82.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 80,
    cy: 244.07,
    r: 4.32,
    transform: "translate(-172.65 290.27) rotate(-82.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 69.39,
    cy: 236.43,
    r: 4.27,
    transform: "translate(-173.88 275.58) rotate(-82.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 59.4,
    cy: 228,
    r: 4.21,
    transform: "translate(-174.11 196.61) rotate(-67.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.07,
    cy: 218.84,
    r: 4.15,
    transform: "translate(-173.48 239.4) rotate(-82.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 41.47,
    cy: 209,
    r: 4.09,
    transform: "translate(-170.21 184.71) rotate(-72.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.65,
    cy: 198.53,
    r: 4.03,
    transform: "translate(-159.12 140.37) rotate(-63.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 26.66,
    cy: 187.49,
    r: 3.97,
    transform: "translate(-159.94 155.22) rotate(-72.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.53,
    cy: 175.94,
    r: 3.91,
    transform: "translate(-155.51 156.3) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11.51,163.4c.3-2.11,2.26-3.57,4.36-3.26s3.57,2.26,3.26,4.36c-.3,2.11-2.26,3.57-4.36,3.26-2.1-.3-3.57-2.26-3.26-4.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M7.29,151.06c.3-2.07,2.22-3.51,4.29-3.21,2.07.3,3.51,2.22,3.21,4.29-.3,2.07-2.22,3.51-4.29,3.21-2.07-.3-3.51-2.22-3.21-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.04,138.42c.29-2.04,2.19-3.46,4.23-3.16,2.04.29,3.46,2.19,3.16,4.23-.29,2.04-2.19,3.46-4.23,3.16-2.04-.29-3.46-2.19-3.16-4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1.76,125.57c.29-2.01,2.15-3.4,4.16-3.11,2.01.29,3.4,2.15,3.11,4.16-.29,2.01-2.15,3.4-4.16,3.11s-3.4-2.15-3.11-4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.46,112.58c.28-1.98,2.12-3.35,4.09-3.06s3.35,2.12,3.06,4.09c-.28,1.98-2.12,3.35-4.09,3.06-1.98-.28-3.35-2.12-3.06-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.14,99.52c.28-1.94,2.08-3.29,4.03-3.01s3.29,2.08,3.01,4.03c-.28,1.94-2.08,3.29-4.03,3.01-1.94-.28-3.29-2.08-3.01-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.83,86.48c.28-1.91,2.05-3.24,3.96-2.96s3.24,2.05,2.96,3.96c-.28,1.91-2.05,3.24-3.96,2.96-1.91-.28-3.24-2.05-2.96-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2.51,73.51c.27-1.88,2.01-3.18,3.89-2.91,1.88.27,3.18,2.01,2.91,3.89s-2.01,3.18-3.89,2.91c-1.88-.27-3.18-2.01-2.91-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5.19,60.72c.27-1.85,1.98-3.13,3.82-2.86,1.85.27,3.13,1.98,2.86,3.82-.27,1.85-1.98,3.13-3.82,2.86-1.85-.27-3.13-1.98-2.86-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.86,48.16c.26-1.81,1.94-3.07,3.76-2.81,1.81.26,3.07,1.94,2.81,3.76-.26,1.81-1.94,3.07-3.76,2.81-1.81-.26-3.07-1.94-2.81-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.47,35.92c.26-1.78,1.91-3.02,3.69-2.76,1.78.26,3.02,1.91,2.76,3.69-.26,1.78-1.91,3.02-3.69,2.76-1.78-.26-3.02-1.91-2.76-3.69Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 22.19,
    cy: 24.52,
    r: 3.2,
    transform: "translate(-6.52 40.93) rotate(-77.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.45,12.66c.25-1.72,1.84-2.91,3.56-2.66s2.91,1.84,2.66,3.56c-.25,1.72-1.84,2.91-3.56,2.66-1.72-.25-2.91-1.84-2.66-3.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 35.79,
    cy: 2.22,
    r: 3.08,
    transform: "translate(26.85 36.95) rotate(-79.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.31,4.99c.13-.87.94-1.48,1.81-1.36s1.48.94,1.36,1.81-.94,1.48-1.81,1.36-1.48-.94-1.36-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M320.36,16.04c.12-.84.9-1.43,1.74-1.3s1.43.9,1.3,1.74c-.12.84-.9,1.43-1.74,1.3s-1.43-.9-1.3-1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.54,27.6c.12-.81.87-1.37,1.68-1.25s1.37.87,1.25,1.68c-.12.81-.87,1.37-1.68,1.25s-1.37-.87-1.25-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.81,39.59c.11-.78.83-1.32,1.61-1.2s1.32.83,1.2,1.61-.83,1.32-1.61,1.2-1.32-.83-1.2-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M336.15,51.95c.11-.74.8-1.26,1.54-1.15.74.11,1.26.8,1.15,1.54s-.8,1.26-1.54,1.15c-.74-.11-1.26-.8-1.15-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.52,64.61c.1-.71.76-1.21,1.48-1.1s1.21.76,1.1,1.48c-.1.71-.76,1.21-1.48,1.1-.71-.1-1.21-.76-1.1-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.91,77.47c.1-.68.73-1.15,1.41-1.05.68.1,1.15.73,1.05,1.41-.1.68-.73,1.15-1.41,1.05-.68-.1-1.15-.73-1.05-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.33,90.48c.09-.65.69-1.1,1.34-1s1.1.69,1,1.34-.69,1.1-1.34,1-1.1-.69-1-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.76,103.56c.09-.62.66-1.04,1.27-.95.62.09,1.04.66.95,1.27s-.66,1.04-1.27.95-1.04-.66-.95-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343.19,116.62c.08-.58.62-.99,1.21-.9.58.08.99.62.9,1.21s-.62.99-1.21.9-.99-.62-.9-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.62,129.6c.08-.55.59-.93,1.14-.85s.93.59.85,1.14c-.08.55-.59.93-1.14.85s-.93-.59-.85-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M339.05,142.42c.07-.52.56-.88,1.07-.8s.88.56.8,1.07-.56.88-1.07.8-.88-.56-.8-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335.51,154.99c.07-.49.52-.82,1.01-.75s.82.52.75,1.01-.52.82-1.01.75-.82-.52-.75-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M331.01,167.25c.07-.45.49-.77.94-.7s.77.49.7.94-.49.77-.94.7-.77-.49-.7-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325.58,179.12c.06-.42.45-.71.87-.65s.71.45.65.87c-.06.42-.45.71-.87.65s-.71-.45-.65-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.26,190.54c.06-.39.42-.66.81-.6s.66.42.6.81-.42.66-.81.6-.66-.42-.6-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.09,201.43c.05-.36.38-.6.74-.55s.6.38.55.74-.38.6-.74.55-.6-.38-.55-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M304.11,211.75c.05-.32.35-.55.67-.5s.55.35.5.67c-.05.32-.35.55-.67.5s-.55-.35-.5-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.37,221.43c.04-.29.31-.49.6-.45s.49.31.45.6-.31.49-.6.45-.49-.31-.45-.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 286.39,
    cy: 230.47,
    r: 0.47,
    transform: "translate(12.61 475.78) rotate(-80.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.81,238.63c.03-.23.24-.38.47-.35s.38.24.35.47-.24.38-.47.35-.38-.24-.35-.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 265.45,
    cy: 246.1,
    r: 0.36,
    transform: "translate(-19.45 469.39) rotate(-80.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.86,252.62c.02-.16.17-.27.34-.25s.27.17.25.34-.17.27-.34.25-.27-.17-.25-.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.13,
    cy: 258.44,
    r: 4.4,
    transform: "translate(-191.11 253.46) rotate(-71.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 67.37,
    cy: 250.73,
    r: 4.33,
    transform: "translate(-181.9 178.14) rotate(-58.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.24,
    cy: 242.15,
    r: 4.27,
    transform: "translate(-191.35 219.92) rotate(-71.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 45.81,
    cy: 232.73,
    r: 4.2,
    transform: "translate(-189.55 262.23) rotate(-86.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M32.08,223.39c-.47-2.24.97-4.43,3.21-4.9,2.24-.47,4.43.97,4.9,3.21.47,2.24-.97,4.43-3.21,4.9-2.24.47-4.43-.97-4.9-3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M23.28,212.46c-.46-2.2.95-4.36,3.16-4.82,2.2-.46,4.36.95,4.82,3.16s-.95,4.36-3.16,4.82-4.36-.95-4.82-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.34,200.89c-.45-2.17.94-4.3,3.11-4.75,2.17-.45,4.3.94,4.75,3.11.45,2.17-.94,4.3-3.11,4.75-2.17.45-4.3-.94-4.75-3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.31,188.75c-.45-2.14.92-4.23,3.06-4.67,2.14-.45,4.23.92,4.67,3.06.45,2.14-.92,4.23-3.06,4.67-2.14.45-4.23-.92-4.67-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2.22,176.1c-.44-2.1.91-4.16,3.01-4.6,2.1-.44,4.16.91,4.6,3.01s-.91,4.16-3.01,4.6c-2.1.44-4.16-.91-4.6-3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-2.9,163.02c-.43-2.07.89-4.09,2.96-4.52,2.07-.43,4.09.89,4.52,2.96.43,2.07-.89,4.09-2.96,4.52-2.07.43-4.09-.89-4.52-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-7.01,149.58c-.42-2.03.88-4.02,2.91-4.45s4.02.88,4.45,2.91c.42,2.03-.88,4.02-2.91,4.45s-4.02-.88-4.45-2.91Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: -2.66,
    cy: 51.59,
    r: 3.31,
    transform: "translate(-54.01 45.92) rotate(-86.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-1.51,38.88c-.37-1.76.76-3.48,2.52-3.84s3.48.76,3.84,2.52c.37,1.76-.76,3.48-2.52,3.84-1.76.37-3.48-.76-3.84-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.88,25.87c-.36-1.72.74-3.41,2.47-3.77,1.72-.36,3.41.74,3.77,2.47.36,1.72-.74,3.41-2.47,3.77-1.72.36-3.41-.74-3.77-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.26,13.29c-.35-1.69.73-3.34,2.42-3.69s3.34.73,3.69,2.42c.35,1.69-.73,3.34-2.42,3.69s-3.34-.73-3.69-2.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.56,
    cy: 0.61,
    r: 3.06,
    transform: "translate(17.74 20.99) rotate(-83.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M327.17,2.93c-.16-.76.33-1.5,1.09-1.66s1.5.33,1.66,1.09c.16.76-.33,1.5-1.09,1.66-.76.16-1.5-.33-1.66-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M334.32,15.05c-.15-.72.31-1.43,1.04-1.58.72-.15,1.43.31,1.58,1.04s-.31,1.43-1.04,1.58-1.43-.31-1.58-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.54,27.67c-.14-.69.3-1.36.99-1.51.69-.14,1.36.3,1.51.99s-.3,1.36-.99,1.51c-.69.14-1.36-.3-1.51-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.78,40.73c-.14-.65.28-1.3.94-1.43.65-.14,1.3.28,1.43.94s-.28,1.3-.94,1.43-1.3-.28-1.43-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350.01,54.14c-.13-.62.27-1.23.89-1.36s1.23.27,1.36.89-.27,1.23-.89,1.36-1.23-.27-1.36-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353.2,67.83c-.12-.59.25-1.16.84-1.28.59-.12,1.16.25,1.28.84.12.59-.25,1.16-.84,1.28-.59.12-1.16-.25-1.28-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.32,81.72c-.12-.55.24-1.09.79-1.21s1.09.24,1.21.79-.24,1.09-.79,1.21-1.09-.24-1.21-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.36,95.73c-.11-.52.22-1.02.74-1.13s1.02.22,1.13.74-.22,1.02-.74,1.13-1.02-.22-1.13-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M356.32,109.77c-.1-.48.21-.95.69-1.06s.95.21,1.06.69c.1.48-.21.95-.69,1.06s-.95-.21-1.06-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.2,123.76c-.09-.45.19-.89.64-.98s.89.19.98.64-.19.89-.64.98c-.45.09-.89-.19-.98-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353.01,137.62c-.09-.41.18-.82.59-.9s.82.18.9.59-.18.82-.59.9c-.41.09-.82-.18-.9-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.78,151.27c-.08-.38.16-.75.54-.83s.75.16.83.54-.16.75-.54.83-.75-.16-.83-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.51,164.63c-.07-.34.15-.68.49-.75s.68.15.75.49-.15.68-.49.75-.68-.15-.75-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M340.23,177.62c-.06-.31.13-.61.44-.68s.61.13.68.44-.13.61-.44.68-.61-.13-.68-.44Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 334.49,
    cy: 190.06,
    r: 0.51,
    transform: "translate(-20.46 41.68) rotate(-6.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M326.8,202.19c-.05-.24.1-.48.35-.53s.48.1.53.35-.1.48-.35.53-.48-.1-.53-.35Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 319.08,
    cy: 213.55,
    r: 0.38,
    transform: "translate(-26.59 46.44) rotate(-7.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M309.76,224.4c-.04-.17.07-.34.25-.38s.34.07.38.25-.07.34-.25.38-.34-.07-.38-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M300.01,234.45c-.03-.14.06-.27.2-.3s.27.06.3.2-.06.27-.2.3-.27-.06-.3-.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 289.7,
    cy: 243.67,
    r: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 278.46,
    cy: 252.11,
    r: 0.13
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 315.17,
    cy: 238.05,
    r: 5.62,
    transform: "translate(9.45 488.12) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 304.26,
    cy: 248.51,
    r: 5.55,
    transform: "translate(-9.05 485.51) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 292.59,
    cy: 258.12,
    r: 5.48,
    transform: "translate(-27.3 481.51) rotate(-76.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.74,259.86c-1.26-2.03-.63-4.69,1.39-5.94,2.03-1.26,4.69-.63,5.94,1.39,1.26,2.03.63,4.69-1.39,5.94s-4.69.63-5.94-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.17,250.17c-1.24-1.99-.62-4.61,1.37-5.85s4.61-.62,5.85,1.37c1.24,1.99.62,4.61-1.37,5.85s-4.61.62-5.85-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.36,239.63c-1.22-1.96-.61-4.54,1.35-5.75s4.54-.61,5.75,1.35c1.22,1.96.61,4.54-1.35,5.75s-4.54.61-5.75-1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.38,228.3c-1.2-1.93-.6-4.46,1.33-5.66,1.93-1.2,4.46-.6,5.66,1.33,1.2,1.93.6,4.46-1.33,5.66-1.93,1.2-4.46.6-5.66-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.29,216.23c-1.18-1.9-.59-4.39,1.31-5.56,1.9-1.18,4.39-.59,5.56,1.31,1.18,1.9.59,4.39-1.31,5.56s-4.39.59-5.56-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.15,203.5c-1.16-1.86-.58-4.31,1.28-5.47,1.86-1.16,4.31-.58,5.47,1.28,1.16,1.86.58,4.31-1.28,5.47-1.86,1.16-4.31.58-5.47-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-6.99,190.17c-1.14-1.83-.57-4.24,1.26-5.38,1.83-1.14,4.24-.57,5.38,1.26,1.14,1.83.57,4.24-1.26,5.38-1.83,1.14-4.24.57-5.38-1.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.99,
    cy: -0.24,
    r: 3.01,
    transform: "translate(3.63 3.74) rotate(-81.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.18,1.15c-.34-.55-.17-1.26.38-1.6s1.26-.17,1.6.38.17,1.26-.38,1.6-1.26.17-1.6-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.43,14.41c-.32-.51-.16-1.19.35-1.51.51-.32,1.19-.16,1.51.35s.16,1.19-.35,1.51-1.19.16-1.51-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.64,28.18c-.3-.48-.15-1.12.33-1.41s1.12-.15,1.41.33c.3.48.15,1.12-.33,1.41s-1.12.15-1.41-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M360.76,42.38c-.28-.45-.14-1.04.31-1.32s1.04-.14,1.32.31c.28.45.14,1.04-.31,1.32s-1.04.14-1.32-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.77,56.93c-.26-.42-.13-.97.29-1.23.42-.26.97-.13,1.23.29.26.42.13.97-.29,1.23s-.97.13-1.23-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.66,71.74c-.24-.39-.12-.89.27-1.13s.89-.12,1.13.27.12.89-.27,1.13-.89.12-1.13-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M369.41,86.72c-.22-.35-.11-.82.24-1.04.35-.22.82-.11,1.04.24s.11.82-.24,1.04-.82.11-1.04-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370.01,101.79c-.2-.32-.1-.74.22-.94s.74-.1.94.22c.2.32.1.74-.22.94s-.74.1-.94-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M369.46,116.85c-.18-.29-.09-.67.2-.85s.67-.09.85.2.09.67-.2.85-.67.09-.85-.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 368.23,
    cy: 131.54,
    r: 0.55,
    transform: "translate(-21.37 164.88) rotate(-24.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M364.92,146.62c-.14-.23-.07-.52.15-.66s.52-.07.66.15.07.52-.15.66-.52.07-.66-.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 361.3,
    cy: 160.94,
    r: 0.41,
    transform: "translate(-33.9 176.85) rotate(-26.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355.87,175.33c-.1-.16-.05-.37.11-.47s.37-.05.47.11.05.37-.11.47-.37.05-.47-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M349.72,189.07c-.08-.13-.04-.3.09-.38s.3-.04.38.09.04.3-.09.38-.3.04-.38-.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 342.69,
    cy: 202.18,
    r: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 334.43,
    cy: 214.84,
    r: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 325.23,
    cy: 226.83,
    r: 0.07
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 50.99,
    y: 9.66,
    width: 123.68,
    height: 268.12,
    rx: 61.84,
    ry: 61.84,
    transform: "translate(134.67 -37.69) rotate(45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 151.51,
    cy: 82.31,
    r: 26.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.13,78.97c-1.52,0-2.48.99-2.78,2.3h5.41c-.18-1.45-1.2-2.3-2.62-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.68,79.54c-1.93,0-3.15,1.33-3.15,3.2s1.24,3.22,3.15,3.22,3.2-1.31,3.2-3.22-1.29-3.2-3.2-3.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.7,76.48c-2.9,0-5.16,1.16-5.53,4.17-.03,0,.02,0,0,0-.91-13.64-11.67-24.42-25.54-24.42-10.96,0-20.34,6.74-24.24,16.29h9.29l-.48,3.13h-7.29v3.31h6.6l-.51,3.01h-6.1v1.93c0,1.17.51,1.73,1.47,1.73h6.23l-.51,3.13h-6.9c-.34,0-.66-.03-.96-.09h0s-1.2-.13-1.93-1.09c-.02-.02-.32-.38-.47-.97-.04-.15-.04-.16-.07-.28.05.39.13.91.17,1.11.21,1.09.48,2.02.5,2.08,3.1,11,13.2,19.07,25.19,19.07s22.63-8.44,25.47-19.82h-3.52v-6.4c0-1.73-.67-2.83-2.37-2.83s-2.37,1.1-2.37,2.83v6.4h-3.52v-7.27c0-3.47,2.53-5.02,5.89-5.02s5.89,1.54,5.89,5.02v7.27s3.54,0,3.54,0v-6.4c0-1.73.46-2.83,2.14-2.83.53,0,1.17.16,1.4.28l.67-3.08c-.39-.05-1.38-.25-2.14-.25M150.42,82.03c0,4.39-2.6,6.97-6.9,6.97-3.98,0-6.67-2.67-6.67-6.26s2.55-6.26,6.37-6.26c1.75,0,3.04.69,3.68,1.38v-5.34h3.52v9.5h0ZM159.3,86.35c1.04,0,1.99-.3,2.89-.71l-.29,2.78c-1.01.41-2.23.57-3.45.57-4.05,0-6.9-2.37-6.9-6.4,0-3.5,2.55-6.12,6.46-6.12,4.42,0,6.63,2.81,6.53,7.13h-9.11c.35,1.98,2.23,2.74,3.87,2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.68,76.48c-3.91,0-6.46,2.62-6.46,6.12,0,4.03,2.85,6.4,6.9,6.4,1.22,0,2.44-.16,3.45-.58l.29-2.78c-.9.41-1.86.71-2.89.71-1.63,0-3.52-.76-3.87-2.74h9.11c.09-4.33-2.12-7.13-6.53-7.13M188.01,81.27c.3-1.31,1.27-2.3,2.78-2.3,1.43,0,2.44.85,2.62,2.3h-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M207.66,72.53v5.34c-.64-.69-1.93-1.38-3.68-1.38-3.82,0-6.37,2.51-6.37,6.26s2.69,6.26,6.67,6.26c4.3,0,6.9-2.58,6.9-6.97v-9.5h-3.52ZM204.44,85.96c-1.91,0-3.15-1.38-3.15-3.22s1.22-3.2,3.15-3.2,3.2,1.29,3.2,3.2-1.29,3.22-3.2,3.22"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.c052fe224d2605eaeea4c2b4f474ca39.svg";
export { ForwardRef as ReactComponent };